import { Component, OnInit, OnDestroy, ChangeDetectorRef, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../shared/common.service';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { FoldersDataService, Folder, Form, Field } from '../folders/folders-data.service';
import { ApiService } from '../../api.service';
import { Location } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { forkJoin, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

type AttachmentPayload = {
  name: string;
  type: string;
  size: number;
  content: string;
};

type ExistingAttachment = {
  name: string;
  url: string | null;
  documentLink: string | null;
  uploadedAt?: string;
  fieldId: string;
  recordId?: number;
};
@Component({
  selector: 'app-study-template',
  templateUrl: './study-template.component.html',
  styleUrls: ['./study-template.component.scss', './layout-fixes.scss']
})
export class StudyTemplateComponent implements OnInit, OnDestroy {
  template_id: string;
  study_id: string;
  study_crc_id: string; // This is the correct ID for backend API calls
  subject_id: string;
  study_name: string;
  template_name: string;
  
  reviewModalPosition: any = { top: '60px', right: '70px' };
  hasCustomReviewPosition = false;
  // Study-related properties for display
  studyCode: string = 'N/A';
  subjectName: string = 'N/A';
  participantId: string = 'N/A';
  siteLocation: string = 'Unknown Location';
  template: any;
  loading: boolean = false;
  selectedFolder: string | null = null;
  selectedForm: string | null = null;
  selectedFolderId: string | null = null;
  isSidebarVisible: boolean = true;
  currentForm: any = null;
  form!: FormGroup;
  fields: any[] = [];
  table_rows: any = [];
  SelectedDropdownValue: string = '';

  // Query, Edit Reason, and Review functionality properties
  tabs = [
    { title: 'Query', type: 'query' },
    { title: 'Field History', type: 'fieldHistory' }
  ];
  fieldHistoryData: any[] = [];
  // If Age is provided by backend, do not auto-recalculate from DOB.
  private fixedAgeFromBackend: { fieldName: string; value: any } | null = null;
  selectedTab = 0;
  isOptionsModalOpen = false;
  isModalOpen = false;
  isReasonModalOpen = false;
  showReviewModal = false;
  showPiCheckModal = false;
  pendingPiCheckValue: boolean = false;
  piCheckEmail: string = '';
  piCheckPassword: string = '';
  piCheckComment: string = '';
  piCheckError: string = '';
  piCheckVerifying: boolean = false;
  piCheckConfirmationAccepted: boolean = false;

  // Review Monitor (authenticated monitor review)
  showMonitorReviewModal: boolean = false;
  monitorReviewStep: number = 1;
  monitorReviewConfirmationAccepted: boolean = false;
  monitorReviewEmail: string = '';
  monitorReviewPassword: string = '';
  monitorReviewReason: string = '';
  monitorReviewError: string = '';
  monitorReviewVerifying: boolean = false;
  showMonitorReviewPassword: boolean = false;

  monitorReviewFolderId: any = '';
  monitorReviewFormId: any = '';
  monitorReviewFieldId: any = '';
  monitorReviewAvailableFolders: any[] = [];
  monitorReviewAvailableForms: any[] = [];
  monitorReviewAvailableFields: any[] = [];
  monitorReviewFolderCheckboxes: { [key: string]: boolean } = {};
  monitorReviewFormCheckboxes: { [key: string]: boolean } = {};
  monitorReviewFieldCheckboxes: { [key: string]: boolean } = {};

  showMonitorReviewFolderDropdown: boolean = false;
  showMonitorReviewFormDropdown: boolean = false;
  showMonitorReviewFieldDropdown: boolean = false;

  // Review Data Manager (authenticated data manager review)
  showDataManagerReviewModal: boolean = false;
  dataManagerReviewStep: number = 1;
  dataManagerReviewConfirmationAccepted: boolean = false;
  dataManagerReviewEmail: string = '';
  dataManagerReviewPassword: string = '';
  dataManagerReviewReason: string = '';
  dataManagerReviewError: string = '';
  dataManagerReviewVerifying: boolean = false;
  showDataManagerReviewPassword: boolean = false;

  dataManagerReviewFolderId: any = '';
  dataManagerReviewFormId: any = '';
  dataManagerReviewFieldId: any = '';
  dataManagerReviewAvailableFolders: any[] = [];
  dataManagerReviewAvailableForms: any[] = [];
  dataManagerReviewAvailableFields: any[] = [];
  dataManagerReviewFolderCheckboxes: { [key: string]: boolean } = {};
  dataManagerReviewFormCheckboxes: { [key: string]: boolean } = {};
  dataManagerReviewFieldCheckboxes: { [key: string]: boolean } = {};

  showDataManagerReviewFolderDropdown: boolean = false;
  showDataManagerReviewFormDropdown: boolean = false;
  showDataManagerReviewFieldDropdown: boolean = false;
  fieldLabel: string = '';
  selectedOptionsFieldId: string | null = null;
  editReason: string = '';
  
  
  reviewOptions = {
    dataManager: false,
    monitor: false,
    pi: false
  };
// Add query type to include queryId
queries: {
  threadId: string;
  text: string;
  isClosed: boolean;
  isSubmitted?: boolean;
  queryId?: number;
  createdBy?: string | number; // User ID who created the query
  auditTrail: { user: string; role?: string; timestamp: string; message: string }[];
}[] = [
  { threadId: this.generateThreadId(), text: '', isClosed: false, isSubmitted: false, queryId: 0, auditTrail: [] }
];

nextLocalQueryId = 0;

  // Track query status per field (fieldName or fieldName__row__rowIndex for table rows)
  // 'open' = has open queries, 'closed' = all queries closed, undefined = no queries
  fieldQueryStatus: { [key: string]: 'open' | 'closed' | 'answered' } = {};

  // Track review status per field (fieldName or fieldName__row__rowIndex for table rows)
  fieldReviewStatus: { [key: string]: {
    monitor_reviewed: boolean;
    monitor_reviewed_by: string | null;
    monitor_review_time: string | null;
    data_manager_reviewed: boolean;
    data_manager_reviewed_by: string | null;
    data_manager_review_time: string | null;
    pi_check: boolean;
    pi_reviewed_by: string | null;
    pi_review_time: string | null;
    pi_comment: string | null;
  } } = {};

  // Track selected files per field when attachments are enabled
  selectedFiles: { [key: string]: File[] } = {};
  existingAttachments: { [key: string]: ExistingAttachment[] } = {};

  
  // Store dependency field information globally for cross-form dependencies
  dependencyFieldRegistry: { [key: string]: any } = {};
  
  // Global dependency tracking - stores all dependencies across forms
  globalDependencies: { [key: string]: any[] } = {};
  
  // Current form values cache for cross-form dependencies
  formValuesCache: { [key: string]: any } = {};

  // Track raised validation queries to prevent duplicates
  validationQueriesRaised: Set<string> = new Set();

  // Properties for managing comment fields
  commentFields: { [key: string]: any } = {};

  // Field lock status tracking (frontend-only)
  fieldLockStatus: { [key: string]: { isLocked: boolean; lockedAt?: string; lockedBy?: string } } = {};
  
  // Store submitted fields to track which ones should be locked
  submittedFields: string[] = [];

  // Freeze/Lock configuration properties (folder/form/field level)
  showFreezeModal: boolean = false;
  showLockModal: boolean = false;
  // When opening Freeze/Lock from a folder's kebab menu, we don't want a folder picker dropdown.
  freezeOpenedFromFolderMenu: boolean = false;
  lockOpenedFromFolderMenu: boolean = false;

  // Freeze state
  freezeStep: number = 1;
  isFreezing: boolean = true;
  freezeConfirmationAccepted: boolean = false;
  freezeEmail: string = '';
  freezePassword: string = '';
  freezeReason: string = '';
  freezeError: string = '';
  showFreezePassword: boolean = false;

  // Lock state
  lockStep: number = 1;
  lockConfirmationAccepted: boolean = false;
  lockEmail: string = '';
  lockPassword: string = '';
  lockReason: string = '';
  lockError: string = '';
  showLockPassword: boolean = false;

  // Target selection for freeze
  freezeFolderId: any = '';
  freezeFormId: any = '';
  freezeFieldId: any = '';
  freezeAvailableFolders: any[] = [];
  freezeAvailableForms: any[] = [];
  freezeAvailableFields: any[] = [];
  freezeFolderCheckboxes: { [key: string]: boolean } = {};
  freezeFormCheckboxes: { [key: string]: boolean } = {};
  freezeFieldCheckboxes: { [key: string]: boolean } = {};

  // Target selection for lock
  lockFolderId: any = '';
  lockFormId: any = '';
  lockFieldId: any = '';
  lockAvailableFolders: any[] = [];
  lockAvailableForms: any[] = [];
  lockAvailableFields: any[] = [];
  lockFolderCheckboxes: { [key: string]: boolean } = {};
  lockFormCheckboxes: { [key: string]: boolean } = {};
  lockFieldCheckboxes: { [key: string]: boolean } = {};

  // Dropdown visibility states
  showFreezeFolderDropdown: boolean = false;
  showFreezeFormDropdown: boolean = false;
  showFreezeFieldDropdown: boolean = false;
  showLockFolderDropdown: boolean = false;
  showLockFormDropdown: boolean = false;
  showLockFieldDropdown: boolean = false;

  // Target selection for PI Signature
  piSignatureFolderId: any = '';
  piSignatureFormId: any = '';
  piSignatureAvailableFolders: any[] = [];
  piSignatureAvailableForms: any[] = [];
  piSignatureFolderCheckboxes: { [key: string]: boolean } = {};
  piSignatureFormCheckboxes: { [key: string]: boolean } = {};

  // Dropdown visibility states for PI Signature
  showPiSignatureFolderDropdown: boolean = false;
  showPiSignatureFormDropdown: boolean = false;

  // Properties for field locking mechanism
  lockedFields: { [key: string]: boolean } = {};
  fieldEditReasons: { [key: string]: string } = {};
  isUnlockModalOpen = false;
  fieldToUnlock: string = '';
  unlockReason: string = '';

  // Statement input modal for fixed-rows-table
  isStatementModalOpen = false;
  statementModalFieldName: string = '';
  statementModalColumns: any[] = [];
  statementModalValues: { [key: string]: string } = {};

  // Table change tracking
  tableChangeTracker: { [key: string]: any } = {};
  
  // Track original table data to identify new vs existing rows
  originalTableData: { [key: string]: any[] } = {};
  // Track hash of form data loaded from backend to detect changes
  initialFormDataHash: string | null = null;
  
  // Debounce timers for table change tracking to avoid excessive formatting
  private tableChangeTimers: { [key: string]: any } = {};

  // Default folders from folders-data.service
  defaultFolders: Folder[] = [];
  formReviewStatus: { [formId: string]: { piSignatureReviewed: boolean; reviewOptions: any; piReviewedBy?: string; piReviewedAt?: string; piComment?: string } } = {};

  currentUser: { email: string, id: number, designation: string } | null = null;
  // formReviewStatus: { [formId: string]: { piSignatureReviewed: boolean; reviewOptions: any } } = {};
  userRole: string = "";
  currentRowIndex: number | null = null;
  currentRowId: number | null = null;
   /** The exact clicked field id for query/history/review modal (never derived by name). */
   selectedModalFieldId: string | null = null;
  showReviewInfoPopup: boolean = false;
  reviewInfo: { 
    monitorName: string; 
    monitorTime: string | null;
    dataManagerName: string;
    dataManagerTime: string | null;
  } = { 
    monitorName: 'Not done', 
    monitorTime: null,
    dataManagerName: 'Not done',
    dataManagerTime: null
  };

  // Validation options: Configure which field types should not accept negative values
  validationOptions = {
    preventNegativeFields: ['weight', 'height', 'waist', 'age', 'bmi'],
    autoCorrectToZero: true,
    showWarning: true
  };

isTableDisabled: boolean = false; // when form is submitted
editableRowIndex: number | null = null; // track which row is being edited
tableRowEditReasons: { [key: string]: { [rowIndex: number]: string } } = {};
pendingRowEdit: { fieldName: string; rowIndex: number } | null = null;
pendingRowEditDisplayLabel: string | null = null;

enableRowEdit(fieldName: string, rowIndex: number) {
  this.isOptionsModalOpen = false;
  this.showReviewModal = false; // Close review modal when options modal closes
  console.log("Field Name:", fieldName);
  console.log('Fields:', this.fields);
  const fieldDef = this.fields.find(f => f.name === fieldName);
  console.log("Field Def:", fieldDef);
  if (this.shouldBlockEditByLockFreeze(fieldDef)) {
    this.showLockFreezeMessage(this.getFieldLockFreezeStatus(fieldDef));
    return;
  }
  this.pendingRowEditDisplayLabel = fieldDef?.title
    ? `${fieldDef.title} (Row ${rowIndex + 1})`
    : `${fieldName} (Row ${rowIndex + 1})`;
  this.pendingRowEdit = { fieldName, rowIndex };
  this.editReason = '';
  this.isReasonModalOpen = true;
}

  // Cache for instruction image blob URLs to avoid refetching
  instructionImageBlobCache: { [url: string]: string } = {};

  // Inline style for the options 3-dots menu so it can appear near the mouse cursor
  optionsModalStyle: { [key: string]: string } = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    public commonService: CommonService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private foldersDataService: FoldersDataService,
    private apiService: ApiService,
    private cookieService: CookieService,
    private http: HttpClient
) { }

  ngOnInit(): void {
    try {
      const userDataStr = this.cookieService.get('userData');
      if (userDataStr) {
        this.currentUser = JSON.parse(userDataStr);
        if (this.currentUser) {
          this.userRole = this.currentUser.designation || '';
        }
      }
    } catch (error) {
      this.currentUser = null;
      this.userRole = '';
    }

    // Try to get data from query parameters first (from study-details)
    this.route.queryParamMap.subscribe(params => {
      if (params.keys.length > 0) {
        // Data comes from query parameters (study-details navigation)
        this.template_id = params.get('template_id') || '1';
        this.study_id = params.get('studyId') || '';
        this.study_name = params.get('study_name') || '';
        this.subject_id = params.get('subjectId') || '';
        this.study_crc_id = params.get('study_id') || ''; // Map study_id to study_crc_id
        
        // Debug logging
        // Get additional study information from query parameters
        const studyCode = params.get('study_code') || '';
        const siteLocation = params.get('site_location') || '';
        const subjectId = params.get('subject_id') || '';
        
        // Initialize study details with real data from study-details page
        this.mapStudyDetails({
          study_code: studyCode,
          study_name: this.study_name,
          subject_name: subjectId,
          site_location: siteLocation
        });

        // If template is already loaded, prefetch PI signature status so sidebar shows checkmarks
        if (this.template?.folders) {
          this.prefetchPiSignatureStatusForAllForms();
        }
      }
    });

    // Fallback to route parameters (for direct navigation with JSON data)
    this.route.params.subscribe(params => {
      if (params['data']) {
        try {
          const data = JSON.parse(params['data']);
          this.template_id = data.template_id;
          this.template_name = data.template_name;
          this.study_id = data.study_id;
          this.study_crc_id = data.study_crc_id;
          this.study_name = data.study_name;
        } catch (error) {
        }
      }
    });

    this.loadTemplate();
    // this.loadDefaultFolders();
  }

  private getLastOpenedFormStorageKey(): string | null {
    if (!this.template_id) {
      return null;
    }
    const studyId = this.study_id || 'unknown-study';
    const subjectId = this.subject_id || this.study_crc_id || 'unknown-subject';
    return `studyTemplate:lastForm:${this.template_id}:${studyId}:${subjectId}`;
  }

  private persistLastOpenedForm(form: any): void {
    const storageKey = this.getLastOpenedFormStorageKey();
    if (!storageKey || !form) {
      return;
    }
    const payload = {
      formId: form.id ?? null,
      formName: form.name ?? null,
      folderId: this.selectedFolderId ?? null,
      folderName: this.selectedFolder ?? null
    };
    try {
      localStorage.setItem(storageKey, JSON.stringify(payload));
    } catch (error) {
      console.warn('[STUDY-TEMPLATE] Failed to persist last opened form:', error);
    }
  }

  private reopenLastOpenedForm(): void {
    if (this.currentForm || !this.template?.folders) {
      return;
    }
    const storageKey = this.getLastOpenedFormStorageKey();
    if (!storageKey) {
      return;
    }
    let stored: any = null;
    try {
      const raw = localStorage.getItem(storageKey);
      stored = raw ? JSON.parse(raw) : null;
    } catch (error) {
      console.warn('[STUDY-TEMPLATE] Failed to read last opened form:', error);
      return;
    }
    if (!stored) {
      return;
    }

    const formId = stored.formId;
    const formName = stored.formName;
    let matchedForm: any = null;
    let matchedFolder: any = null;

    if (formId !== null && formId !== undefined) {
      const formIdStr = String(formId);
      for (const folder of this.template.folders) {
        if (!folder.forms) continue;
        const found = folder.forms.find((f: any) => String(f.id) === formIdStr);
        if (found) {
          matchedForm = found;
          matchedFolder = folder;
          break;
        }
      }
    }

    if (!matchedForm && formName) {
      for (const folder of this.template.folders) {
        if (!folder.forms) continue;
        const found = folder.forms.find((f: any) => f.name === formName);
        if (found) {
          matchedForm = found;
          matchedFolder = folder;
          break;
        }
      }
    }

    if (!matchedForm) {
      return;
    }

    if (matchedFolder) {
      this.selectedFolderId = matchedFolder.id;
      this.selectedFolder = matchedFolder.name;
    } else {
      this.selectedFolderId = stored.folderId ?? this.selectedFolderId;
      this.selectedFolder = stored.folderName ?? this.selectedFolder;
    }

    this.openForm(matchedForm);
  }

  loadTemplate() {
    this.loading = true;
    
    // Debug logging
    // Check if template_id is valid
    if (!this.template_id || this.template_id === 'null' || this.template_id === 'undefined') {
      this.router.navigate(['/study-list']);
      return;
    }
    
    // First try to get template from API
    this.apiService.getTemplateData(this.template_id).subscribe(
      (response) => {
        // CRITICAL: Log the raw response immediately
        console.log('🚨🚨🚨 [STUDY-TEMPLATE] RAW API RESPONSE RECEIVED 🚨🚨🚨');
        console.log('🚨 [STUDY-TEMPLATE] Full response object:', response);
        console.log('🚨 [STUDY-TEMPLATE] Response keys:', Object.keys(response || {}));
        console.log('🚨 [STUDY-TEMPLATE] Response template:', response.template);
        
        // Check if response has template and search for field 53318 immediately
        if (response && response.template) {
          const responseStr = JSON.stringify(response, null, 2);
          if (responseStr.includes('53318')) {
            console.log('🚨 [STUDY-TEMPLATE] ✅ FOUND 53318 IN RESPONSE STRING!');
          }
          if (responseStr.includes('instructionImages') || responseStr.includes('instruction_images')) {
            console.log('🚨 [STUDY-TEMPLATE] ✅ FOUND instructionImages IN RESPONSE STRING!');
          }
        }
        
        console.log('📥 [STUDY-TEMPLATE] Template data from API - Full response:', response);
        console.log('📥 [STUDY-TEMPLATE] Response template:', response.template);
        
        // Check specifically for field 53318 in the response
        console.log('📥 [STUDY-TEMPLATE] === SEARCHING FOR FIELD ID 53318 IN RESPONSE ===');
        let found53318 = false;
        const searchForField53318 = (obj: any, path: string = 'root'): void => {
          if (Array.isArray(obj)) {
            obj.forEach((item, idx) => searchForField53318(item, `${path}[${idx}]`));
          } else if (obj && typeof obj === 'object') {
            Object.keys(obj).forEach(key => {
              if (key === 'id' && (obj[key] === 53318 || obj[key] === '53318' || String(obj[key]) === '53318')) {
                found53318 = true;
                // console.log(`🚨🚨🚨 [STUDY-TEMPLATE] 🎯🎯🎯 FOUND FIELD 53318 at ${path} 🎯🎯🎯`);
                // console.log(`🚨 [STUDY-TEMPLATE] 🎯 Field 53318 complete object:`, JSON.stringify(obj, null, 2));
                // console.log(`🚨 [STUDY-TEMPLATE] 🎯 Field 53318 instructionImages:`, obj.instructionImages);
                // console.log(`🚨 [STUDY-TEMPLATE] 🎯 Field 53318 instructionImages type:`, typeof obj.instructionImages);
                // console.log(`🚨 [STUDY-TEMPLATE] 🎯 Field 53318 instructionImages is array:`, Array.isArray(obj.instructionImages));
                // console.log(`🚨 [STUDY-TEMPLATE] 🎯 Field 53318 type:`, obj.type);
                // console.log(`🚨 [STUDY-TEMPLATE] 🎯 Field 53318 name:`, obj.name);
                // console.log(`🚨 [STUDY-TEMPLATE] 🎯 Field 53318 title:`, obj.title);
              }
              if (key === 'instructionImages' || key === 'instruction_images') {
                console.log(`🚨 [STUDY-TEMPLATE] Found instructionImages property at ${path}.${key}:`, obj[key]);
                console.log(`🚨 [STUDY-TEMPLATE] instructionImages value:`, JSON.stringify(obj[key], null, 2));
              }
              searchForField53318(obj[key], `${path}.${key}`);
            });
          }
        };
        searchForField53318(response);
        if (!found53318) {
          console.warn('⚠️⚠️⚠️ [STUDY-TEMPLATE] FIELD 53318 NOT FOUND IN RESPONSE! ⚠️⚠️⚠️');
        }
        console.log('📥 [STUDY-TEMPLATE] === END SEARCHING FOR FIELD 53318 ===');
        
        this.template = response.template;
        if (!this.template) {
          this.router.navigate(['/study-template']);
          return;
        }
        
        // Initialize folders array if it doesn't exist
        if (!this.template.folders) {
          this.ensureDefaultFoldersExist();
        }

        // Add default folders if they don't exist

        // Only initialize with default values if no real data was passed from query parameters
        if (!this.studyCode || this.studyCode === 'N/A') {
          this.mapStudyDetails({
            study_code: this.study_id,
            study_name: this.study_name,
            subject_name: 'Subject-001', // Default subject name
            site_location: 'Main Site'   // Default site location
          });
        }

        this.loading = false;
        this.prefetchPiSignatureStatusForAllForms();
        this.reopenLastOpenedForm();
        this.fetchParticipantIdIfNeeded();
      },
      (error) => {
        // Fallback to localStorage
        const savedTemplates = localStorage.getItem('ecrfTemplates');
        if (savedTemplates) {
          const templates = JSON.parse(savedTemplates);
          this.template = templates.find((t: any) => t.id.toString() === this.template_id);
        }
        
        if (!this.template) {
          this.router.navigate(['/study-template']);
          return;
        }
        
        // Initialize folders array if it doesn't exist
        if (!this.template.folders) {
          this.ensureDefaultFoldersExist();
        }

        // Add default folders if they don't exist

        this.loading = false;
        this.prefetchPiSignatureStatusForAllForms();
        this.reopenLastOpenedForm();
        this.fetchParticipantIdIfNeeded();
      }
    );
  }

  /**
   * Fetch participant_id from get-form-data API when template is loaded so the header shows it
   * even before the user opens a form (API returns participant_id e.g. when data is empty).
   */
  private fetchParticipantIdIfNeeded(): void {
    if (!this.study_id || !this.subject_id || !this.template?.folders?.length) {
      return;
    }
    const firstFolder = this.template.folders[0];
    const firstForm = firstFolder?.forms?.[0];
    if (!firstForm) {
      return;
    }
    const formId = firstForm.id || firstForm.name;
    this.apiService.getTemplateFormDataByQuery(this.study_id, this.subject_id, formId).subscribe(
      (response) => {
        if (response?.participant_id != null && response.participant_id !== undefined) {
          this.participantId = String(response.participant_id);
          this.cdr.detectChanges();
        }
      },
      () => {}
    );
  }

  loadDefaultFolders() {
    this.loading = true;
    this.foldersDataService.getFoldersData().subscribe(data => {
      this.defaultFolders = data.folders;
      this.loading = false;
      // Load template after default folders are loaded
      this.loadTemplate();
    }, error => {
      this.loading = false;
      // Still try to load template even if default folders fail
      this.loadTemplate();
    });
  }

  /**
   * Prefetch PI signature status for all forms so the sidebar can show the checkmark on page load.
   */
  private prefetchPiSignatureStatusForAllForms(): void {
    if (!this.study_id || !this.subject_id || !this.template?.folders) {
      return;
    }
    const studyId = this.study_id;
    const subjectId = this.subject_id;
    const requests: Array<{ formId: string; form: any; request: any }> = [];
    this.template.folders.forEach((folder: any) => {
      (folder.forms || []).forEach((form: any) => {
        const formId = form.id ?? form.form_id ?? form.name;
        if (!formId) return;
        const request = this.apiService.getTemplateFormDataByQuery(studyId, subjectId, formId).pipe(
          map((response: any) => ({ formId, form, data: Array.isArray(response?.data) ? response.data : [] })),
          catchError(() => of({ formId, form, data: [] }))
        );
        requests.push({ formId, form, request });
      });
    });
    if (requests.length === 0) {
      return;
    }
    forkJoin(requests.map(r => r.request)).subscribe((results: any[]) => {
      results.forEach((result: any) => {
        const { formId, data } = result;
        let piSignatureReviewed = false;
        let piReviewedBy: string | undefined;
        let piReviewedAt: string | undefined;
        let piComment: string | undefined;
        if (Array.isArray(data)) {
          for (const record of data) {
            const piCheck = record.pi_check;
            if (piCheck === true || piCheck === 1) {
              piSignatureReviewed = true;
            }
            if (record.pi_reviewed_by && !piReviewedBy) piReviewedBy = record.pi_reviewed_by;
            if (record.pi_review_time && !piReviewedAt) piReviewedAt = record.pi_review_time;
            if (record.pi_comment && !piComment) piComment = record.pi_comment;
          }
        }
        if (piSignatureReviewed) {
          if (!this.formReviewStatus[formId]) {
            this.formReviewStatus[formId] = {
              piSignatureReviewed: false,
              reviewOptions: { dataManager: false, monitor: false, pi: false }
            };
          }
          this.formReviewStatus[formId].piSignatureReviewed = true;
          if (piReviewedBy !== undefined) this.formReviewStatus[formId].piReviewedBy = piReviewedBy;
          if (piReviewedAt !== undefined) this.formReviewStatus[formId].piReviewedAt = piReviewedAt;
          if (piComment !== undefined) this.formReviewStatus[formId].piComment = piComment;
        }
      });
      this.cdr.detectChanges();
    });
  }

  // Query, Edit Reason, and Review functionality methods
  generateThreadId(): string {
    return 'thread_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  openOptionsModal(event: MouseEvent, target: EventTarget | null, field?: any, rowIndex?: number) {
    event.stopPropagation();
    this.isOptionsModalOpen = true;

    // Position the options modal near the mouse cursor
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const mouseX = event.clientX;
    const mouseY = event.clientY;
    const estimatedWidth = 180;  // rough modal width
    const estimatedHeight = 140; // rough modal height

    let left = mouseX + 8;
    let top = mouseY + 8;

    if (left + estimatedWidth > viewportWidth - 8) {
      left = Math.max(8, viewportWidth - estimatedWidth - 8);
    }
    if (top + estimatedHeight > viewportHeight - 8) {
      top = Math.max(8, viewportHeight - estimatedHeight - 8);
    }

    this.optionsModalStyle = {
      position: 'fixed',
      top: `${top}px`,
      left: `${left}px`,
      right: 'auto',
    };
    const fieldId = field?.id != null ? String(field.id) : null;
    if (fieldId && rowIndex !== undefined && rowIndex !== null) {
      this.selectedOptionsFieldId = `${fieldId}__row__${rowIndex}`;
      if (field?.name) {
        this.fieldLabel = `${field.name}__row__${rowIndex}`;
        return;
      }
    }
    this.selectedOptionsFieldId = fieldId;
    if (field?.title || field?.name) {
      this.fieldLabel = field.title || field.name;
      return;
    }

    // Traverse to the closest parent with field title
    const icon = target as HTMLElement;
    const fieldGroup = icon.closest('.form-group-wrapper');
    
    if (fieldGroup) {
      const labelElement = fieldGroup.querySelector('label span');
      if (labelElement) {
        this.fieldLabel = labelElement.textContent || '';
      }
    }
  }

  openModal(field?: any,rowIndex?: any) {
    this.isModalOpen = true;
    this.selectedTab = 0; // Default to 'Query'

     // Always prefer the clicked field id (avoids collisions when names repeat across forms/folders)
     if (field?.id != null) {
      this.selectedModalFieldId = String(field.id);
    } else if (this.selectedOptionsFieldId) {
      // selectedOptionsFieldId can look like: "<fieldId>" or "<fieldId>__row__<rowIndex>"
      const parsedFieldId = String(this.selectedOptionsFieldId).split('__row__')[0];
      this.selectedModalFieldId = parsedFieldId || null;
    } else {
      this.selectedModalFieldId = null;
    }

    if (field?.name) {
      this.fieldLabel = rowIndex >= 0 ? `${field.name}__row__${rowIndex}` : (field.title || field.name);
    }

    const fieldName = field?.name || this.fieldLabel || 'Unknown Field';
    const fieldIdOverride = field?.id ?? null;
    // Clear previous data
    this.fieldHistoryData = [];
    
    this.currentRowIndex = rowIndex >= 0 ? rowIndex : null;
    let rowId: number;
    if (rowIndex >= 0 && field) {
      if (field.type === 'fixed-rows-table') {
        const pkStr = this.getFixedRowsDbRowIdForUiIndex(field, field.name, rowIndex);
        if (pkStr != null) {
          const num = Number(pkStr);
          this.currentRowId = Number.isNaN(num) ? null : num;
        } else {
          this.currentRowId = null;
        }
      } else {
        // Get the actual row data from the form control using the array index
        const tableData = this.getTableData(field.name);
        if (tableData && tableData[rowIndex] && tableData[rowIndex].id) {
          // Use the id from the form control data to find the matching row in table_rows
          rowId = tableData[rowIndex].id;
          this.currentRowId = rowId;
        } else {
          // Fallback: try to find by row_index (for backwards compatibility)
          rowId = this.table_rows.find((row: any) => JSON.parse(row.value).row_index == rowIndex)?.id;
          this.currentRowId = rowId;
        }
      }
    } else {
      this.currentRowId = null;
    }


    // Load query history from template backend
    this.loadQueryHistory(fieldName, rowIndex, fieldIdOverride, field?.type === 'fixed-rows-table');
    this.loadFieldHistory();
  }

// When loading query history, preserve backend queryId and set nextLocalQueryId
private loadQueryHistory(fieldName: string, rowIndex?: number, fieldIdOverride?: string | number, isFixedRowsTable?: boolean) {
  if (!this.study_id || !this.subject_id || !this.currentForm) {
    const userData = this.commonService.getUserData();
    this.queries = [{
      threadId: this.generateThreadId(),
      text: '',
      isClosed: false,
      queryId: 0,
      createdBy: userData?.id || null,
      auditTrail: []
    }];
    this.nextLocalQueryId = 1;
    return;
  }

  const studyId = this.study_id;
  const subjectId = this.subject_id;
  const formId = this.currentForm.id || this.currentForm.name;
  console.log("Field Name: ", fieldName);
  const fieldId = fieldIdOverride != null ? String(fieldIdOverride) : this.getActiveFieldIdForApi(fieldName);
  const rowIdParam = this.getRowIdParam();

  this.apiService.getTemplateQueryHistory(studyId, subjectId, formId, fieldId, rowIdParam).subscribe({
    next: (response) => {
      const threads = Array.isArray(response?.data) ? response.data : [];
      // Fixed-rows-table: API rowId is ecrf_table PK (e.g. 15916), not *ngFor rowIndex (0,1,2…).
      let resolvedDbRowId: string | null = null;
      if (isFixedRowsTable && rowIndex !== undefined && rowIndex !== null) {
        if (this.currentRowId != null && this.currentRowId !== undefined) {
          resolvedDbRowId = String(this.currentRowId);
        } else {
          const fieldForRow = this.fields.find(f => f.name === fieldName);
          const fromSorted =
            fieldForRow != null ? this.getFixedRowsDbRowIdForUiIndex(fieldForRow, fieldName, rowIndex) : null;
          if (fromSorted != null) {
            resolvedDbRowId = fromSorted;
          } else {
            const rows = this.getTableData(fieldName);
            const rid = rows?.[rowIndex]?.id;
            if (rid != null && rid !== undefined) {
              resolvedDbRowId = String(rid);
            }
          }
        }
      }
      const filteredThreads = isFixedRowsTable && rowIndex !== undefined && rowIndex !== null
        ? threads.filter((thread: any) => {
            const threadRowId = thread?.rowId ?? thread?.row_id;
            if (resolvedDbRowId != null) {
              return String(threadRowId) === resolvedDbRowId;
            }
            return String(threadRowId) === String(rowIndex);
          })
        : threads;

      if (filteredThreads.length > 0) {
        // Map backend threads -> frontend queries preserving queryId
        this.queries = filteredThreads.map((thread: any) => {
          // Ensure auditTrail is always an array
          let auditTrailArray: any[] = [];
          if (Array.isArray(thread.auditTrail)) {
            auditTrailArray = thread.auditTrail;
          } else if (thread.auditTrail) {
            // If it's not an array but exists, wrap it
            auditTrailArray = [thread.auditTrail];
          }
          // Extract creator ID from backend response (could be created_by, query_created_by, or from auditTrail)
          let createdBy = thread.created_by || thread.query_created_by || null;
          // If not found in response, try to get from first audit trail entry
          if (!createdBy && auditTrailArray.length > 0) {
            // The last entry in auditTrail is the first one created (oldest)
            const firstEntry = auditTrailArray[auditTrailArray.length - 1];
            // Try to match user ID if available in the entry
            if (firstEntry && firstEntry.user_id) {
              createdBy = firstEntry.user_id;
            }
          }
          return {
            threadId: thread.threadId || this.generateThreadId(),
            text: '', // text not provided by backend, user types it
            isClosed: !!thread.isClosed,
            queryId: (thread.queryId !== undefined) ? thread.queryId : this.generateThreadIdAsNumber(),
            isSubmitted: auditTrailArray.length > 0,
            createdBy: createdBy,
            rowId: thread?.rowId ?? thread?.row_id,
            auditTrail: auditTrailArray
          };
        });
        // set nextLocalQueryId as max(queryId)+1 to keep incremental unique ids
        const maxId = this.queries.reduce((max, q) => {
          const id = (typeof q.queryId === 'number') ? q.queryId : -1;
          return id > max ? id : max;
        }, -1);
        this.nextLocalQueryId = (maxId >= 0) ? maxId + 1 : 0;

        // Update query status for this field
        this.updateFieldQueryStatus(fieldName, rowIndex);

      } else {
        // No existing queries, create new one
        const userData = this.commonService.getUserData();
        this.queries = [{
          threadId: this.generateThreadId(),
          text: '',
          isClosed: false,
          queryId: 0,
          createdBy: userData?.id || null,
          auditTrail: []
        }];
        this.nextLocalQueryId = 1;
        // No queries means no status
        const fieldKey = this.getFieldQueryKey(fieldName, rowIndex);
        delete this.fieldQueryStatus[fieldKey];
      }
    },
    error: (error) => {
      const userData = this.commonService.getUserData();
      this.queries = [{
        threadId: this.generateThreadId(),
        text: '',
        isClosed: false,
        queryId: 0,
        createdBy: userData?.id || null,
        auditTrail: []
      }];
      this.nextLocalQueryId = 1;
      // On error, clear status
      const fieldKey = this.getFieldQueryKey(fieldName, rowIndex);
      delete this.fieldQueryStatus[fieldKey];
    }
  });
}

// Get the key for tracking query status (fieldName or fieldName__row__rowIndex)
private getFieldQueryKey(fieldName: string, rowIndex?: number): string {
  if (rowIndex !== undefined && rowIndex !== null) {
    return `${fieldName}__row__${rowIndex}`;
  }
  return fieldName;
}

// Get the key for tracking review status (reuses same logic as query key)
private getFieldReviewKey(fieldName: string, rowIndex?: number): string {
  return this.getFieldQueryKey(fieldName, rowIndex);
}

/** `table_rows` entries for this template table / fixed-rows field (string-safe `field_id`). */
private getDbRowsForTemplateTableField(field: any): any[] {
  if (!field) {
    return [];
  }
  return this.table_rows.filter((row: any) => {
    const rf = row?.field_id;
    if (rf === undefined || rf === null) {
      return false;
    }
    const rfStr = String(rf);
    if (field.id != null && field.id !== '' && rfStr === String(field.id)) {
      return true;
    }
    return field.name != null && field.name !== '' && (row.field_id === field.name || rfStr === String(field.name));
  });
}

/** Backend row id on each `table_rows` item (same as query-history `rowId` / `row_id`). */
private parseFixedRowsBackendRowIdForSort(dbRow: any): number | null {
  const id = dbRow?.id;
  if (id === undefined || id === null) {
    return null;
  }
  const n = Number(id);
  return Number.isNaN(n) ? null : n;
}

/** Sort fixed-rows `table_rows` by backend `id` ascending (matches query `row_id` ordering). */
private sortFixedRowsDbRowsLikeLoadedForm(dbRows: any[]): any[] {
  const sorted = [...dbRows];
  sorted.sort((a, b) => {
    const ra = this.parseFixedRowsBackendRowIdForSort(a);
    const rb = this.parseFixedRowsBackendRowIdForSort(b);
    if (ra === null && rb === null) {
      return 0;
    }
    if (ra === null) {
      return 1;
    }
    if (rb === null) {
      return -1;
    }
    return ra - rb;
  });
  return sorted;
}

/** Ecrf PK for a fixed-rows UI row (sorted `table_rows` first, then form row `id`). */
private getFixedRowsDbRowIdForUiIndex(field: any, fieldName: string, uiIndex: number): string | null {
  const sorted = this.sortFixedRowsDbRowsLikeLoadedForm(this.getDbRowsForTemplateTableField(field));
  if (uiIndex >= 0 && uiIndex < sorted.length && sorted[uiIndex]?.id != null && sorted[uiIndex]?.id !== undefined) {
    return String(sorted[uiIndex].id);
  }
  const td = this.getTableData(fieldName);
  const id = td?.[uiIndex]?.id;
  if (id != null && id !== undefined) {
    return String(id);
  }
  return null;
}

// Update query status for a field based on current queries
private updateFieldQueryStatus(fieldName: string, rowIndex?: number): void {
  this.setFieldQueryStatusFromThreads(fieldName, rowIndex, this.queries);
}

// Derive query highlight status from a list of threads without mutating query data
private setFieldQueryStatusFromThreads(fieldName: string, rowIndex: number | undefined, threads: any[] | undefined): void {
  const fieldKey = this.getFieldQueryKey(fieldName, rowIndex);
  // Consider "answered" only when there is at least one reply beyond the initial comment (>=2 entries)
  const hasAnsweredQueries = Array.isArray(threads)
    ? threads.some(q => !q?.isClosed && Array.isArray(q?.auditTrail) && q.auditTrail.length >= 2)
    : false;
  const hasOpenQueries = Array.isArray(threads) ? threads.some(q => !q?.isClosed) : false;
  const hasClosedQueries = Array.isArray(threads) ? threads.some(q => q?.isClosed) : false;

  if (hasAnsweredQueries) {
    this.fieldQueryStatus[fieldKey] = 'answered';
  } else if (hasOpenQueries) {
    this.fieldQueryStatus[fieldKey] = 'open';
  } else if (hasClosedQueries) {
    this.fieldQueryStatus[fieldKey] = 'closed';
  } else {
    delete this.fieldQueryStatus[fieldKey];
  }
}

// Check if a field has open queries
hasOpenQueries(fieldName: string, rowIndex?: number): boolean {
  const fieldKey = this.getFieldQueryKey(fieldName, rowIndex);
  return this.fieldQueryStatus[fieldKey] === 'open' || this.fieldQueryStatus[fieldKey] === 'answered';
}

// Check if a field has answered (responded) queries
hasAnsweredQueries(fieldName: string, rowIndex?: number): boolean {
  const fieldKey = this.getFieldQueryKey(fieldName, rowIndex);
  return this.fieldQueryStatus[fieldKey] === 'answered';
}

// Check if a field has closed queries (all queries are closed)
hasClosedQueries(fieldName: string, rowIndex?: number): boolean {
  const fieldKey = this.getFieldQueryKey(fieldName, rowIndex);
  return this.fieldQueryStatus[fieldKey] === 'closed';
}

// Get review data for a field
getReviewData(fieldName: string, rowIndex?: number): any {
  const fieldKey = this.getFieldReviewKey(fieldName, rowIndex);
  return this.fieldReviewStatus[fieldKey] || null;
}

// Check if a field has data manager review
hasDataManagerReview(fieldName: string, rowIndex?: number): boolean {
  const reviewData = this.getReviewData(fieldName, rowIndex);
  return Boolean(reviewData?.data_manager_reviewed);
}

// Check if a field has monitor review
hasMonitorReview(fieldName: string, rowIndex?: number): boolean {
  const reviewData = this.getReviewData(fieldName, rowIndex);
  return Boolean(reviewData?.monitor_reviewed);
}

// Check if a field has PI check
hasPiCheck(fieldName: string, rowIndex?: number): boolean {
  const reviewData = this.getReviewData(fieldName, rowIndex);
  return reviewData?.pi_check || false;
}

// Check if a field has been reviewed by Monitor and/or Data Manager (for showing review icon on field label)
hasMonitorOrDataManagerReview(fieldName: string, rowIndex?: number): boolean {
  return this.hasMonitorReview(fieldName, rowIndex) || this.hasDataManagerReview(fieldName, rowIndex);
}

// Prefetch query status so highlights are available without opening the query modal
private prefetchQueryStatusesForCurrentForm(): void {
  if (!this.study_id || !this.subject_id || !this.currentForm || !this.fields) {
    return;
  }

  const studyId = this.study_id;
  const subjectId = this.subject_id;
  const formId = this.currentForm.id || this.currentForm.name;

  // Non-table fields
  this.fields
    .filter(field => field && field.type !== 'table' && field.type !== 'fixed-rows-table')
    .forEach(field => {
      const fieldName = field.title || field.name;
      if (!fieldName) {
        return;
      }
      const fieldId =
        field.id != null && field.id !== ''
          ? String(field.id)
          : this.getFieldIdFromCurrentFormFieldName(fieldName);
      this.apiService.getTemplateQueryHistory(studyId, subjectId, formId, fieldId, 'undefined').subscribe({
        next: (response) => {
          this.setFieldQueryStatusFromThreads(fieldName, undefined, response?.data);
        },
        error: () => {
          const fieldKey = this.getFieldQueryKey(fieldName);
          delete this.fieldQueryStatus[fieldKey];
        }
      });
    });

  // Table fields (status is per row)
  const tableFields = this.fields.filter(field => field && (field.type === 'table' || field.type === 'fixed-rows-table'));
  tableFields.forEach(field => {
    const fieldId = field.id != null && field.id !== '' ? String(field.id) : field.name;
    const rowsForField = this.getDbRowsForTemplateTableField(field);

    if (field.type === 'fixed-rows-table') {
      // Same pattern as dynamic `table`: one history request per DB row with explicit `row_id` (no field-level bulk fetch).
      const sortedRows = this.sortFixedRowsDbRowsLikeLoadedForm(rowsForField);
      sortedRows.forEach((row: any, sortedPos: number) => {
        // UI `*ngFor` index matches this order (same backend-id sort as setFormDataWithLockStatus).
        const rowIndex = sortedPos;

        const rowId = row?.id != null && row?.id !== undefined ? row.id.toString() : 'undefined';
        this.apiService.getTemplateQueryHistory(studyId, subjectId, formId, fieldId, rowId).subscribe({
          next: (response) => {
            this.setFieldQueryStatusFromThreads(field.name, rowIndex, response?.data);
          },
          error: () => {
            const fieldKey = this.getFieldQueryKey(field.name, rowIndex);
            delete this.fieldQueryStatus[fieldKey];
          }
        });
      });
      return;
    }

    rowsForField.forEach((row: any) => {
      let rowIndex: number | undefined;
      try {
        const parsedValue = row?.value ? JSON.parse(row.value) : null;
        if (parsedValue && parsedValue.row_index !== undefined && parsedValue.row_index !== null) {
          rowIndex = Number(parsedValue.row_index);
          if (Number.isNaN(rowIndex)) {
            rowIndex = undefined;
          }
        }
      } catch (error) {
        rowIndex = undefined;
      }

      if (rowIndex === undefined) {
        return;
      }

      const rowId = row?.id ? row.id.toString() : 'undefined';
      this.apiService.getTemplateQueryHistory(studyId, subjectId, formId, fieldId, rowId).subscribe({
        next: (response) => {
          this.setFieldQueryStatusFromThreads(field.name, rowIndex, response?.data);
        },
        error: () => {
          const fieldKey = this.getFieldQueryKey(field.name, rowIndex);
          delete this.fieldQueryStatus[fieldKey];
        }
      });
    });
  });
}

// Prefetch review status so review data is available without opening the review modal
private prefetchReviewStatusesForCurrentForm(): void {
  if (!this.study_id || !this.subject_id || !this.currentForm || !this.fields) {
    return;
  }

  const studyId = this.study_id;
  const subjectId = this.subject_id;
  const formId = this.currentForm.id || this.currentForm.name;

  // Non-table fields
  this.fields
    .filter(field => field && field.type !== 'table' && field.type !== 'fixed-rows-table')
    .forEach(field => {
      const fieldName = field.title || field.name;
      if (!fieldName) {
        return;
      }
      const fieldId =
        field.id != null && field.id !== ''
          ? String(field.id)
          : this.getFieldIdFromCurrentFormFieldName(fieldName);
      
      // Only fetch if we have a valid fieldId (not just the fieldName as fallback)
      if (fieldId && fieldId !== fieldName) {
        this.apiService.fetchReviewData(studyId, subjectId, formId, fieldId).subscribe({
          next: (response) => {
            if (response.success && response.data) {
              const reviewData = response.data;
              const fieldKey = this.getFieldReviewKey(fieldName);
              this.fieldReviewStatus[fieldKey] = {
                monitor_reviewed: Boolean(reviewData.monitor_reviewed),
                monitor_reviewed_by: reviewData.monitor_reviewed_by || null,
                monitor_review_time: reviewData.monitor_review_time || null,
                data_manager_reviewed: Boolean(reviewData.data_manager_reviewed),
                data_manager_reviewed_by: reviewData.data_manager_reviewed_by || null,
                data_manager_review_time: reviewData.data_manager_review_time || null,
                pi_check: Boolean(reviewData.pi_check),
                pi_reviewed_by: reviewData.pi_reviewed_by || null,
                pi_review_time: reviewData.pi_review_time || null,
                pi_comment: reviewData.pi_comment || null
              };
            }
          },
          error: () => {
            const fieldKey = this.getFieldReviewKey(fieldName);
            delete this.fieldReviewStatus[fieldKey];
          }
        });
      }
    });

  // Table fields - fetch review data for the field itself
  // Note: If review data needs to be per-row, the backend field_id would need to include row information
  const tableFields = this.fields.filter(field => field && (field.type === 'table' || field.type === 'fixed-rows-table'));
  tableFields.forEach(field => {
    const fieldName = field.title || field.name;
    if (!fieldName) {
      return;
    }
    const fieldId =
      field.id != null && field.id !== ''
        ? String(field.id)
        : this.getFieldIdFromCurrentFormFieldName(fieldName);
    
    // Only fetch if we have a valid fieldId (not just the fieldName as fallback)
    if (fieldId && fieldId !== fieldName) {
      this.apiService.fetchReviewData(studyId, subjectId, formId, fieldId).subscribe({
        next: (response) => {
          if (response.success && response.data) {
            const reviewData = response.data;
            // Store review data at the field level (not per row)
            const fieldKey = this.getFieldReviewKey(fieldName);
            this.fieldReviewStatus[fieldKey] = {
              monitor_reviewed: Boolean(reviewData.monitor_reviewed),
              monitor_reviewed_by: reviewData.monitor_reviewed_by || null,
              monitor_review_time: reviewData.monitor_review_time || null,
              data_manager_reviewed: Boolean(reviewData.data_manager_reviewed),
              data_manager_reviewed_by: reviewData.data_manager_reviewed_by || null,
              data_manager_review_time: reviewData.data_manager_review_time || null,
              pi_check: Boolean(reviewData.pi_check),
              pi_reviewed_by: reviewData.pi_reviewed_by || null,
              pi_review_time: reviewData.pi_review_time || null,
              pi_comment: reviewData.pi_comment || null
            };
          }
        },
        error: () => {
          const fieldKey = this.getFieldReviewKey(fieldName);
          delete this.fieldReviewStatus[fieldKey];
        }
      });
    }
  });
}


  private loadFieldHistory() {
    // Check if we have valid required IDs
    if (!this.study_id || !this.subject_id || !this.currentForm) {
      this.fieldHistoryData = [];
      return;
    }

    const fieldName = this.fieldLabel || 'Unknown Field';
    
    // Get the required parameters for the API call as requested
    const studyId = this.study_id;
    const subjectId = this.subject_id;
    const formId = this.currentForm.id || this.currentForm.name;
    const rowId = this.currentRowId;
    const rowIdParam = rowId !== null && rowId !== undefined ? rowId.toString() : 'undefined';
    
    // // Find the actual field ID from the field name using the same method as query submission
    // const fieldId = this.getFieldIdFromFieldName(fieldName);
     // Use the exact clicked field id when available. Fallback is scoped to current form only.
    const fieldId = this.getActiveFieldIdForApi(fieldName);

    // Call the API to get field history using the fetchHistory endpoint with query parameters
    this.apiService.getTemplateHistoryByQuery(studyId, subjectId, formId, fieldId, rowIdParam).subscribe({
      next: (response) => {
        if (response.success) {
          // Transform backend data to frontend format for field history

          const fieldDefinition = this.getFieldById(fieldId) || this.fields.find(f => f.title === fieldName || f.name === fieldName);
          const isTableField = fieldDefinition?.type === 'table' || fieldDefinition?.type === 'fixed-rows-table';

          this.fieldHistoryData = response.historyItem.map((history: any) => {
            const baseEntry: any = {
              updated_by: history.updated_by,
              updated_at: history.updated_at,
              value: history.value,
              edit_reason: history.edit_reason,
            };

            if (!isTableField) {
              return baseEntry;
            }

            const tableRows = this.parseTableHistoryValue(history.value);
            const tableColumns = this.buildTableHistoryColumns(fieldDefinition, tableRows);

            return {
              ...baseEntry,
              isTable: true,
              tableData: tableRows,
              tableColumns,
            };
          });

          // this.fieldHistoryData = response.historyItem.map((history: any) => ({
          //   id: history.id,
          //   value: history.value,
          //   subData: history.sub_data,
          //   updatedBy: history.updated_by,
          //   editReason: history.edit_reason,
          //   reviewStatus: history.review_status,
          //   createdAt: history.created_at,
          //   // Parse sub_data if it's a JSON string
          //   parsedSubData: history.sub_data ? 
          //     (typeof history.sub_data === 'string' ? 
          //       JSON.parse(history.sub_data) : 
          //       history.sub_data) : null
          // }));
        } else {
          // No existing field history, set empty array
          this.fieldHistoryData = [];
        }
      },
      error: (error) => {
        // Fallback to empty array
        this.fieldHistoryData = [];
      }
    });
  }

   /**
   * Resolve a field id only within the currently loaded form fields.
   * This avoids wrong ids when different forms/folders have same field names.
   */
   private getFieldIdFromCurrentFormFieldName(fieldName: string): string {
    const normalizedFieldName = fieldName?.includes('__row__') ? fieldName.split('__row__')[0] : fieldName;
    if (!normalizedFieldName) return fieldName;
    if (!this.fields || !Array.isArray(this.fields)) return normalizedFieldName;

    for (const field of this.fields) {
      if (!field) continue;
      if (field.title === normalizedFieldName || field.name === normalizedFieldName) {
        return field.id != null ? String(field.id) : normalizedFieldName;
      }
      if (field.subFields && Array.isArray(field.subFields)) {
        for (const subField of field.subFields) {
          if (!subField) continue;
          if (subField.name === normalizedFieldName) {
            return subField.id != null ? String(subField.id) : normalizedFieldName;
          }
        }
      }
    }
    return normalizedFieldName;
  }

  /**
   * Field id for template APIs: id from Query modal if set, else id from the ⋮ menu
   * (`selectedOptionsFieldId`), else resolve by label on the **current** form only.
   */
  private getActiveFieldIdForApi(fieldLabel: string): string {
    if (this.selectedModalFieldId) {
      return this.selectedModalFieldId;
    }
    if (this.selectedOptionsFieldId) {
      const parsed = String(this.selectedOptionsFieldId).split('__row__')[0];
      if (parsed) {
        return parsed;
      }
    }
    return this.getFieldIdFromCurrentFormFieldName(fieldLabel);
  }

  openReviewModal(event?: MouseEvent) {
    const userData = this.commonService.getUserData();
    const designation = userData?.designation || '';

    // If CRO, PI, or CRC tries to review, show approver details instead of opening the modal
    if (['CRO', 'PI', 'CRC'].includes(designation)) {
      // Always center the popup for CRO/PI/CRC users
      this.reviewModalPosition = { top: '50%', left: '50%', right: 'auto', transform: 'translate(-50%, -50%)' };
      this.hasCustomReviewPosition = false;
      
      // Fetch review data from backend
      const fieldName = this.fieldLabel || 'Unknown Field';
      if (this.study_id && this.subject_id && this.currentForm) {
        const studyId = this.study_id;
        const subjectId = this.subject_id;
        const formId = this.currentForm.id || this.currentForm.name;
        const fieldId = this.getActiveFieldIdForApi(fieldName);

        if (fieldId && fieldId !== fieldName) {
          this.apiService.fetchReviewData(studyId, subjectId, formId, fieldId).subscribe({
            next: (response) => {
              if (response.success && response.data) {
                const reviewData = response.data;
                this.reviewInfo = {
                  monitorName: reviewData.monitor_reviewed && reviewData.monitor_reviewed_by 
                    ? reviewData.monitor_reviewed_by 
                    : 'Not done',
                  monitorTime: reviewData.monitor_reviewed && reviewData.monitor_review_time 
                    ? reviewData.monitor_review_time 
                    : null,
                  dataManagerName: reviewData.data_manager_reviewed && reviewData.data_manager_reviewed_by 
                    ? reviewData.data_manager_reviewed_by 
                    : 'Not done',
                  dataManagerTime: reviewData.data_manager_reviewed && reviewData.data_manager_review_time 
                    ? reviewData.data_manager_review_time 
                    : null
                };
              } else {
                this.reviewInfo = {
                  monitorName: 'Not done',
                  monitorTime: null,
                  dataManagerName: 'Not done',
                  dataManagerTime: null
                };
              }
              this.showReviewInfoPopup = true;
            },
            error: (error) => {
              this.reviewInfo = {
                monitorName: 'Not done',
                monitorTime: null,
                dataManagerName: 'Not done',
                dataManagerTime: null
              };
              this.showReviewInfoPopup = true;
            }
          });
        } else {
          // Fallback if fieldId is not valid
          this.reviewInfo = {
            monitorName: 'Not done',
            monitorTime: null,
            dataManagerName: 'Not done',
            dataManagerTime: null
          };
          this.showReviewInfoPopup = true;
        }
      } else {
        // Fallback if required data is missing
        this.reviewInfo = {
          monitorName: 'Not done',
          monitorTime: null,
          dataManagerName: 'Not done',
          dataManagerTime: null
        };
        this.showReviewInfoPopup = true;
      }
      return;
    }

    if (event) {
      // Calculate position relative to the clicked element
      const target = event.target as HTMLElement;
      const rect = target.getBoundingClientRect();

      // Position modal near the clicked button; account for page scroll
      const top = rect.bottom + window.scrollY; // dropdown should appear below the button
      const right = Math.max(0, window.innerWidth - rect.right);

      this.reviewModalPosition = {
        top: `${top}px`,
        right: `${right}px`
      };
    }

    this.showReviewModal = true;
    const fieldName = this.fieldLabel || 'Unknown Field';
    // For ECRF template, we'll use a simplified approach
    this.fieldHistoryData = [];
    
    // Initialize with default values
    this.reviewOptions = {
      dataManager: false,
      monitor: false,
      pi: false
    };

    // Fetch review data from backend
    if (this.study_id && this.subject_id && this.currentForm) {
      const studyId = this.study_id;
      const subjectId = this.subject_id;
      const formId = this.currentForm.id || this.currentForm.name;
      const fieldId = this.getActiveFieldIdForApi(fieldName);

      // Only fetch if we have a valid fieldId (not just the fieldName as fallback)
      if (fieldId && fieldId !== fieldName) {
        this.apiService.fetchReviewData(studyId, subjectId, formId, fieldId).subscribe({
          next: (response) => {
            if (response.success && response.data) {
              const reviewData = response.data;
              this.reviewOptions = {
                dataManager: reviewData.data_manager_reviewed || false,
                monitor: reviewData.monitor_reviewed || false,
                pi: reviewData.pi_check || false
              };
            }
          },
          error: (error) => {
            // Keep default values on error
          }
        });
      }
    }
  }

  private getReviewApproverDetails(): { monitorName: string; dataManagerName: string } {
    const formKey = this.currentForm?.id || this.currentForm?.name || 'default';
    const status = this.formReviewStatus[formKey];
    const statusAny: any = status || {};
    // Try multiple possible keys; fall back to "Not done"
    const monitorName =
      statusAny?.reviewOptions?.monitorBy ||
      statusAny?.monitorName ||
      statusAny?.reviewedByMonitor ||
      'Not done';
    const dataManagerName =
      statusAny?.reviewOptions?.dataManagerBy ||
      statusAny?.dataManagerName ||
      statusAny?.reviewedByDataManager ||
      'Not done';
    return { monitorName, dataManagerName };
  }

  closeReviewInfoPopup() {
    this.hasCustomReviewPosition = false;
    this.showReviewInfoPopup = false;
    this.isOptionsModalOpen = false;
  }

  editStudy() {
    const labelTrimmed = (this.fieldLabel || '').trim();
    const fieldNameFromLabel = this.getFieldNameFromLabel(labelTrimmed);
    // Match by title, name, or normalized name so checkbox and other fields are found
    const field = this.fields.find(f =>
      f.title === labelTrimmed || f.name === labelTrimmed || f.name === fieldNameFromLabel
    );

    console.log("Field: ", field);
    console.log(this.form);
    if (this.shouldBlockEditByLockFreeze(field)) {
      this.showLockFreezeMessage(this.getFieldLockFreezeStatus(field));
      return;
    }
    if (field) {
      console.log("Unlocking field: ", field.name);
      this.fieldToUnlock = field.name;
      this.editReason = '';
      this.isReasonModalOpen = true;
    }
  }

  private getFieldNameFromLabel(label: string): string {
    // Convert field label to field name (similar to how fields are created)
    return label.toLowerCase().replace(/\s+/g, '_');
  }

  private getRowIdParam(): string {
    if (this.currentRowId !== null && this.currentRowId !== undefined) {
      return this.currentRowId.toString();
    }
    const match = this.fieldLabel?.match(/__row__(\d+)/);
    if (match && match[1] !== undefined) {
      return match[1];
    }
    return 'undefined';
  }

  private collectFieldIdsForCurrentForm(): string[] {
    const ids = new Set<string>();
    if (!this.fields || !Array.isArray(this.fields)) {
      return [];
    }
    this.fields.forEach((field: any) => {
      if (field?.id != null) {
        ids.add(String(field.id));
      }
      if (field?.subFields && Array.isArray(field.subFields)) {
        field.subFields.forEach((subField: any) => {
          if (subField?.id != null) {
            ids.add(String(subField.id));
          }
        });
      }
    });
    return Array.from(ids);
  }

  private disableFieldControl(fieldName: string): void {
    if (!this.form) return;
    const control = this.form.get(fieldName);
    if (control && control.enabled) {
      control.disable({ emitEvent: false });
    }
  }

  private applyLockedDataToCurrentForm(rows: any[]): void {
    if (!this.currentForm || !Array.isArray(rows)) {
      return;
    }

    const fieldIds = new Set(this.collectFieldIdsForCurrentForm());
    const lockedFieldIds = new Set<string>();
    const frozenFieldIds = new Set<string>();
    let hasStudyLock = false;
    let hasStudyFreeze = false;
    let hasSubjectLock = false;
    let hasSubjectFreeze = false;

    rows.forEach((row: any) => {
      const isLocked = row?.is_locked === 1 || row?.is_locked === true;
      const isFrozen = row?.is_freezed === 1 || row?.is_freezed === true;
      if (!isLocked && !isFrozen) return;

      const lockedDataId = row?.locked_data_id != null ? String(row.locked_data_id) : null;
      const dataType = row?.data_type ? String(row.data_type).toLowerCase() : '';
      const isFieldMatch = lockedDataId != null && fieldIds.has(lockedDataId);

      if (isFieldMatch) {
        if (isLocked) lockedFieldIds.add(lockedDataId);
        if (isFrozen) frozenFieldIds.add(lockedDataId);
        return;
      }

      if (dataType === 'study' || dataType === 'subject') {
        if (dataType === 'study') {
          if (String(row?.study_id ?? row?.locked_data_id) === String(this.study_id)) {
            if (isLocked) hasStudyLock = true;
            if (isFrozen) hasStudyFreeze = true;
          }
        }
        if (dataType === 'subject') {
          if (String(row?.subject_id) === String(this.subject_id)) {
            if (isLocked) hasSubjectLock = true;
            if (isFrozen) hasSubjectFreeze = true;
          }
        }
        return;
      }

      if (!dataType) {
        if (row?.study_id != null && String(row.study_id) === String(this.study_id)) {
          if (isLocked) hasStudyLock = true;
          if (isFrozen) hasStudyFreeze = true;
        }
        if (row?.subject_id != null && String(row.subject_id) === String(this.subject_id)) {
          if (isLocked) hasSubjectLock = true;
          if (isFrozen) hasSubjectFreeze = true;
        }
      }
    });

    const isGlobalLocked = hasStudyLock || hasSubjectLock;
    const isGlobalFrozen = hasStudyFreeze || hasSubjectFreeze;

    if (isGlobalLocked) this.currentForm.is_locked = true;
    if (isGlobalFrozen) this.currentForm.is_frozen = true;

    this.fields.forEach((field: any) => {
      const fieldId = field?.id != null ? String(field.id) : null;
      const shouldLock = isGlobalLocked || (fieldId != null && lockedFieldIds.has(fieldId));
      const shouldFreeze = isGlobalFrozen || (fieldId != null && frozenFieldIds.has(fieldId));

      if (shouldLock) field.is_locked = true;
      if (shouldFreeze) field.is_frozen = true;

      if (field?.subFields && Array.isArray(field.subFields)) {
        field.subFields.forEach((subField: any) => {
          const subFieldId = subField?.id != null ? String(subField.id) : null;
          const subLock = isGlobalLocked || (subFieldId != null && lockedFieldIds.has(subFieldId));
          const subFreeze = isGlobalFrozen || (subFieldId != null && frozenFieldIds.has(subFieldId));
          if (subLock) subField.is_locked = true;
          if (subFreeze) subField.is_frozen = true;
        });
      }
    });

    if (isGlobalLocked || isGlobalFrozen) {
      this.disableAllFormControls();
      return;
    }

    this.fields.forEach((field: any) => {
      const fieldId = field?.id != null ? String(field.id) : null;
      const isLockedOrFrozen =
        (fieldId != null && (lockedFieldIds.has(fieldId) || frozenFieldIds.has(fieldId))) ||
        field?.is_locked ||
        field?.is_frozen;

      if (isLockedOrFrozen) {
        if (field?.type === 'compound' && field?.subFields) {
          field.subFields.forEach((subField: any) => {
            const subFieldId = subField?.id != null ? String(subField.id) : null;
            const subLocked =
              (subFieldId != null && (lockedFieldIds.has(subFieldId) || frozenFieldIds.has(subFieldId))) ||
              subField?.is_locked ||
              subField?.is_frozen;
            if (subLocked && subField?.name) {
              this.disableFieldControl(subField.name);
            }
          });
        } else if (field?.name) {
          this.disableFieldControl(field.name);
        }

        if (field?.attachmentRequired && field?.name) {
          this.disableFieldControl(`${field.name}_attachments`);
        }
      }
    });
  }

  private fetchLockedDataForCurrentForm(): void {
    if (!this.currentForm) return;
    const fieldIds = this.collectFieldIdsForCurrentForm();
    if (!this.study_id && !this.subject_id && fieldIds.length === 0) return;

    this.apiService.fetchLockedDataByContext({
      study_id: this.study_id,
      subject_id: this.subject_id,
      field_id: fieldIds
    }).subscribe({
      next: (response: any) => {
        const rows = Array.isArray(response?.data) ? response.data : [];
        this.applyLockedDataToCurrentForm(rows);
      },
      error: (error) => {
      }
    });
  }

  isFieldLocked(fieldName: string): boolean {
    return this.fieldLockStatus[fieldName]?.isLocked || false;
  }

  // Get field lock status for display
  getFieldLockStatus(fieldName: string): { isLocked: boolean; lockedAt?: string; lockedBy?: string } {
    return this.fieldLockStatus[fieldName] || { isLocked: false };
  }

  // Check if a field should be disabled (combines all disabled conditions)
  isFieldDisabled(field: any): boolean {
    if (!field || !field.name) {
      return false;
    }
    return this.isFieldDisabledUser() || 
           this.isFieldReadOnly(field) || 
           this.isFieldLocked(field.name);
  }

  // Check if field is locked by field label
  isFieldLockedByLabel(fieldLabel: string): boolean {
    const fieldName = this.getFieldNameFromLabel(fieldLabel);
    return this.isFieldLocked(fieldName);
  }

  // Unlock a field (for admin/monitor use)
  unlockField(fieldName: string, reason: string): void {
    const userData = this.commonService.getUserData();
    const fullName = `${userData.first_name} ${userData.last_name}`;
    
    // Mark field as unlocked so isFieldLocked() returns false and template allows editing
    this.fieldLockStatus[fieldName] = {
      isLocked: false,
      lockedAt: this.fieldLockStatus[fieldName]?.lockedAt,
      lockedBy: this.fieldLockStatus[fieldName]?.lockedBy
    };
    
    // Store the edit reason for this field
    this.fieldEditReasons[fieldName] = reason;
    // Enable the form control
    const formControl = this.form?.get(fieldName) || this.form.controls[fieldName];
    console.log("Form Control: ", formControl);
    if (formControl) {
      formControl.enable();
    }
    
    // Remove from submitted fields
    this.submittedFields = this.submittedFields.filter(f => f !== fieldName);
    this.cdr.detectChanges();
  }

  getFieldValue(fieldLabel: string): any {
    // Get the current field value based on the field label or name
    const field = this.fields.find(f => f.title === fieldLabel || f.name === fieldLabel);
    if (field && this.form) {
      // console.log(field, field.name);
      const formControl = this.form.get(field.name);
      const value = formControl?.value;
      return value;
    }
    return null;
  }

  // Get field name from field_id using this.template variable
  getFieldNameFromFieldId(fieldId: string): string {
    if (!this.template || !this.template.folders) {
      return fieldId; // Return fieldId as fallback
    }

    // Search through all folders and forms to find the field with matching field_id
    for (const folder of this.template.folders) {
      if (folder.forms) {
        for (const form of folder.forms) {
          if (form.fields) {
            for (const field of form.fields) {
              // Check if field has id property and it matches the fieldId
              if (field.id === parseInt(fieldId)) {
                return field.name || fieldId; // Return field.name or fieldId as fallback
              }
              
              // Also check subFields for compound fields
              if (field.subFields) {
                for (const subField of field.subFields) {
                  if (subField.id === parseInt(fieldId)) {
                    return subField.name || fieldId; // Return subField.name or fieldId as fallback
                  }
                }
              }
            }
          }
        }
      }
    }
    return fieldId; // Return fieldId as fallback if not found
  }

  // Get field definition by field_id
  getFieldById(fieldId: string): any {
    if (!this.template || !this.template.folders) {
      return null;
    }

    // Search through all folders and forms to find the field with matching field_id
    for (const folder of this.template.folders) {
      if (folder.forms) {
        for (const form of folder.forms) {
          if (form.fields) {
            for (const field of form.fields) {
              // Check if field has id property and it matches the fieldId
              if (field.id === parseInt(fieldId)) {
                return field;
              }
              
              // Also check subFields for compound fields
              if (field.subFields) {
                for (const subField of field.subFields) {
                  if (subField.id === parseInt(fieldId)) {
                    return subField;
                  }
                }
              }
            }
          }
        }
      }
    }

    return null;
  }

  private parseTableHistoryValue(value: any): any[] {
    if (Array.isArray(value)) {
      return value;
    }

    if (value === null || value === undefined) {
      return [];
    }

    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed) {
        return [];
      }

      try {
        const parsed = JSON.parse(trimmed);
        return this.parseTableHistoryValue(parsed);
      } catch (error) {
        return [];
      }
    }

    if (typeof value === 'object') {
      return [value];
    }

    return [];
  }

  private buildTableHistoryColumns(field: any, rows: any[]): { key: string; title: string }[] {
    const columns: { key: string; title: string }[] = [];
    const existingKeys = new Set<string>();

    if (field?.columns?.length) {
      field.columns.forEach((column: any, index: number) => {
        // Skip Sr. No column for fixed-rows-table (row # is already shown in history table)
        if (column?.isSrNo || column?.name === '_sr_no') {
          return;
        }
        const key = column.name || `col_${index}`;
        const title = column.title || this.formatColumnTitle(key);
        if (!existingKeys.has(key)) {
          columns.push({ key, title });
          existingKeys.add(key);
        }
      });
    } else if (rows.length > 0) {
      Object.keys(rows[0]).forEach(key => {
        if (!['row_index', 'operation', 'existing_row_id', 'is_new_row', 'id'].includes(key)) {
          if (!existingKeys.has(key)) {
            columns.push({ key, title: this.formatColumnTitle(key) });
            existingKeys.add(key);
          }
        }
      });
    }

    const metadataKeys = ['operation'];
    metadataKeys.forEach(key => {
      if (rows.some(row => row[key] !== undefined)) {
        if (!existingKeys.has(key)) {
          columns.push({ key, title: this.formatColumnTitle(key) });
          existingKeys.add(key);
        }
      }
    });

    const operationIndex = columns.findIndex(col => col.key === 'operation');
    if (operationIndex > 0) {
      const [operationColumn] = columns.splice(operationIndex, 1);
      columns.unshift(operationColumn);
    }

    return columns;
  }

  private formatColumnTitle(key: string): string {
    return key
      .replace(/[_-]+/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase());
  }

  formatHistoryCellValue(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    if (typeof value === 'object') {
      try {
        return JSON.stringify(value);
      } catch (error) {
        return String(value);
      }
    }

    return String(value);
  }

  /**
   * Resolves field id from display/name within the **active** form only.
   * (Template-wide matching was wrong when multiple forms shared field names.)
   */
  getFieldIdFromFieldName(fieldName: string): string {
    return this.getFieldIdFromCurrentFormFieldName(fieldName);
  }

  getCommentFieldValue(fieldName: string, commentFieldName: string): any {
    // For comment fields, we need to store them separately
    const commentKey = `${fieldName}_${commentFieldName}`;
    return this.commentFields[commentKey] || '';
  }

  setCommentFieldValue(fieldName: string, commentFieldName: string, value: any): void {
    const commentKey = `${fieldName}_${commentFieldName}`;
    this.commentFields[commentKey] = value;
  }

  isCommentRequired(fieldName: string): boolean {
    const field = this.fields.find(f => f.name === fieldName);
    if (!field) return false;
    
    const fieldValue = this.getFieldValue(fieldName);
    return fieldValue === 'no';
  }

  shouldShowNavigation(field: any, navigationType: string): boolean {
    const fieldValue = this.getFieldValue(field.name);
    const titleLower = field.title.toLowerCase();
    switch (navigationType) {
      case 'adverse-events':
        return titleLower.includes('adverse event') && fieldValue === 'yes';
      case 'laboratory':
        return titleLower.includes('laboratory') && fieldValue === 'yes';
      case 'physical':
        return titleLower.includes('physical') && fieldValue === 'yes';
      case 'idrs':
        return titleLower.includes('idrs') && fieldValue === 'yes';
      default:
        return false;
    }
  }

  validateCommentFields(): boolean {
    let isValid = true;
    
    this.fields.forEach(field => {
      if (field.type === 'radio' && this.getFieldValue(field.name) === 'no') {
        // Check if comment is required and provided
        if (field.title.toLowerCase().includes('vital signs') && !field.title.toLowerCase().includes('baseline') && !field.title.toLowerCase().includes('follow') && !field.title.toLowerCase().includes('medicine')) {
          const commentKey = `${field.id}_vitalSignsComments`;
          if (!this.commentFields[commentKey] || this.commentFields[commentKey].trim() === '') {
            isValid = false;
          }
        } else if (field.title.toLowerCase().includes('physical') && !field.title.toLowerCase().includes('baseline') && !field.title.toLowerCase().includes('follow')) {
          const commentKey = `${field.id}_physicalExamComments`;
          if (!this.commentFields[commentKey] || this.commentFields[commentKey].trim() === '') {
            isValid = false;
          }
        } else if (field.title.toLowerCase().includes('idrs')) {
          const commentKey = `${field.id}_idrsAssessmentComments`;
          if (!this.commentFields[commentKey] || this.commentFields[commentKey].trim() === '') {
            isValid = false;
          }
        } else if (field.title.toLowerCase().includes('laboratory') && !field.title.toLowerCase().includes('baseline') && !field.title.toLowerCase().includes('follow')) {
          const commentKey = `${field.id}_labInvestigationComments`;
          if (!this.commentFields[commentKey] || this.commentFields[commentKey].trim() === '') {
            isValid = false;
          }
        } else if (field.title.toLowerCase().includes('baseline') && field.title.toLowerCase().includes('vital signs')) {
          const commentKey = `${field.id}_baselineVitalSignsComments`;
          if (!this.commentFields[commentKey] || this.commentFields[commentKey].trim() === '') {
            isValid = false;
          }
        } else if (field.title.toLowerCase().includes('baseline') && field.title.toLowerCase().includes('physical')) {
          const commentKey = `${field.id}_baselinePhysicalExamComments`;
          if (!this.commentFields[commentKey] || this.commentFields[commentKey].trim() === '') {
            isValid = false;
          }
        } else if (field.title.toLowerCase().includes('baseline') && field.title.toLowerCase().includes('laboratory')) {
          const commentKey = `${field.id}_baselineLabInvestigationComments`;
          if (!this.commentFields[commentKey] || this.commentFields[commentKey].trim() === '') {
            isValid = false;
          }
        } else if (field.title.toLowerCase().includes('follow') && field.title.toLowerCase().includes('vital signs')) {
          const commentKey = `${field.id}_followUpVitalSignsComments`;
          if (!this.commentFields[commentKey] || this.commentFields[commentKey].trim() === '') {
            isValid = false;
          }
        } else if (field.title.toLowerCase().includes('follow') && field.title.toLowerCase().includes('physical')) {
          const commentKey = `${field.id}_followUpPhysicalExamComments`;
          if (!this.commentFields[commentKey] || this.commentFields[commentKey].trim() === '') {
            isValid = false;
          }
        } else if (field.title.toLowerCase().includes('follow') && field.title.toLowerCase().includes('laboratory')) {
          const commentKey = `${field.id}_followUpLabInvestigationComments`;
          if (!this.commentFields[commentKey] || this.commentFields[commentKey].trim() === '') {
            isValid = false;
          }
                          } else if (field.title.toLowerCase().includes('medicine') && field.title.toLowerCase().includes('vital signs')) {
                    const commentKey = `${field.id}_medicineVitalSignsComments`;
                    if (!this.commentFields[commentKey] || this.commentFields[commentKey].trim() === '') {
                      isValid = false;
                    }
                  } else if (field.title.toLowerCase().includes('adverse event')) {
                    const commentKey = `${field.id}_adverseEventsComments`;
                    if (!this.commentFields[commentKey] || this.commentFields[commentKey].trim() === '') {
                      isValid = false;
                    }
                  } else if (field.title.toLowerCase().includes('concomitant medication')) {
                    const commentKey = `${field.id}_concomitantMedicationComments`;
                    if (!this.commentFields[commentKey] || this.commentFields[commentKey].trim() === '') {
                      isValid = false;
                    }
                  } else if (field.title.toLowerCase().includes('rescue medication')) {
                    const commentKey = `${field.id}_rescueMedicationComments`;
                    if (!this.commentFields[commentKey] || this.commentFields[commentKey].trim() === '') {
                      isValid = false;
                    }
                  } else if (field.title.toLowerCase().includes('prior medication')) {
                    const commentKey = `${field.id}_priorMedicationComments`;
                    if (!this.commentFields[commentKey] || this.commentFields[commentKey].trim() === '') {
                      isValid = false;
                    }
                  } else if (field.title.toLowerCase().includes('protocol deviation')) {
                    const commentKey = `${field.id}_protocolDeviationComments`;
                    if (!this.commentFields[commentKey] || this.commentFields[commentKey].trim() === '') {
                      isValid = false;
                    }
                  } else if (field.title.toLowerCase().includes('study completion')) {
                    const commentKey = `${field.id}_studyCompletionComments`;
                    if (!this.commentFields[commentKey] || this.commentFields[commentKey].trim() === '') {
                      isValid = false;
                    }
                  }
      }
    });
    
    return isValid;
  }

  confirmEditReason() {
    if (!this.editReason.trim()) {
      // Do not proceed without a reason; keep the modal open.
      return;
    }

    if (this.pendingRowEdit) {
      const { fieldName, rowIndex } = this.pendingRowEdit;
      const trimmedReason = this.editReason.trim();
      const displayLabel = this.pendingRowEditDisplayLabel || `Row ${rowIndex + 1}`;

      if (!this.tableRowEditReasons[fieldName]) {
        this.tableRowEditReasons[fieldName] = {};
      }
      this.tableRowEditReasons[fieldName][rowIndex] = trimmedReason;

      this.editableRowIndex = rowIndex;
      this.pendingRowEdit = null;
      this.pendingRowEditDisplayLabel = null;
      this.isReasonModalOpen = false;
      this.editReason = '';

      const currentData = this.getTableData(fieldName);
      this.trackTableChange(fieldName, currentData);
      return;
    }

    if (this.editReason.trim()) {
      // Get the field name from the label
      const fieldName = this.getFieldNameFromLabel(this.fieldLabel);
      const formId = this.currentForm?.id;
      const field_control_name = fieldName+"_"+parseInt(formId);
      
      console.log("Edit Reason Confirmed for field: ", this.fieldToUnlock);
      // Unlock the field with the provided reason
      this.unlockField(this.fieldToUnlock, this.editReason.trim());

      // Clear modal state
      this.isReasonModalOpen = false;
      this.editReason = '';
      this.fieldToUnlock = '';
    }
  }

  cancelEditReason() {
    this.isReasonModalOpen = false;
    this.editReason = '';
    if (this.pendingRowEdit) {
      this.pendingRowEdit = null;
    }
    this.pendingRowEditDisplayLabel = null;
  }

  // Edit fixed-rows-table row - prompt for reason and unlock row
  editFixedRowsTableRow(fieldName: string, rowIndex: number): void {
    const fieldDef = this.fields.find(f => f.name === fieldName);
    if (this.shouldBlockEditByLockFreeze(fieldDef)) {
      this.showLockFreezeMessage(this.getFieldLockFreezeStatus(fieldDef));
      return;
    }
    // Check if row is already editable
    if (this.editableRowIndex === rowIndex) {
      alert(`Row ${rowIndex + 1} is already unlocked for editing.`);
      return;
    }

    // If another row is being edited, inform the user
    if (this.editableRowIndex !== null && this.editableRowIndex !== rowIndex) {
      const confirmSwitch = confirm(`Row ${this.editableRowIndex + 1} is currently being edited. Do you want to switch to editing Row ${rowIndex + 1}?`);
      if (!confirmSwitch) {
        return;
      }
    }

    // Prompt for edit reason
    const reason = prompt(`Please provide a reason for editing Row ${rowIndex + 1}:`);
    
    if (reason && reason.trim()) {
      // Store the edit reason for this row
      if (!this.tableRowEditReasons[fieldName]) {
        this.tableRowEditReasons[fieldName] = {};
      }
      this.tableRowEditReasons[fieldName][rowIndex] = reason.trim();

      // Set this row as editable (this will lock other rows)
      this.editableRowIndex = rowIndex;

      // Track table changes
      const currentData = this.getTableData(fieldName);
      this.trackTableChange(fieldName, currentData);

      // Trigger change detection to update the UI
      this.cdr.detectChanges();

      // Show confirmation
      alert(`Row ${rowIndex + 1} is now unlocked for editing. Reason: ${reason.trim()}`);
    } else if (reason !== null) {
      // User clicked OK but didn't provide a reason
      alert('Please provide a reason for editing this row.');
    }
    // If reason is null, user clicked Cancel, so do nothing
  }

  closeModal() {
    this.isModalOpen = false;
    this.isOptionsModalOpen = false;
    this.showReviewModal = false; // Close review modal when options modal closes
  }

  closeReviewModal() {
    this.showReviewModal = false;
  }

  selectTab(index: number) {
    this.selectedTab = index;
    
    // Load field history data when Field History tab is selected
    if (index === 1 && this.tabs[index]?.type === 'fieldHistory') {
      this.loadFieldHistory();
    }
  }

private generateThreadIdAsNumber(): number {
  return Date.now() % 1000000000;
}

// New Getter to control New Query button
get isNewQueryDisabled(): boolean {
  // Only Monitor, Data Manager, and PI can create new queries
  if (!this.canCreateQuery()) {
    return true;
  }

  if (!this.queries || this.queries.length === 0) return true;

  const lastQuery = this.queries[0]; // New queries are unshifted to the top
  // Disable if the most recent query is a blank/unsent new query.
  // We check for auditTrail.length === 0 because an existing thread loaded from backend might have isSubmitted=false but a non-empty auditTrail.
  return lastQuery.auditTrail.length === 0 && !lastQuery.isSubmitted && !lastQuery.isClosed;
}

// Add Query: unshift to put at top, allocate a stable queryId
addQuery() {
  // Only Monitor, Data Manager, and PI can create queries
  if (!this.canCreateQuery()) {
    alert('You do not have permission to create new queries. You can only respond to existing queries.');
    return;
  }

  // The 'New Query' button is now enabled when the most recent query is submitted/closed.
  if (this.isNewQueryDisabled) {
    // Optional: Alert the user to submit/close the current one if it's completely new.
    return;
  }

  const userData = this.commonService.getUserData();
  const newQueryId = this.nextLocalQueryId++;
  this.queries.unshift({
    threadId: this.generateThreadId(),
    text: '',
    isClosed: false,
    isSubmitted: false,
    queryId: newQueryId,
    createdBy: userData?.id || null,
    auditTrail: []
  });

  this.selectedTab = 0;
}


// Submit uses query.queryId (not index)
confirmSubmitQuery(query: any, rowIndex?: any, event?: Event) {
 if (event) {
   event.stopPropagation();
   event.preventDefault();
 }

 if (!query || !query.text || !query.text.trim()) {
  alert('Please enter query text before submitting.');
  return;
 }

 const userData = this.commonService.getUserData();
 if (!userData) {
  alert('User data not available. Please login again.');
  return;
 }

 // CRO cannot respond to queries
 if (this.isUserCRO()) {
  alert('You do not have permission to respond to queries.');
  return;
 }

 const rowIdParam = this.getRowIdParam();
 const designation = userData?.designation || 'N/A';

 const queryData = {
  study_id: this.study_id,
  subject_id: this.subject_id,
  form_id: this.currentForm?.id || this.currentForm?.name || 'default',
  field_id: this.getActiveFieldIdForApi(this.fieldLabel) || 'unknown',
  row_id: rowIdParam,
  query_text: query.text,
  query_type: 'Data Query',
  query_status: 'Open',
  query_priority: 'Medium',
  query_assignee: null,
  query_created_by: userData?.id || null,
  query_id: query.queryId,
  designation: designation
 };

 this.apiService.submitTemplateQuery(queryData).subscribe({
  next: (response) => {
   query.isSubmitted = true;
   
   // Store creator information if not already set
   if (!query.createdBy) {
     query.createdBy = userData?.id || null;
   }
   
   // ⭐ FIX: Use unshift() to add the new entry to the START of the auditTrail array
   query.auditTrail.unshift({
    user: userData?.email || userData?.name || 'Unknown User',
    role: userData?.designation || 'User',
    timestamp: new Date().toISOString(),
    message: query.text
   });
   
   // Update field query status
   const fieldName = this.fieldLabel || 'Unknown Field';
   this.updateFieldQueryStatus(fieldName, this.currentRowIndex ?? undefined);
   
   query.text = '';
   alert('Query submitted successfully!');
  },
  error: (error) => {
   alert(error.error.message || 'Error submitting query. Please try again.');
  }
 });
}

canCloseQuery(query: any): boolean {
  if (!query) return false;
  const userData = this.commonService.getUserData();
  const role = (this.userRole || userData?.designation || '').toString().trim().toLowerCase();
  
  // CRC cannot close any queries
  if (role === 'crc') return false;

  // Cannot close already closed queries
  if (query.isClosed) return false;

  // ✅ Monitor & Data Manager can always close (except already-closed)
  if (role === 'monitor' || role === 'data manager') {
    return true;
  }

  // For all other roles, keep previous restrictions

  // Cannot close unsubmitted queries without audit trail
  if (!query.isSubmitted && (!query.auditTrail || query.auditTrail.length === 0)) return false;
  
  const currentUserId = userData?.id;
  if (!currentUserId) return false;
  
  // Check if this is a system-generated query (createdBy is null/undefined or query has no user creator)
  const isSystemGenerated = this.isSystemGeneratedQuery(query);
  
  // For system-generated queries: Allow Data Manager to close them
  if (isSystemGenerated) {
    const allowedRoles = ['data manager'];
    return allowedRoles.includes(role);
  }
  
  // For user-created queries: Only the creator can close it
  // Check if current user is the creator using createdBy field
  if (query.createdBy !== undefined && query.createdBy !== null) {
    return String(query.createdBy) === String(currentUserId); // Convert to string for reliable comparison
  }
  
  // Fallback: Check the auditTrail to find the creator
  // Since entries are added with unshift (newest first), the creator is the last entry (oldest)
  if (query.auditTrail && query.auditTrail.length > 0) {
    const creatorEntry = query.auditTrail[query.auditTrail.length - 1]; // Last entry is the first one created (oldest)
    const creatorEmail = creatorEntry?.user || '';
    const currentUserEmail = userData?.email || userData?.name || '';
    return creatorEmail === currentUserEmail;
  }
  
  return false;
}

/**
 * Determines if a query is system-generated (e.g., range validation queries)
 * System-generated queries typically have:
 * - createdBy is null/undefined
 * - No user-created audit trail entries
 * - Or specific indicators in the query text/audit trail
 */
private isSystemGeneratedQuery(query: any): boolean {
  // If createdBy is null or undefined, it's likely system-generated
  if (query.createdBy === null || query.createdBy === undefined) {
    return true;
  }
  
  // Check if audit trail exists but has no user entries (system entries only)
  if (query.auditTrail && query.auditTrail.length > 0) {
    // Check if the first entry (oldest) indicates system generation
    const firstEntry = query.auditTrail[query.auditTrail.length - 1];
    // System queries might have specific patterns in the message or role
    const message = (firstEntry?.message || '').toLowerCase();
    const role = (firstEntry?.role || '').toLowerCase();
    
    // Check for system indicators: range validation, system validation, etc.
    if (message.includes('range') || 
        message.includes('validation') || 
        message.includes('system') ||
        role === 'system' ||
        !firstEntry?.user) {
      return true;
    }
  }
  
  return false;
}

confirmCloseQuery(query: any) {
 const fieldId = this.getActiveFieldIdForApi(this.fieldLabel);
 const rowIdParam = this.getRowIdParam();

 if (!query) return;
 if (query.isClosed) return;
 if (!query.isSubmitted && (!query.auditTrail || query.auditTrail.length === 0)) return;

 // Only the creator of the query can close it
 if (!this.canCloseQuery(query)) {
   alert('You do not have permission to close this query. Only the person who created the query can close it.');
   return;
 }

 const userData = this.commonService.getUserData();
 const designation = userData?.designation || 'N/A';

const queryData = {
  field_id: fieldId,
  row_id: rowIdParam,
  query_id: query.queryId,
  designation: designation,
  closed_by: userData?.id || null,
  subject_id: this.subject_id
}
 const closeEntry = {
  user: userData?.email || userData?.name || 'Current User',
  role: userData?.designation || 'User',
  timestamp: new Date().toISOString(),
  message: 'Query closed'
 };

 this.apiService.closeTemplateQuery(queryData).subscribe({
  next: (response) => {
   // Update UI only after API call is successful
   query.isClosed = true;
   query.isSubmitted = true;
   // ⭐ Consistency: Use unshift() to add the close entry to the top as well
   query.auditTrail.unshift(closeEntry);
   
   // Update field query status
   const fieldName = this.fieldLabel || 'Unknown Field';
   this.updateFieldQueryStatus(fieldName, this.currentRowIndex ?? undefined);
   
   alert('Query closed successfully');
  },
  error: (error) => {
   alert('Failed to close query. Please try again.');
  }
 });
}

// Utility function (assuming it exists in your class)
getUserInitials(name: string): string {
    if (!name || name.trim() === '') return 'SY'; // System for system-generated validations
    const parts = name.split(' ');
    if (parts.length > 1) {
        return (parts[0][0] + parts[parts.length - 1][0]);
    }
    return name.substring(0, 2);
}

trackByAuditEntry(index: number, entry: any): any {
    return entry?.timestamp || entry?.user || index;
}


  // Check if user can toggle a specific review checkbox
  canToggleReviewCheckbox(type: 'dataManager' | 'monitor' | 'pi'): boolean {
    const role = this.userRole || this.currentUser?.designation || '';
    
    if (type === 'dataManager') {
      // Only Data Manager can toggle "Reviewed by Data Manager"
      return role === 'Data Manager';
    } else if (type === 'monitor') {
      // Only Monitor can toggle "Reviewed by Monitor"
      return role === 'Monitor';
    }
    // For PI checkbox, allow other roles (or implement specific logic if needed)
    return true;
  }

  onReviewCheckboxToggle(type: 'dataManager' | 'monitor' | 'pi', event: Event) {
    // Check if user has permission to toggle this checkbox
    if (!this.canToggleReviewCheckbox(type)) {
      event.preventDefault();
      const input = event.target as HTMLInputElement;
      input.checked = !input.checked; // Revert the change
      alert('You do not have permission to toggle this review checkbox.');
      return;
    }

    const input = event.target as HTMLInputElement;
    const nextValue = input.checked;
    const label =
      type === 'dataManager'
        ? 'Data Manager'
        : type === 'monitor'
        ? 'Monitor'
        : 'PI';

    const confirmed = confirm(`Are you sure you want to ${nextValue ? 'mark' : 'unmark'} "${label}" as reviewed?`);
    if (!confirmed) {
      // revert UI
      input.checked = !nextValue;
      return;
    }

    // Collect review comment/reason (backend accepts `review_reason` / `reason_for_change` / `comment` aliases).
    // For Monitor/Data Manager review, require a reason when marking reviewed.
    let reviewReason: string | null = null;
    if ((type === 'monitor' || type === 'dataManager') && nextValue) {
      const entered = prompt(`Enter reason for ${label} review`, '') ?? '';
      reviewReason = entered.trim() ? entered.trim() : null;
      if (!reviewReason) {
        // Revert UI if user cancels / leaves empty
        input.checked = !nextValue;
        alert('Review reason is required.');
        return;
      }
    }

    // Prepare API request data
    const studyId = this.study_id;
    const subjectId = this.subject_id;
    const formId = this.currentForm?.id || this.currentForm?.name || 'default';
    const reviewedBy = this.currentUser?.id || null;
    // Get user name from currentUser (may have first_name/last_name or other properties)
    const userData: any = this.currentUser || {};
    const reviewedByName = userData.first_name && userData.last_name 
      ? `${userData.first_name} ${userData.last_name}`.trim()
      : userData.name || userData.email || 'Unknown';
    
    // Get field_id from fieldLabel
    const fieldName = this.fieldLabel || 'Unknown Field';
    const fieldId = this.getActiveFieldIdForApi(fieldName);

    const reviewData = {
      study_id: studyId,
      subject_id: subjectId,
      form_id: formId,
      field_id: fieldId,
      review_type: type, // 'dataManager', 'monitor', or 'pi'
      is_reviewed: nextValue,
      reviewed_by: reviewedBy,
      reviewed_by_name: reviewedByName,
      review_reason: reviewReason
    };

    // Call API to update review status
    this.apiService.updateReviewStatus(reviewData).subscribe({
      next: (response) => {
        // Apply state only after successful API call
        if (type === 'dataManager') {
          this.reviewOptions.dataManager = nextValue;
        } else if (type === 'monitor') {
          this.reviewOptions.monitor = nextValue;
        } else {
          this.reviewOptions.pi = nextValue;
        }
      },
      error: (error) => {
        // Revert UI on error
        input.checked = !nextValue;
        alert('Failed to update review status. Please try again.');
      }
    });
  }

  // Close options modal when clicking outside
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.isOptionsModalOpen) {
      const target = event.target as HTMLElement;
      if (!target.closest('.options-modal') && !target.closest('.menu-icon')) {
        this.isOptionsModalOpen = false;
        this.showReviewModal = false; // Close review modal when options modal closes
      }
    }

    // Close any open kebab (3-dots) dropdowns when clicking outside
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown') && !target.closest('.dropdown-menu')) {
      this.closeAllBootstrapDropdowns();
    }
  }

  // --- Bootstrap dropdown (kebab menu) management ---
  private closeAllBootstrapDropdowns(): void {
    const openMenus = document.querySelectorAll('.dropdown-menu.show');
    openMenus.forEach(menu => menu.classList.remove('show'));

    const expandedButtons = document.querySelectorAll(
      '[data-bs-toggle="dropdown"][aria-expanded="true"]'
    );
    expandedButtons.forEach(btn => (btn as HTMLElement).setAttribute('aria-expanded', 'false'));
  }

  // Close any other open dropdown before Bootstrap processes the click to open the next one.
  onDropdownButtonClick(event: Event): void {
    const button = event.target as HTMLElement;
    const dropdownButton = button.closest('[data-bs-toggle="dropdown"]') as HTMLElement;
    if (!dropdownButton) return;

    const clickedParent = dropdownButton.closest('.dropdown');
    const openMenus = document.querySelectorAll('.dropdown-menu.show');

    openMenus.forEach(menu => {
      const parentDropdown = menu.closest('.dropdown');
      if (parentDropdown !== clickedParent) {
        menu.classList.remove('show');
        const menuButton = parentDropdown?.querySelector('[data-bs-toggle="dropdown"]') as HTMLElement;
        if (menuButton) menuButton.setAttribute('aria-expanded', 'false');
      }
    });
  }

  ensureDefaultFoldersExist() {
    if (!this.template.folders) {
      this.template.folders = [];
    }

    // Check if default folders exist, if not add them, if they exist update them with latest fields
    this.defaultFolders.forEach(defaultFolder => {
      const existingFolderIndex = this.template.folders.findIndex((folder: any) => 
        folder.name === defaultFolder.name
      );

      if (existingFolderIndex === -1) {
        // Folder doesn't exist, add it
        const templateFolder = this.convertDefaultFolderToTemplate(defaultFolder);
        this.template.folders.push(templateFolder);
      } else {
        // Folder exists, update it with latest forms and fields
        const existingFolder = this.template.folders[existingFolderIndex];
        this.syncFolderWithDefaults(existingFolder, defaultFolder);
      }
    });
    // this.saveTemplate();
  }

  syncFolderWithDefaults(existingFolder: any, defaultFolder: Folder) {
    // Update folder properties
    existingFolder.icon = defaultFolder.icon;
    existingFolder.color = defaultFolder.color;
    existingFolder.description = defaultFolder.description;
    existingFolder.title = defaultFolder.title;
    existingFolder.subTitle = defaultFolder.subTitle;

    // Sync forms
    defaultFolder.forms.forEach(defaultForm => {
      const existingFormIndex = existingFolder.forms.findIndex((form: any) => 
        form.name === defaultForm.name
      );

      if (existingFormIndex === -1) {
        // Form doesn't exist, add it
        const templateForm = this.convertDefaultFormToTemplate(defaultForm);
        existingFolder.forms.push(templateForm);
      } else {
        // Form exists, update it with latest fields
        const existingForm = existingFolder.forms[existingFormIndex];
        this.syncFormWithDefaults(existingForm, defaultForm);
      }
    });
  }

  syncFormWithDefaults(existingForm: any, defaultForm: Form) {
    // Update form properties
    existingForm.route = defaultForm.route;

    // Sync fields - replace all fields with default fields to ensure we have latest field definitions
    existingForm.fields = defaultForm.fields.map(defaultField => this.convertDefaultFieldToTemplate(defaultField));
  }

  convertDefaultFolderToTemplate(defaultFolder: Folder): any {
    const convertedFolder = {
      id: Date.now() + Math.random(),
      name: defaultFolder.name,
      icon: defaultFolder.icon,
      color: defaultFolder.color,
      description: defaultFolder.description,
      title: defaultFolder.title,
      subTitle: defaultFolder.subTitle,
      createdAt: new Date().toISOString(),
      forms: defaultFolder.forms.map(defaultForm => this.convertDefaultFormToTemplate(defaultForm))
    };
    return convertedFolder;
  }

  convertDefaultFormToTemplate(defaultForm: Form): any {
    const convertedForm = {
      id: Date.now() + Math.random(),
      name: defaultForm.name,
      route: defaultForm.route,
      createdAt: new Date().toISOString(),
      fields: defaultForm.fields.map(defaultField => this.convertDefaultFieldToTemplate(defaultField))
    };
    return convertedForm;
  }

  convertDefaultFieldToTemplate(defaultField: Field): any {
    const fieldName = defaultField.title.toLowerCase().replace(/\s+/g, '_');
    
    let convertedField: any = {
      title: defaultField.title,
      name: fieldName,
      type: this.mapFieldType(defaultField.type),
      required: defaultField.required,
      description: defaultField.description,
      attachmentRequired: false
    };

    if (defaultField.values && defaultField.values.length > 0) {
      convertedField.options = defaultField.values.map(v => v.value);
      convertedField.optionLabels = defaultField.values.map(v => v.label);
      convertedField.valueToLabelMap = {};
      defaultField.values.forEach(v => {
        convertedField.valueToLabelMap[v.value] = v.label;
      });
    }

    if (defaultField.unit) {
      convertedField.unit = defaultField.unit;
    }

    if (defaultField.fields && defaultField.fields.length > 0) {
      convertedField.subFields = defaultField.fields.map(subField => this.convertDefaultFieldToTemplate(subField));
    }

    // Table functionality will be recreated from scratch
    return convertedField;
  }

  mapFieldType(defaultType: string): string {
    const typeMapping: { [key: string]: string } = {
      'radio-button': 'radio',
      'dropdown': 'select',
      'date': 'date',
      'time': 'time',
      'number': 'number',
      'textarea': 'textarea',
      'checkbox-group': 'checkbox',
      'calculated': 'calculated',
      'compound': 'compound',
      'signature': 'esignature',
      'text': 'text',
    };

    return typeMapping[defaultType] || 'text';
  }

  isDefaultFolder(folderName: string): boolean {
    return this.defaultFolders.some(defaultFolder => defaultFolder.name === folderName);
  }

  onFolderClick(folder: any) {
    this.selectedFolderId = this.selectedFolderId === folder.id ? null : folder.id;
    this.selectedFolder = this.selectedFolder === folder.name ? null : folder.name;
  }

  /**
   * Clear previous form data when switching to a new form
   */
  private clearPreviousFormData(): void {
    // Preserve lock status before reset
    const preservedLockStatus = { ...this.fieldLockStatus };
    
    // Reset the form if it exists
    if (this.form) {
      this.form.reset();
    }
    
    // Restore lock status and re-disable locked fields
    this.fieldLockStatus = preservedLockStatus;
    Object.keys(preservedLockStatus).forEach(fieldName => {
      if (preservedLockStatus[fieldName]?.isLocked) {
        const formControl = this.form?.get(fieldName);
        if (formControl) {
          formControl.disable();
        }
      }
    });
    
    // Clear form values cache for cross-form dependencies
    this.formValuesCache = {};
    
    // Clear comment fields
    this.commentFields = {};
    
    // Clear any table rows data
    this.table_rows = [];
    
    // Clear attachment state
    this.selectedFiles = {};
    this.existingAttachments = {};
    
    // Clear any other form-related state
    this.editReason = '';
    this.fieldLabel = '';
    this.selectedModalFieldId = null;
    // Clear cached query highlight state when switching forms
    this.fieldQueryStatus = {};
    // Clear cached review status when switching forms
    this.fieldReviewStatus = {};
  }

  openForm(form: any) {
    // Clear previous form data before switching to new form
    this.clearPreviousFormData();
    
    this.currentForm = form;
    this.fields = form.fields || [];
    
    // Merge validation data from template into fields
    this.mergeValidationDataIntoFields();
    
    // Ensure all fields have Sr. No column for fixed-rows-table (frontend only)
    this.fields.forEach((field: any, index: number) => {
      if (field.type === 'fixed-rows-table') {
        this.ensureSrNoColumnForFixedRowsTable(field);
      }
    });
    
    
    this.buildForm();
    // console.log("Form Buidled");
    this.selectedForm = form.name;
    this.persistLastOpenedForm(form);
    // Populate form with existing data if available
    // this.populateFormWithExistingData(form);
    this.populateFormWithExistingData(form);
    
    // Disable all form controls if user is Monitor, Data Manager, or CRO (after data is populated)
    if (this.isFieldDisabledUser()) {
      this.disableAllFormControls();
    }
    
    // CRC and PI can edit all fields regardless of query status
    
    // Process and setup dependencies for the current form
    this.setupFormDependencies(form);
    
    // Set up dependency field listeners for existing fields
    this.setupDependencyFieldListeners();
    
    // Initialize form values cache for cross-form dependencies
    this.initializeFormValuesCache();

    // Fetch lock/freeze status from locked_data for this form
    this.fetchLockedDataForCurrentForm();

    // Prefetch review status so Monitor/Data Manager review icons show for all users as soon as the form is opened
    this.prefetchReviewStatusesForCurrentForm();
  }

  buildForm(): void {
    const group: any = {};
      for (const field of this.fields) {
        // Skip form control creation for instruction and title fields (display-only)
        if (field.type === 'instruction' || field.type === 'title') {
          continue;
        }
        
        const baseValidators = field.required ? [Validators.required] : [];

        if (field.type === 'checkbox') {
          const checkboxValidators = field.required ? [this.atLeastOneSelectedValidator()] : [];
          group[field.name] = [[], checkboxValidators];
        } else if (field.type === 'esignature' || field.type === 'signature') {
          group[field.name] = ['', baseValidators];
        } else if (field.type === 'number') {
          group[field.name] = [null, baseValidators];
        } else if (field.type === 'calculated') {
          group[field.name] = ['', []]; // Calculated fields are read-only, no validation needed
        } else if (field.type === 'compound') {
          if (field.subFields) {
            field.subFields.forEach((subField: any) => {
              const subValidators = subField.required ? [Validators.required] : [];
              group[subField.name] = [null, subValidators];
            });
          }
        } else if (field.type === 'table' || field.type === 'fixed-rows-table') {
          // Simplified table implementation - just array of objects
          // For table fields, we use custom validation that doesn't interfere with form submission
          const tableValidators = field.required ? [this.tableRequiredValidator()] : [];
          group[field.name] = [[], tableValidators];
        } else {
          group[field.name] = ['', baseValidators];
        }

        if (field.attachmentRequired) {
          group[field.name + '_attachments'] = ['', field.required ? [Validators.required] : []];
        }
        // Auto-created converted value field (read-only) when conversion is configured
        if (field.conversionRequired) {
          const convertedName = `${field.name}_converted`;
          group[convertedName] = [null, []];
        }
      }

    // Add comment fields to the form
    Object.keys(this.commentFields).forEach(commentKey => {
      group[commentKey] = [this.commentFields[commentKey] || '', []]; // No validation for comment fields
    });

    this.form = this.fb.group(group);
    
    // Add value change listeners for debugging
    this.form.valueChanges.subscribe(values => {
    });
    
    // Add individual control listeners for all fields to trigger dependency updates and calculations
    this.fields.forEach(field => {
      if (this.form.get(field.name)) {
        this.form.get(field.name)?.valueChanges.subscribe(value => {
          // console.log(`Field "${field.title}" (${field.name}) value changed to:`, value);
          
          // Check for cross-form dependencies
          this.checkCrossFormDependencies(field.name, value);
          
          // Trigger calculations for specific field types
          this.onFieldValueChange(field, value);

          // Update converted value, if configured
          if (field.conversionRequired) {
            const convertedControl = this.form.get(`${field.name}_converted`);
            if (convertedControl) {
              const converted = this.convertFieldValue(field, value);
              if (converted == null) {
                convertedControl.setValue(null, { emitEvent: false });
              } else {
                const rounded = Number(parseFloat(String(converted)).toFixed(6));
                convertedControl.setValue(rounded, { emitEvent: false });
              }
            }
          }
          
          // Check validation for this field and dependent fields when value changes
          // Use getRawValue() so disabled controls (e.g. calculated Age) are included
          setTimeout(() => {
            this.checkFieldValidations(this.getFormValuesForValidation());
          }, 100); // Small delay to ensure form values are updated
          
          // Trigger change detection for dependency fields
          this.cdr.detectChanges();
        });
      }
    });
    
    // Set up dependency field listeners
    this.setupDependencyFieldListeners();
    
    // Set up listeners for any dependency fields that exist in the current form
    this.setupCurrentFormDependencyListeners();
    
    // Disable all form controls if user is Monitor, Data Manager, or CRO
    if (this.isFieldDisabledUser()) {
      this.disableAllFormControls();
    }
    
    // CRC and PI can edit all fields regardless of query status
  }

  private convertFieldValue(field: any, rawValue: any): number | null {
    if (!field || !field.conversionRequired) {
      return null;
    }
    const value = typeof rawValue === 'number' ? rawValue : parseFloat(rawValue);
    if (isNaN(value)) {
      return null;
    }
    const type = (field.conversionType || '').toLowerCase();
    const from = (field.conversionFromUnit || '').toLowerCase();
    const to = (field.conversionToUnit || '').toLowerCase();
    if (!type || !from || !to || from === to) {
      return null;
    }

    if (type === 'weight') {
      const toKg: { [unit: string]: number } = {
        kilogram: 1,
        gram: 0.001,
        milligram: 1e-6,
        microgram: 1e-9,
        nanogram: 1e-12,
        picogram: 1e-15,
        femtogram: 1e-18,
        hectogram: 0.1,
        decagram: 0.01,
        tonne: 1000,
        kilotonne: 1_000_000,
        megatonne: 1_000_000_000,
        carat_metric: 0.0002,
        pound: 0.45359237,
        ounce: 0.028349523125,
        stone: 6.35029318,
        hundredweight: 50.80234544,
        ton_uk_long: 1016.0469088,
        ton_us_short: 907.18474,
        slug: 14.59390294,
        grain: 0.00006479891,
        ounce_troy: 0.0311034768,
        pound_troy: 0.3732417216,
        earth_mass: 5.9722e24,
        solar_mass: 1.98847e30
      };
      if (!toKg[from] || !toKg[to]) {
        return null;
      }
      const valueInKg = value * toKg[from];
      const result = valueInKg / toKg[to];
      return Number.isFinite(result) ? result : null;
    }

    if (type === 'length') {
      const toMeters: { [unit: string]: number } = {
        m: 1,
        cm: 0.01,
        dm: 0.1,
        mm: 0.001,
        um: 1e-6,
        nm: 1e-9,
        pm: 1e-12,
        hm: 100,
        km: 1000,
        in: 0.0254,
        ft: 0.3048,
        ft_us_survey: 1200 / 3937,
        yd: 0.9144,
        mile: 1609.344,
        mil: 0.0000254,
        thou: 0.0000254,
        barleycorn: 0.0254 / 3,
        chain_survey: 20.11684023368064,
        furlong: 201.168,
        hand: 0.1016,
        fathom: 1.8288,
        ell_uk: 1.143,
        cable: 185.2,
        nmi_int: 1852,
        nmi_uk: 1853.184,
        angstrom: 1e-10,
        au: 149_597_870_700,
        ly: 9_460_730_472_580_800,
        parsec: 30_856_775_814_913_673
      };
      if (!toMeters[from] || !toMeters[to]) {
        return null;
      }
      const valueInMeters = value * toMeters[from];
      const result = valueInMeters / toMeters[to];
      return Number.isFinite(result) ? result : null;
    }

    if (type === 'temperature') {
      const toCelsius = (val: number, unit: string): number | null => {
        switch (unit) {
          case 'c':
          case 'celsius':
            return val;
          case 'f':
          case 'fahrenheit':
            return (val - 32) * (5 / 9);
          case 'k':
          case 'kelvin':
            return val - 273.15;
          case 'rankine':
          case 'r':
            return (val - 491.67) * (5 / 9);
          case 'reaumur':
            return val * (5 / 4);
          default:
            return null;
        }
      };
      const fromCelsius = (valC: number, unit: string): number | null => {
        switch (unit) {
          case 'c':
          case 'celsius':
            return valC;
          case 'f':
          case 'fahrenheit':
            return valC * (9 / 5) + 32;
          case 'k':
          case 'kelvin':
            return valC + 273.15;
          case 'rankine':
          case 'r':
            return (valC + 273.15) * (9 / 5);
          case 'reaumur':
            return valC * (4 / 5);
          default:
            return null;
        }
      };
      const valueInC = toCelsius(value, from);
      if (valueInC == null) {
        return null;
      }
      const result = fromCelsius(valueInC, to);
      return result != null && Number.isFinite(result) ? result : null;
    }

    if (type === 'time') {
      const toSeconds: { [unit: string]: number } = {
        femtosecond: 1e-15,
        picosecond: 1e-12,
        nanosecond: 1e-9,
        microsecond: 1e-6,
        millisecond: 1e-3,
        shake: 1e-8,
        second: 1,
        minute: 60,
        hour: 3600,
        day: 86400,
        week: 604800,
        fortnight: 1209600,
        month_common: 365.25 * 86400 / 12,
        month_synodic: 29.530588853 * 86400,
        quarter_common: (365.25 * 86400 / 12) * 3,
        year_common: 365 * 86400,
        year_avg_gregorian: 365.2425 * 86400,
        year_julian: 365.25 * 86400,
        year_leap: 366 * 86400,
        year_tropical: 365.24219 * 86400,
        decade: 10 * 365.2425 * 86400,
        century: 100 * 365.2425 * 86400,
        millennium: 1000 * 365.2425 * 86400
      };
      if (!toSeconds[from] || !toSeconds[to]) {
        return null;
      }
      const valueInSeconds = value * toSeconds[from];
      const result = valueInSeconds / toSeconds[to];
      return Number.isFinite(result) ? result : null;
    }

    if (type === 'volume') {
      const toLiters: { [unit: string]: number } = {
        liter: 1,
        liter_1901_1964: 1.000028,
        kiloliter: 1000,
        milliliter: 0.001,
        microliter: 1e-6,
        nanoliter: 1e-9,
        picoliter: 1e-12,
        deciliter: 0.1,
        cubic_millimeter: 1e-6,
        fluid_ounce_us: 0.0295735295625,
        fluid_ounce_imperial: 0.0284130625,
        cup: 0.2365882365,
        pint_us_liquid: 0.473176473,
        pint_us_dry: 0.5506104713575,
        pint_imperial: 0.56826125,
        quart_us_liquid: 0.946352946,
        quart_us_dry: 1.101220942715,
        quart_imperial: 1.1365225,
        gallon_us_liquid: 3.785411784,
        gallon_us_dry: 4.40488377086,
        gallon_imperial: 4.54609,
        dram_us: 0.0036966911953125,
        dram_imperial: 0.0035516328125,
        gill_us: 0.11829411825,
        gill_imperial: 0.1420653125,
        cubic_yard: 764.554857984
      };
      if (!toLiters[from] || !toLiters[to]) {
        return null;
      }
      const valueInLiters = value * toLiters[from];
      const result = valueInLiters / toLiters[to];
      return Number.isFinite(result) ? result : null;
    }

    return null;
  }
  
  // Disable all form controls programmatically
  disableAllFormControls(): void {
    if (!this.form) return;
    
    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      if (control) {
        control.disable();
      }
    });
  }








  deleteField(index: number): void {
    const field = this.fields[index];
    
    this.fields.splice(index, 1);
    this.form.removeControl(field.name);
    this.form.removeControl(field.name + '_attachments');
    
    this.saveFormFields();
  }

  // File handling
  onFileSelected(event: any, fieldName: string): void {
    const files = event.target.files as FileList | null;
    if (files && files.length > 0) {
      const existing = this.selectedFiles[fieldName] || [];
      const combined = [...existing, ...Array.from(files)];
      const uniqueByKey = new Map<string, File>();
      for (const file of combined) {
        const key = `${file.name}_${file.size}_${file.lastModified}`;
        if (!uniqueByKey.has(key)) {
          uniqueByKey.set(key, file);
        }
      }
      const allFiles = Array.from(uniqueByKey.values());
      const MAX_FILES_PER_FIELD = 5;
      if (allFiles.length > MAX_FILES_PER_FIELD) {
        // Keep only first MAX_FILES_PER_FIELD files and optionally notify user
        this.selectedFiles[fieldName] = allFiles.slice(0, MAX_FILES_PER_FIELD);
        alert(`You can attach a maximum of ${MAX_FILES_PER_FIELD} files to this field.`);
      } else {
        this.selectedFiles[fieldName] = allFiles;
      }
      this.form.get(fieldName + '_attachments')?.setValue(this.selectedFiles[fieldName]);
    } else {
      this.selectedFiles[fieldName] = [];
      this.form.get(fieldName + '_attachments')?.setValue('');
    }
  }

  removeFile(fieldName: string, index: number): void {
    if (this.selectedFiles[fieldName]) {
      this.selectedFiles[fieldName].splice(index, 1);
      if (this.selectedFiles[fieldName].length === 0) {
        this.form.get(fieldName + '_attachments')?.setValue('');
      }
    }
  }

  getFileIcon(fileName: string): string {
    const extension = fileName.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'pdf':
        return 'fa fa-file-pdf-o';
      case 'doc':
      case 'docx':
        return 'fa fa-file-word-o';
      case 'xls':
      case 'xlsx':
        return 'fa fa-file-excel-o';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return 'fa fa-file-image-o';
      default:
        return 'fa fa-file-o';
    }
  }

  // Method to open/view attached files
  openFile(file: File): void {
    if (!file) {
      return;
    }

    const fileUrl = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = fileUrl;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => {
      URL.revokeObjectURL(fileUrl);
    }, 1000);
  }

  // Method to download attached files
  downloadFile(file: File): void {
    if (!file) {
      return;
    }

    // Create a URL for the file
    const fileUrl = URL.createObjectURL(file);
    
    // Create a temporary anchor element to trigger download
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = file.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Clean up the URL
    URL.revokeObjectURL(fileUrl);
  }

  openExistingAttachment(fieldName: string, attachment: ExistingAttachment): void {
    if (!attachment) {
      return;
    }

    if (!attachment.url) {
      alert('Attachment URL is not available. Please reload the form or contact support.');
      return;
    }

    const link = document.createElement('a');
    link.href = attachment.url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downloadExistingAttachment(fieldName: string, attachment: ExistingAttachment): void {
    if (!attachment) {
      return;
    }

    if (!attachment.url) {
      alert('Attachment URL is not available. Please reload the form or contact support.');
      return;
    }

    const link = document.createElement('a');
    link.href = attachment.url;
    link.download = attachment.name || 'attachment';
    link.rel = 'noopener noreferrer';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // Options editing


  toggleCheckbox(fieldName: string, option: string, checked: boolean): void {
    const control = this.form.controls[fieldName] || this.form.get(fieldName);
    if (!control) return;
    const raw = control.value;
    let current: string[];
    if (Array.isArray(raw)) {
      current = raw.map(v => (typeof v === 'string' ? v : String(v)));
    } else if (typeof raw === 'string' && raw.trim()) {
      try {
        const parsed = JSON.parse(raw);
        current = Array.isArray(parsed) ? parsed.map((v: any) => String(v)) : [];
      } catch {
        current = raw.split(',').map((s: string) => s.trim()).filter(Boolean);
      }
    } else {
      current = [];
    }
    if (checked) {
      if (!current.includes(option)) current.push(option);
    } else {
      const idx = current.indexOf(option);
      if (idx !== -1) current.splice(idx, 1);
    }
    control.setValue(current);
    control.markAsTouched();
  }

  private atLeastOneSelectedValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const value = control.value;
      if (Array.isArray(value) && value.length > 0) return null;
      return { required: true };
    };
  }

  async onSubmit(): Promise<void> {
    // Check for pending table changes
    const pendingTableChanges = this.getPendingTableChangesCount();
    if (pendingTableChanges > 0) {
    } else {
    }
    const hasDataToSubmit = await this.submitFormData();
    if (!hasDataToSubmit) {
      return;
    }
    // NOTE: Do not reload form data immediately here - it will be reloaded after successful submission
    // to ensure we get the latest data from the backend, not stale cached data

    // Process and setup dependencies for the current form
    this.setupFormDependencies(this.currentForm);
    
    // Set up dependency field listeners for existing fields
    this.setupDependencyFieldListeners();
    
    // Initialize form values cache for cross-form dependencies
    this.initializeFormValuesCache();
    
    // if (this.form.valid) {
    //   // console.log('Form submitted:', this.form.value);
    //   this.submitFormData();
    // } else {
    //   this.markFormGroupTouched();
    //   // Debug: Use the helper method for detailed validation info
    //   this.debugFormValidation();
    // }
  }

  private async submitFormData(): Promise<boolean> {
    // Check if we have valid study_crc_id
    if (!this.currentForm) {
      alert('Missing required data for submission. Please refresh and try again.');
      return false;
    }

    // Get user data for submission
    const userData = this.commonService.getUserData();
    if (!userData) {
      alert('User data not available. Please login again.');
      return false;
    }

    // Get PI check value for the current form - ensure it's always a boolean
    const piCheckValue = !!this.getPiSignatureReviewed();
    
    // Determine if user is PI - use the method that checks cookies directly
    const isPI = this.isUserPI();
    
    // Check if PI review status has changed (for PI users)
    // We need to allow submission even if only PI review status changed
    const currentHash = this.computeFormHash();
    const hasFormDataChanges = !this.initialFormDataHash || this.initialFormDataHash !== currentHash;
    
    // If user is PI and has checked the review, we should allow submission even without other changes
    const shouldSubmitPiReview = isPI && piCheckValue;
    
    // Short-circuit only if nothing has changed AND it's not a PI review submission
    if (!hasFormDataChanges && !shouldSubmitPiReview) {
      alert('No changes detected.');
      return false;
    }
    // Collect form data and prepare submission payload (include disabled controls for validation and payload)
    const formValues = this.getFormValuesForValidation();
    const submissionData: any[] = [];

    // Check validation for all fields before submission
    await this.checkFieldValidations(formValues);

    // Process each field in the current form
    for (const field of this.fields) {
      const fieldValue = formValues[field.name];
      
      // For table fields, only submit if there are pending changes
      let finalFieldValue = fieldValue;
      if (field.type === 'table' || field.type === 'fixed-rows-table') {
        const hasPendingChanges = this.tableChangeTracker[field.name]?.hasChanges;
        if (!hasPendingChanges) {
          continue;
        }
        // Use the formatted data from tableChangeTracker instead of raw form data
        const formattedTableData = this.tableChangeTracker[field.name]?.data;
        if (formattedTableData) {
          // Use the properly formatted data with operation types
          finalFieldValue = formattedTableData;
          // Debug: Check for dropdown values in the formatted data
          if (Array.isArray(formattedTableData)) {
            formattedTableData.forEach((row: any, rowIndex: number) => {
              Object.keys(row).forEach(key => {
                if (key !== 'row_index' && key !== 'operation' && key !== 'is_new_row' && key !== 'existing_row_id') {
                }
              });
            });
          }
        }
      }
      
      // Skip empty values unless field is required
      const hasData = finalFieldValue !== null && 
                     finalFieldValue !== undefined && 
                     finalFieldValue !== '' && 
                     (typeof finalFieldValue !== 'string' || finalFieldValue.trim() !== '') &&
                     (!Array.isArray(finalFieldValue) || finalFieldValue.length > 0);
      
      if (!hasData) {
        if (field.required) {
        }
        continue;
      }

      const attachmentPayload = await this.prepareAttachmentPayload(field.name);

      // Create submission data structure
      const formattedValue = this.formatFieldValue(field, finalFieldValue);
      const subData = this.getSubData(field, formValues, attachmentPayload);
      
      // Debug: Log dropdown values in submission data
      if (field.type === 'table' || field.type === 'fixed-rows-table') {
        // If the value is a JSON string, parse it to check dropdown values
        if (typeof formattedValue === 'string') {
          try {
            const parsedValue = JSON.parse(formattedValue);
            if (Array.isArray(parsedValue)) {
              parsedValue.forEach((row: any, rowIndex: number) => {
                Object.keys(row).forEach(key => {
                  if (key !== 'row_index' && key !== 'operation' && key !== 'is_new_row' && key !== 'existing_row_id') {
                  }
                });
              });
            }
          } catch (error) {
          }
        }
      }
      
      const fieldData: any = {
        study_id: this.study_id,
        subject_id: this.subject_id, 
        form_id: this.currentForm.id || this.currentForm.name,
        field_id: field.id || field.name,
        is_table: (field.type === 'table' || field.type === 'fixed-rows-table') ? true : false,
        value: formattedValue,
        sub_data: subData,
        updated_by: userData.id,
        // Provide a consistent timestamp for backend history/audit (especially table/fixed-rows-table)
        updated_at: new Date().toISOString(),
        edit_reason: this.fieldEditReasons[field.name] || null,
        // Include PI check only if user is PI, otherwise default to false - always boolean
        pi_check: isPI ? !!piCheckValue : false
      };

      if (attachmentPayload && attachmentPayload.length > 0) {
        // Send full attachments array to backend for multi-attachment support
        fieldData.documents = attachmentPayload;
      }

      submissionData.push(fieldData);
    }

    // Handle comment fields
    Object.keys(this.commentFields).forEach(commentKey => {
      const commentValue = this.commentFields[commentKey];
      if (commentValue && commentValue.trim() !== '') {
        const [fieldName, commentType] = commentKey.split('_');
        const field = this.fields.find(f => f.name === fieldName);
        
        if (field) {
          const commentData = {
            study_id: this.study_crc_id,
            subject_id: this.study_crc_id,
            form_id: this.currentForm.id || this.currentForm.name,
            field_id: `${field.id || field.name}_comment`,
            value: commentValue,
            sub_data: JSON.stringify({ comment_type: commentType }),
            updated_by: userData.id,
            pi_check: isPI ? !!piCheckValue : false
          };
          submissionData.push(commentData);
        }
      }
    });
    
    // If user is PI and has checked the review, but there are no form fields to submit,
    // we need to submit at least one field to carry the PI review status
    if (isPI && piCheckValue && submissionData.length === 0) {
      if (this.fields.length > 0) {
        // Try to find a field with a value first, otherwise use the first field
        let fieldToSubmit = this.fields.find(field => {
          const value = formValues[field.name];
          return value !== null && 
                 value !== undefined && 
                 value !== '' && 
                 (typeof value !== 'string' || value.trim() !== '') &&
                 (!Array.isArray(value) || value.length > 0);
        });
        
        // If no field has a value, use the first field
        if (!fieldToSubmit) {
          fieldToSubmit = this.fields[0];
        }
        
        const fieldValue = formValues[fieldToSubmit.name];
        const formattedValue = this.formatFieldValue(fieldToSubmit, fieldValue);
        const attachmentPayload = await this.prepareAttachmentPayload(fieldToSubmit.name);
        const subData = this.getSubData(fieldToSubmit, formValues, attachmentPayload);
        
        const piReviewCarrierData: any = {
          study_id: this.study_id,
          subject_id: this.subject_id,
          form_id: this.currentForm.id || this.currentForm.name,
          field_id: fieldToSubmit.id || fieldToSubmit.name,
          is_table: (fieldToSubmit.type === 'table' || fieldToSubmit.type === 'fixed-rows-table') ? true : false,
          value: formattedValue,
          sub_data: subData,
          updated_by: userData.id,
          edit_reason: null,
          pi_check: true // This is the key - PI review status
        };
        
        if (attachmentPayload && attachmentPayload.length > 0) {
          piReviewCarrierData.documents = attachmentPayload;
        }
        
        submissionData.push(piReviewCarrierData);
      } else {
        // No fields in form - create a special PI review entry
        const piReviewOnlyData: any = {
          study_id: this.study_id,
          subject_id: this.subject_id,
          form_id: this.currentForm.id || this.currentForm.name,
          field_id: 'pi_review_status',
          is_table: false,
          value: 'pi_reviewed',
          sub_data: JSON.stringify({ pi_review: true }),
          updated_by: userData.id,
          edit_reason: null,
          pi_check: true
        };
        submissionData.push(piReviewOnlyData);
      }
    }
    
    // Submit data to backend
    if (submissionData.length > 0) {
      this.apiService.submitTemplateFormData(submissionData).subscribe({
        next: (response) => {
          alert('Form data submitted successfully!');
          window.location.reload();
          
          // Disable all table rows after successful submission
          this.isTableDisabled = true;
          this.editableRowIndex = null; // Clear any active row editing
          
          // Clear table_rows cache before reloading to ensure fresh data
          this.table_rows = [];
          
          // Reload form data from API after successful submission to get the latest data
          // This ensures we have the correct data format from the backend
          if (this.currentForm) {
            // Load form data from API - this will properly populate table data
            this.loadFormDataFromAPI(this.currentForm);
            
            // Update table tracking after form data is reloaded
            // Use a small delay to ensure the async API call completes
            setTimeout(() => {
              this.fields.forEach(field => {
                if (field.type === 'table' || field.type === 'fixed-rows-table') {
                  const currentData = this.form.get(field.name)?.value;
                  if (Array.isArray(currentData)) {
                    this.originalTableData[field.name] = JSON.parse(JSON.stringify(currentData));
                    // Mark table changes as submitted
                    if (this.tableChangeTracker[field.name]) {
                      this.tableChangeTracker[field.name].hasChanges = false;
                    }
                    this.clearTableRowReasons(field.name);
                  }
                }
              });
              
              // Populate fixed-rows-table statement when empty (e.g. after reload with no rows)
              this.populateFixedRowsTableFromValue();
            }, 1000);
          }
          
          // Lock only fields that were actually submitted with meaningful data
          const submittedFieldNames = submissionData
            .filter(data => {
              const value = data.value;
              return value !== null && 
                     value !== undefined && 
                     value !== '' && 
                     (typeof value !== 'string' || value.trim() !== '') &&
                     (!Array.isArray(value) || value.length > 0);
            })
            .map(data => {
              // Try to find field by ID first (convert to number for comparison)
              let field = this.fields.find(f => {
                const fieldIdNum = typeof f.id === 'number' ? f.id : parseInt(f.id);
                const dataFieldIdNum = typeof data.field_id === 'number' ? data.field_id : parseInt(data.field_id);
                return fieldIdNum === dataFieldIdNum;
              });
              
              // If not found by ID, try by name
              if (!field) {
                field = this.fields.find(f => f.name === data.field_id);
              }
              
              // If still not found, try to find by matching field_id from template
              if (!field && this.template) {
                const templateField = this.getFieldById(String(data.field_id));
                if (templateField) {
                  field = this.fields.find(f => f.title === templateField.title && f.type === templateField.type);
                }
              }
              
              return field ? field.name : null;
            })
            .filter(name => name !== null);
          
          if (submittedFieldNames.length > 0) {
            this.lockFields(submittedFieldNames, `${userData.first_name} ${userData.last_name}`);
          }
        },
        error: (error) => {
          alert('Error submitting form data. Please try again.');
        }
      });
      return true;
    } else {
      // Avoid noisy alerts when nothing was collected; simply stop submission
      this.markFormGroupTouched();
      return false;
    }
  }

  // Merge validation data from template into fields
  private mergeValidationDataIntoFields(): void {
    if (!this.template || !this.template.folders || !this.fields) {
      return;
    }

    // Loop through all folders and forms in template to find validation data
    this.template.folders.forEach((folder: any) => {
      if (folder.forms && Array.isArray(folder.forms)) {
        folder.forms.forEach((templateForm: any) => {
          if (templateForm.fields && Array.isArray(templateForm.fields)) {
            templateForm.fields.forEach((templateField: any) => {
              // Find matching field in current form by ID
              const matchingField = this.fields.find(f => 
                f.id === templateField.id || 
                String(f.id) === String(templateField.id)
              );
              
              if (matchingField && templateField && templateField.validation) {
                const tplValidation = templateField.validation;
                const hasRangeValidation =
                  tplValidation &&
                  tplValidation.validationType === 'range-limit-check';

                // Treat any field that has a range-limit-check config as validated,
                // even if hasValidation flag was not set correctly on older records.
                if (templateField.hasValidation || hasRangeValidation) {
                  matchingField.hasValidation = true;
                  matchingField.validation = { ...tplValidation };
                }
              }
            });
          }
        });
      }
    });
  }

  /**
   * Returns form values including disabled controls (e.g. calculated Age field).
   * Angular's form.value excludes disabled controls, so range validation would never see Age.
   * Also syncs calculated Age from DOB so range check sees the current value.
   */
  private getFormValuesForValidation(): any {
    if (!this.form) {
      return {};
    }
    this.updateAge(); // Ensure Age (and other calculated fields) are current before validation
    return typeof this.form.getRawValue === 'function'
      ? this.form.getRawValue()
      : this.form.value;
  }

  // Helper method to check if form values have any meaningful data
  private hasFormValues(formValues: any): boolean {
    if (!formValues || Object.keys(formValues).length === 0) {
      return false;
    }

    // Check if any form value is non-empty
    return Object.values(formValues).some(value => {
      if (value === null || value === undefined || value === '') {
        return false;
      }
      if (typeof value === 'string' && value.trim() === '') {
        return false;
      }
      if (Array.isArray(value) && value.length === 0) {
        return false;
      }
      return true;
    });
  }

  // Check field validations and raise queries for dependent fields with range limits
  private async checkFieldValidations(formValues: any): Promise<void> {
    console.log('🔍 checkFieldValidations called with formValues:', formValues);
    if (!this.template || !this.template.folders) {
      console.log('No template or folders, returning');
      return;
    }

    // Early return if formValues is empty or all values are empty
    if (!this.hasFormValues(formValues)) {
      console.log('All form values are empty, skipping validation');
      return;
    }

    // Loop through all fields in the current form
    for (const field of this.fields) {
      // Skip fields that don't have any validation config at all
      if (!field || !field.validation) {
        continue;
      }

      const validation = field.validation;

      // Backward compatibility: if a field has a range-limit-check validation
      // object but the hasValidation flag was not set (older templates),
      // enable validation for this field.
      if (!field.hasValidation && validation.validationType === 'range-limit-check') {
        field.hasValidation = true;
      }

      // Check if field has validation configured
      if (!field.hasValidation) {
        continue;
      }
      
      // Only process range-limit-check validations
      if (validation.validationType !== 'range-limit-check') {
        continue;
      }
      
      console.log('Processing validation for field:', field.name || field.title, 'validationType:', validation.validationType, 'fieldSelection:', validation.fieldSelection);

      let shouldValidate = false;

      // Check if validation is for this field directly
      if (validation.fieldSelection === 'this-field') {
        shouldValidate = true;
      }
      // Check if validation is for dependent field
      else if (validation.fieldSelection === 'dependent-field') {
        console.log('📋 Checking dependency condition for field:', field.name || field.title);
        // Get dependency information
        const dependency = validation.dependency;
        if (!dependency || !dependency.fieldId) {
          console.log('SKIPPING: No dependency or fieldId');
          continue;
        }

        // Get the dependency field from template
        const dependencyField = this.getFieldById(String(dependency.fieldId));
        if (!dependencyField) {
          console.log('SKIPPING: Dependency field not found for fieldId:', dependency.fieldId);
          continue;
        }

        // Get dependency field name - try multiple ways
        let dependencyFieldName = dependencyField.name;
        if (!dependencyFieldName) {
          // Try from field's dependencyFieldName property
          dependencyFieldName = field.dependencyFieldName;
        }
        if (!dependencyFieldName) {
          // Try constructing from title
          dependencyFieldName = dependencyField.title?.toLowerCase().replace(/\s+/g, '_');
        }
        if (!dependencyFieldName) {
          // Try from dependency object
          dependencyFieldName = dependency.fieldName || dependency.fieldTitle?.toLowerCase().replace(/\s+/g, '_');
        }

        if (!dependencyFieldName) {
          console.log('SKIPPING: Could not resolve dependency field name');
          continue;
        }

        console.log('Dependency field name (condition check):', dependencyFieldName);

        // Get dependency field value from form - check both current form and cross-form cache
        let dependencyValue = formValues[dependencyFieldName];
        console.log('Initial dependencyValue from formValues:', dependencyValue);
        
        // If not found in current form, check cross-form dependencies
        if (dependencyValue === null || dependencyValue === undefined || dependencyValue === '') {
          const dependencyKey = `${dependency.folderId}_${dependency.formId}_${dependencyFieldName}`;
          dependencyValue = this.formValuesCache[dependencyKey];
          console.log('Checked cache with key:', dependencyKey, 'value:', dependencyValue);
        }
        
        // Also try alternative key format in case the cache uses a different format
        if ((dependencyValue === null || dependencyValue === undefined || dependencyValue === '') && dependency.formId) {
          const altKey = `${dependency.formId}_${dependencyFieldName}`;
          dependencyValue = this.formValuesCache[altKey];
          console.log('Checked alternative cache key:', altKey, 'value:', dependencyValue);
        }

        console.log('Final dependencyValue for condition check:', dependencyValue);

        // Early skip if dependency value is empty (null, undefined, or empty string)
        // This prevents validation from running when dependency field has no value
        if (dependencyValue === null || dependencyValue === undefined || dependencyValue === '') {
          console.log('SKIPPING: Dependency field value is empty, condition cannot be met');
          continue;
        }
        
        // Additional check for string values that are only whitespace
        if (typeof dependencyValue === 'string' && dependencyValue.trim() === '') {
          console.log('SKIPPING: Dependency field value is empty string/whitespace, condition cannot be met');
          continue;
        }

        // Check if dependency condition is met
        let conditionMet = false;
        const dependencyFieldType = (dependencyField.type || '').toLowerCase();
        
        // For number fields, skip trigger value check - always validate if field has value
        if (dependencyFieldType === 'number') {
          // Additional check: ensure the value is actually a valid number
          const numValue = typeof dependencyValue === 'number' ? dependencyValue : parseFloat(String(dependencyValue));
          conditionMet = !isNaN(numValue) && dependencyValue !== null && dependencyValue !== undefined && dependencyValue !== '';
          console.log('Number field condition check - conditionMet:', conditionMet, 'numValue:', numValue);
        } else if (dependency.triggerValue !== null && dependency.triggerValue !== undefined && dependency.triggerValue !== '') {
          // Check if trigger value matches (case-insensitive for strings)
          if (typeof dependencyValue === 'boolean') {
            conditionMet = dependencyValue === (dependency.triggerValue === 'true' || dependency.triggerValue === true);
          } else if (Array.isArray(dependencyValue)) {
            // For arrays, check if any value matches (case-insensitive)
            const triggerStr = String(dependency.triggerValue).toLowerCase().trim();
            conditionMet = dependencyValue.some(val => String(val).toLowerCase().trim() === triggerStr);
          } else {
            // Case-insensitive string comparison
            const dependencyStr = String(dependencyValue).toLowerCase().trim();
            const triggerStr = String(dependency.triggerValue).toLowerCase().trim();
            conditionMet = dependencyStr === triggerStr && dependencyStr !== ''; // Ensure not empty after trim
          }
        } else {
          // If no trigger value, check if dependency field has any value (for non-select fields)
          if (!['radio', 'radio-button', 'dropdown', 'select', 'checkbox', 'checkbox-group'].includes(dependencyFieldType)) {
            conditionMet = dependencyValue !== null && dependencyValue !== undefined && dependencyValue !== '';
            // Additional check for strings
            if (typeof dependencyValue === 'string') {
              conditionMet = conditionMet && dependencyValue.trim() !== '';
            }
          }
        }

        // If dependency condition is met, proceed with validation
        shouldValidate = conditionMet;
        console.log('Dependency condition result - shouldValidate:', shouldValidate);
      } else {
        // Unknown fieldSelection, skip
        continue;
      }

      // If we shouldn't validate, skip
      if (!shouldValidate) {
        continue;
      }

      // Get the field value to validate
      // For dependent field validation, check if dependent field is in range
      let fieldValue: any;
      let fieldToValidate: any;
      
      if (validation.fieldSelection === 'dependent-field') {
        console.log('=== DEPENDENT FIELD VALIDATION START ===');
        console.log('Main Field:', field.name || field.title, 'ID:', field.id);
        console.log('Validation Config:', validation);
        
        // For dependent field validation, check if the DEPENDENT field's value is within range
        const dependency = validation.dependency;
        console.log('Dependency Object:', dependency);
        
        const dependencyField = this.getFieldById(String(dependency.fieldId));
        if (!dependencyField) {
          console.log('ERROR: Dependency field not found for fieldId:', dependency.fieldId);
          continue;
        }
        console.log('Dependency Field Found:', dependencyField.name || dependencyField.title, 'ID:', dependencyField.id);
        
        // Try multiple ways to get the dependency field name
        let dependencyFieldName = dependencyField.name;
        if (!dependencyFieldName) {
          // Try from field's dependencyFieldName property
          dependencyFieldName = field.dependencyFieldName;
        }
        if (!dependencyFieldName) {
          // Try constructing from title
          dependencyFieldName = dependencyField.title?.toLowerCase().replace(/\s+/g, '_');
        }
        if (!dependencyFieldName) {
          // Try from dependency object
          dependencyFieldName = dependency.fieldName || dependency.fieldTitle?.toLowerCase().replace(/\s+/g, '_');
        }
        
        console.log('Resolved Dependency Field Name:', dependencyFieldName);
        
        if (!dependencyFieldName) {
          console.log('ERROR: Could not resolve dependency field name');
          continue;
        }
        
        // Get dependency field value from form - check both current form and cross-form cache
        fieldValue = formValues[dependencyFieldName];
        console.log('Initial fieldValue from formValues:', fieldValue, 'for key:', dependencyFieldName);
        
        // If not found in current form, check cross-form dependencies
        if (fieldValue === null || fieldValue === undefined || fieldValue === '') {
          const dependencyKey = `${dependency.folderId}_${dependency.formId}_${dependencyFieldName}`;
          fieldValue = this.formValuesCache[dependencyKey];
          console.log('Checked cache with key:', dependencyKey, 'value:', fieldValue);
        }
        
        // Also try alternative key format in case the cache uses a different format
        if ((fieldValue === null || fieldValue === undefined || fieldValue === '') && dependency.formId) {
          const altKey = `${dependency.formId}_${dependencyFieldName}`;
          fieldValue = this.formValuesCache[altKey];
          console.log('Checked alternative cache key:', altKey, 'value:', fieldValue);
        }
        
        // For dependent field range validation: run when the dependent field has a value.
        // Raise query on main field (field with validation configured) when dependent field is out of range,
        // even if main field has no value entered - this catches the case where user enters out-of-range
        // data in dependent field (e.g. test1) before or without entering main field (e.g. test2).

        // Skip if dependent field has no value
        if (fieldValue === null || fieldValue === undefined || fieldValue === '') {
          console.log('SKIPPING: Dependent field has no value');
          continue;
        }

        console.log('Dependent Field Value Retrieved:', fieldValue, 'Type:', typeof fieldValue);

        // Check if minValue and maxValue are configured
        if (validation.minValue === null || validation.minValue === undefined ||
            validation.maxValue === null || validation.maxValue === undefined) {
          console.log('SKIPPING: minValue or maxValue not configured', {
            minValue: validation.minValue,
            maxValue: validation.maxValue
          });
          continue;
        }

        const minRaw = String(validation.minValue).trim();
        const maxRaw = String(validation.maxValue).trim();
        const bpMin = this.tryParseBp(minRaw);
        const bpMax = this.tryParseBp(maxRaw);
        const bpVal = this.tryParseBp(fieldValue);
        const bpMode = !!(bpMin || bpMax || bpVal);

        if (bpMode) {
          if (!bpMin || !bpMax || !bpVal) {
            console.log('SKIPPING: BP range check requires value like 120/80 for min/max/value', {
              minValue: validation.minValue,
              maxValue: validation.maxValue,
              fieldValue
            });
            continue;
          }

          const isWithinRange =
            bpVal.sys >= bpMin.sys && bpVal.sys <= bpMax.sys &&
            bpVal.dia >= bpMin.dia && bpVal.dia <= bpMax.dia;

          console.log('BP Range Check:', {
            value: `${bpVal.sys}/${bpVal.dia}`,
            minValue: `${bpMin.sys}/${bpMin.dia}`,
            maxValue: `${bpMax.sys}/${bpMax.dia}`,
            isWithinRange
          });

          if (isWithinRange) {
            console.log('✅ DEPENDENT FIELD IS WITHIN BP RANGE - SKIPPING VALIDATION (NO QUERY SHOULD BE RAISED)');
            const queryKeyPattern = `${field.id || field.name}_dependent_`;
            const keysToRemove: string[] = [];
            this.validationQueriesRaised.forEach(key => {
              if (key.startsWith(queryKeyPattern)) {
                keysToRemove.push(key);
              }
            });
            keysToRemove.forEach(key => {
              this.validationQueriesRaised.delete(key);
              console.log('Removed previously raised query key:', key);
            });
            continue;
          }

          console.log('❌ DEPENDENT FIELD IS OUT OF BP RANGE - RAISING QUERY');
          const queryKey = `${field.id || field.name}_dependent_${bpVal.sys}/${bpVal.dia}_${bpMin.sys}/${bpMin.dia}_${bpMax.sys}/${bpMax.dia}`;
          if (!this.validationQueriesRaised.has(queryKey)) {
            await this.raiseValidationQuery(field, `${bpVal.sys}/${bpVal.dia}`, validation);
            this.validationQueriesRaised.add(queryKey);
          }
          console.log('=== DEPENDENT FIELD VALIDATION END ===');
          continue;
        }

        // Numeric mode (existing behavior); support "X Years Y Months" age format
        let numericValue: number;
        if (typeof fieldValue === 'number') {
          numericValue = fieldValue;
        } else if (typeof fieldValue === 'string') {
          const cleanedValue = fieldValue.trim();
          const ageVal = this.tryParseAge(cleanedValue);
          if (ageVal !== null) {
            numericValue = ageVal;
          } else {
            numericValue = parseFloat(cleanedValue);
          }
          if (isNaN(numericValue)) {
            console.log('SKIPPING: Cannot convert fieldValue to number:', fieldValue);
            continue;
          }
        } else {
          console.log('SKIPPING: Non-numeric value type:', typeof fieldValue, 'value:', fieldValue);
          continue;
        }

        const minValue = parseFloat(minRaw);
        const maxValue = parseFloat(maxRaw);

        console.log('Range Check:', {
          numericValue: numericValue,
          minValue: minValue,
          maxValue: maxValue,
          isWithinRange: numericValue >= minValue && numericValue <= maxValue
        });

        if (isNaN(minValue) || isNaN(maxValue)) {
          console.log('ERROR: minValue or maxValue is NaN', { minValue, maxValue });
          continue;
        }

        if (numericValue >= minValue && numericValue <= maxValue) {
          // Dependent field is in range - no query needed, skip validation completely
          // This is the correct behavior: when dependent field is within range, no query should be raised
          console.log('✅ DEPENDENT FIELD IS WITHIN RANGE - SKIPPING VALIDATION (NO QUERY SHOULD BE RAISED)');
          console.log(`Value ${numericValue} is within range [${minValue}, ${maxValue}]`);
          
          // Remove any previously raised queries for this field since the dependent field is now in range
          // This ensures that if a query was raised when the value was out of range, it gets cleared when it comes back in range
          const queryKeyPattern = `${field.id || field.name}_dependent_`;
          const keysToRemove: string[] = [];
          this.validationQueriesRaised.forEach(key => {
            if (key.startsWith(queryKeyPattern)) {
              keysToRemove.push(key);
            }
          });
          keysToRemove.forEach(key => {
            this.validationQueriesRaised.delete(key);
            console.log('Removed previously raised query key:', key);
          });
          
          continue; // CRITICAL: This continue prevents any query from being raised
        } else {
          // Dependent field is OUT of range - raise query on the main field (the field with validation configured)
          console.log('❌ DEPENDENT FIELD IS OUT OF RANGE - RAISING QUERY');
          console.log(`Value ${numericValue} is outside range [${minValue}, ${maxValue}]`);
          const queryKey = `${field.id || field.name}_dependent_${numericValue}_${minValue}_${maxValue}`;
          console.log('Query Key:', queryKey);
          console.log('Already raised queries:', Array.from(this.validationQueriesRaised));
          if (!this.validationQueriesRaised.has(queryKey)) {
            console.log('Raising validation query...');
            await this.raiseValidationQuery(field, numericValue, validation);
            this.validationQueriesRaised.add(queryKey);
            console.log('Query raised and added to set');
          } else {
            console.log('Query already raised, skipping duplicate');
          }
        }
        console.log('=== DEPENDENT FIELD VALIDATION END ===');
        // Skip the rest of the validation logic for dependent field validation
        continue;
      } else {
        // Validate the current field's value
        fieldValue = formValues[field.name];
        fieldToValidate = field;
      }
      
      // Skip if field has no value (e.g. Age can be missing if form.value was used - disabled controls are excluded)
      if (fieldValue === null || fieldValue === undefined || fieldValue === '') {
        const isAgeField = (field.title || field.name || '').toLowerCase().includes('age');
        if (isAgeField) {
          console.log('⚠️ [Age range validation] Field has no value in formValues:', field.name || field.title, '- ensure getRawValue() is used so disabled (calculated) Age is included.');
        }
        continue;
      }

      // Check if minValue and maxValue are configured
      if (validation.minValue === null || validation.minValue === undefined ||
          validation.maxValue === null || validation.maxValue === undefined) {
        continue;
      }

      const minRaw = String(validation.minValue).trim();
      const maxRaw = String(validation.maxValue).trim();
      const bpMin = this.tryParseBp(minRaw);
      const bpMax = this.tryParseBp(maxRaw);
      const bpVal = this.tryParseBp(fieldValue);
      const bpMode = !!(bpMin || bpMax || bpVal);

      if (bpMode) {
        // BP-style comparison: SYS/DIA must both be within min..max
        if (!bpMin || !bpMax || !bpVal) {
          console.log('SKIPPING: BP range check requires value like 120/80 for min/max/value', {
            minValue: validation.minValue,
            maxValue: validation.maxValue,
            fieldValue
          });
          continue;
        }

        const isWithin =
          bpVal.sys >= bpMin.sys && bpVal.sys <= bpMax.sys &&
          bpVal.dia >= bpMin.dia && bpVal.dia <= bpMax.dia;

        if (!isWithin) {
          const queryKey = `${fieldToValidate.id || fieldToValidate.name}_${bpVal.sys}/${bpVal.dia}_${bpMin.sys}/${bpMin.dia}_${bpMax.sys}/${bpMax.dia}`;
          if (!this.validationQueriesRaised.has(queryKey)) {
            await this.raiseValidationQuery(fieldToValidate, `${bpVal.sys}/${bpVal.dia}`, validation);
            this.validationQueriesRaised.add(queryKey);
          }
        }
        continue;
      }

      // Numeric comparison (existing behavior); support "X Years Y Months" age format
      let numericValue: number;
      if (typeof fieldValue === 'number') {
        numericValue = fieldValue;
      } else if (typeof fieldValue === 'string') {
        const ageVal = this.tryParseAge(fieldValue);
        if (ageVal !== null) {
          numericValue = ageVal;
        } else {
          numericValue = parseFloat(fieldValue);
        }
        if (isNaN(numericValue)) {
          continue; // Skip if value cannot be converted to number
        }
      } else {
        continue; // Skip non-numeric values
      }

      const minValue = parseFloat(minRaw);
      const maxValue = parseFloat(maxRaw);
      if (isNaN(minValue) || isNaN(maxValue)) {
        continue;
      }

      const isAgeField = (fieldToValidate.title || fieldToValidate.name || '').toLowerCase().includes('age');
      const inRange = numericValue >= minValue && numericValue <= maxValue;
      if (isAgeField) {
        console.log('📋 [Age range check]', {
          field: fieldToValidate.name || fieldToValidate.title,
          rawValue: fieldValue,
          numericValue,
          minValue,
          maxValue,
          inRange,
          willRaiseQuery: !inRange
        });
      }

      if (numericValue < minValue || numericValue > maxValue) {
        const queryKey = `${fieldToValidate.id || fieldToValidate.name}_${fieldValue}_${minValue}_${maxValue}`;
        if (!this.validationQueriesRaised.has(queryKey)) {
          if (isAgeField) {
            console.log('❌ [Age range] Raising validation query: value', numericValue, 'outside range [', minValue, '-', maxValue, ']');
          }
          await this.raiseValidationQuery(fieldToValidate, fieldValue, validation);
          this.validationQueriesRaised.add(queryKey);
        }
      } else {
        const queryKey = `${fieldToValidate.id || fieldToValidate.name}_${fieldValue}_${minValue}_${maxValue}`;
        // Don't remove immediately, keep it to prevent re-raising if user changes back
      }
    }
  }

  private tryParseBp(value: any): { sys: number; dia: number } | null {
    if (value === null || value === undefined) {
      return null;
    }
    const s = String(value).trim();
    const m = /^(\d{1,3})\s*\/\s*(\d{1,3})$/.exec(s);
    if (!m) {
      return null;
    }
    const sys = Number(m[1]);
    const dia = Number(m[2]);
    if (!Number.isFinite(sys) || !Number.isFinite(dia)) {
      return null;
    }
    return { sys, dia };
  }

  /**
   * Parse age values in "X Years Y Months" format (e.g. from calculated age field)
   * to a single number (years, with fractional months) for range comparison.
   * Validation min/max are plain numbers (e.g. 20 to 30 years).
   */
  private tryParseAge(value: any): number | null {
    if (value === null || value === undefined) {
      return null;
    }
    const s = String(value).trim();
    // Match "4 Years 0 Months", "4 years 0 months", "4 Years, 0 Months", "20 Years 5 Months"
    const m = /(\d+)\s*Years?\s*,?\s*(\d+)\s*Months?/i.exec(s);
    if (m) {
      const years = Number(m[1]);
      const months = Number(m[2]);
      if (!Number.isFinite(years) || !Number.isFinite(months)) {
        return null;
      }
      return years + months / 12;
    }
    // Fallback: single number at start (e.g. "25" or "25 years")
    const single = /^(\d+)/.exec(s);
    if (single) {
      const n = Number(single[1]);
      return Number.isFinite(n) ? n : null;
    }
    return null;
  }

  // Raise a query automatically when validation fails
  private async raiseValidationQuery(field: any, fieldValue: any, validation: any): Promise<void> {
    console.log('🚨 raiseValidationQuery CALLED - THIS SHOULD NOT HAPPEN IF DEPENDENT FIELD IS IN RANGE');
    console.log('Field:', field.name || field.title, 'ID:', field.id);
    console.log('Field Value:', fieldValue);
    console.log('Validation:', validation);
    console.trace('Stack trace for raiseValidationQuery call');
    
    const fieldName = field.title || field.name;
    const fieldId = field.id || field.name;

    // Create query message
    const queryMessage = validation.queryMessage || 
      `Value ${fieldValue} is outside the allowed range (${validation.minValue} - ${validation.maxValue}) for field "${fieldName}"`;

    console.log('Query Message:', queryMessage);

    // Prepare query data
    const queryData = {
      study_id: this.study_id,
      subject_id: this.subject_id,
      form_id: this.currentForm?.id || this.currentForm?.name || 'default',
      field_id: fieldId,
      row_id: 'undefined', // For regular fields, use undefined
      query_text: queryMessage,
      query_type: 'Range Validation Query',
      query_status: 'Open',
      query_priority: 'High',
      query_assignee: null,
      query_created_by: null, // System-generated query
      query_id: 0,
      designation: 'System'
    };

    console.log('Query Data:', queryData);

    // Submit the query
    try {
      this.apiService.submitTemplateQuery(queryData).subscribe({
        next: (response) => {
          console.log('✅ Query submitted successfully:', response);
          alert(`Validation query raised: ${queryMessage}`);
        },
        error: (error) => {
          console.error('❌ Error submitting query:', error);
        }
      });
    } catch (error) {
      console.error('❌ Exception while submitting query:', error);
    }
  }

  private markFormGroupTouched(): void {
    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      control?.markAsTouched();
    });
  }

  // Capture a stable hash of the current form payload to detect changes
  private computeFormHash(): string {
    if (!this.form) {
      return '0';
    }

    try {
      const payload = this.getHashableFormData();
      const serialized = JSON.stringify(payload);
      return this.simpleHash(serialized);
    } catch (error) {
      return '0';
    }
  }

  // Normalize the data we want to track for change detection
  private getHashableFormData(): any {
    const formValues = this.form?.getRawValue ? this.form.getRawValue() : this.form?.value || {};
    return {
      formValues,
      commentFields: { ...(this.commentFields || {}) },
      piSignatureReviewed: this.getPiSignatureReviewed()
    };
  }

  // Lightweight string hash (sufficient for change detection)
  private simpleHash(value: string): string {
    let hash = 0;
    if (value.length === 0) {
      return '0';
    }
    for (let i = 0; i < value.length; i++) {
      hash = (hash << 5) - hash + value.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }
    return hash.toString();
  }

  // Store the current form hash as the baseline fetched state
  private updateInitialFormDataHash(): void {
    this.initialFormDataHash = this.computeFormHash();
  }

  // Helper method to debug form validation
  private debugFormValidation(): void {
    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      if (control && control.invalid) {
      } else if (control) {
      }
    });
  }

  // Custom validator for table fields that doesn't interfere with form submission
  private tableRequiredValidator() {
    return (control: any) => {
      // For table fields, we consider them valid if they exist (even if empty)
      // This prevents form invalidity issues while still allowing required field logic
      if (control.value === null || control.value === undefined) {
        return { required: true };
      }
      return null;
    };
  }

  // Helper method to format field values based on field type
  private formatFieldValue(field: any, value: any): string {
    if (value === null || value === undefined) {
      return '';
    }

    switch (field.type) {
      case 'checkbox':
        return Array.isArray(value) ? JSON.stringify(value) : String(value);
      case 'radio':
        return String(value);
      case 'number':
        return String(value);
      case 'date':
        return String(value);
      case 'time':
        return String(value);
      case 'textarea':
        return String(value);
      case 'text':
        return String(value);
      case 'select':
        return String(value);
      case 'esignature':
      case 'signature':
        return String(value);
      case 'compound':
        return this.formatCompoundFieldValue(field, value);
      case 'table':
      case 'fixed-rows-table':
        return this.formatTableFieldValue(field, value);
      default:
        return String(value);
    }
  }

  // Helper method to format compound field values
  private formatCompoundFieldValue(field: any, value: any): string {
    if (!field.subFields || !Array.isArray(value)) {
      return String(value);
    }

    const compoundData = {};
    field.subFields.forEach((subField: any, index: number) => {
      if (value[index] !== undefined) {
        compoundData[subField.name] = value[index];
      }
    });

    return JSON.stringify(compoundData);
  }

  private isTableRowEmpty(row: any, columns?: any[]): boolean {
    if (!row || typeof row !== 'object') {
      return true;
    }

    // Get keys to check - use column names if provided, otherwise check all row keys
    const checkKeys = columns?.length 
      ? columns.map((col: any, idx: number) => col.name || `col_${idx}`)
      : Object.keys(row);

    // Check if any key has a meaningful value
    return !checkKeys.some(key => {
      const value = row[key];
      if (value == null) return false; // null or undefined
      if (typeof value === 'string') return value.trim() !== '';
      if (typeof value === 'number') return !Number.isNaN(value);
      if (typeof value === 'boolean') return value;
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'object') return Object.keys(value).length > 0;
      return !!value;
    });
  }

  private reindexTableRowReasons(fieldName: string, removedIndex: number): void {
    const reasons = this.tableRowEditReasons[fieldName];
    if (!reasons) {
      return;
    }

    const updated: { [rowIndex: number]: string } = {};
    Object.keys(reasons).forEach(key => {
      const parsedIndex = parseInt(key, 10);
      if (Number.isNaN(parsedIndex)) {
        return;
      }

      if (parsedIndex === removedIndex) {
        return;
      }

      const targetIndex = parsedIndex > removedIndex ? parsedIndex - 1 : parsedIndex;
      updated[targetIndex] = reasons[parsedIndex];
    });

    if (Object.keys(updated).length > 0) {
      this.tableRowEditReasons[fieldName] = updated;
    } else {
      delete this.tableRowEditReasons[fieldName];
    }
  }

  private clearTableRowReasons(fieldName: string): void {
    if (this.tableRowEditReasons[fieldName]) {
      delete this.tableRowEditReasons[fieldName];
    }
  }

  // Helper method to format table field values
  private formatTableFieldValue(field: any, value: any): any {
    if (!Array.isArray(value)) {
      return String(value);
    }

    // Get original data to compare with current data
    const originalData = this.originalTableData[field.name] || [];
    const isFixedRowsTable = field.type === 'fixed-rows-table';
    const emptyCheckColumns = isFixedRowsTable ? this.getTableColumnsExcludingSrNo(field) : field.columns;
    const originalRowIndexMap = isFixedRowsTable ? new Map<number, any>() : null;
    if (originalRowIndexMap) {
      originalData.forEach((row: any) => {
        const rowIndex = row?.row_index !== undefined && row?.row_index !== null
          ? Number(row.row_index)
          : null;
        if (rowIndex !== null && !Number.isNaN(rowIndex)) {
          originalRowIndexMap.set(rowIndex, row);
        }
      });
    }
    
    // For table fields, we need to properly serialize the array of objects
    // Each row should be an object with column data and operation type
    const tableData = value.map((row: any, index: number) => {
      console.log("row inddex", row);
      const rowIndexFromData = isFixedRowsTable && row?.row_index !== undefined && row?.row_index !== null
        ? Number(row.row_index)
        : null;
      const resolvedRowIndex = rowIndexFromData !== null && !Number.isNaN(rowIndexFromData)
        ? rowIndexFromData
        : index;
      const originalRow = isFixedRowsTable
        ? (originalRowIndexMap?.get(resolvedRowIndex) || originalData[index] || null)
        : (originalData[index] || null);
      const rowData: any = { 
        row_index: resolvedRowIndex,
        // id: (originalData[index] && originalData[index].id) ? originalData[index].id : null
      };
      
      // Determine if this is a new row or existing row
      const isNewRow = isFixedRowsTable ? !originalRow : index >= originalData.length;
      rowData.operation = isNewRow ? 'INSERT' : 'UPDATE';
      rowData.is_new_row = isNewRow;

      if (isNewRow && this.isTableRowEmpty(row, emptyCheckColumns)) {
        return null;
      }

      if (!isNewRow && isFixedRowsTable && !this.hasFixedRowsTableRowChanged(field, row, originalRow)) {
        return null;
      }
      
      // Add row ID for existing rows (if available)
      if (!isNewRow && originalRow && originalRow.id) {
        rowData.existing_row_id = originalRow.id;
      }
      
      // Process each column in the table
      if (field.columns && Array.isArray(field.columns)) {
        field.columns.forEach((column: any, colIndex: number) => {
          // Skip Sr. No column - it's auto-generated and should not be saved
          if (column.isSrNo || column.name === '_sr_no') {
            return;
          }
          const columnKey = this.getDataColumnKey(field, column);
          // Include all columns except Sr. No - include even if value is null or empty string
          // This ensures all column data (including col_0) is sent to backend
          if (columnKey in row) {
            // Ensure dropdown values are properly preserved
            rowData[columnKey] = row[columnKey];
          }
        });
      } else {
        // If no columns defined, use the row data as-is (but still exclude Sr. No)
        Object.keys(row).forEach(key => {
          // Skip Sr. No column keys
          if (key === '_sr_no' || key.startsWith('sr_no')) {
            return;
          }
          if (row[key] !== undefined) {
            rowData[key] = row[key];
          }
        });
      }
      
      const rowReason = this.tableRowEditReasons[field.name]?.[index];
      if (rowReason) {
        rowData.edit_reason = rowReason;
      }
      
      return rowData;
    }).filter((row: any) => row !== null);

    return tableData;
  }

  private normalizeTableCellValue(value: any): any {
    if (value === null || value === undefined) return '';
    if (typeof value === 'string') return value.trim();
    if (typeof value === 'number') return Number.isNaN(value) ? '' : value;
    if (typeof value === 'boolean') return value;
    if (Array.isArray(value)) return value.map(item => this.normalizeTableCellValue(item));
    if (typeof value === 'object') {
      try {
        return JSON.stringify(value);
      } catch (error) {
        return String(value);
      }
    }
    return value;
  }

  private hasFixedRowsTableRowChanged(field: any, row: any, originalRow: any): boolean {
    if (!row || !originalRow) {
      return true;
    }

    const columnsToCompare = this.getTableColumnsExcludingSrNo(field);
    for (const column of columnsToCompare) {
      const columnKey = this.getDataColumnKey(field, column);
      const currentValue = this.normalizeTableCellValue(row[columnKey]);
      const previousValue = this.normalizeTableCellValue(originalRow[columnKey]);
      if (currentValue !== previousValue) {
        return true;
      }
    }

    return false;
  }

  private storeExistingAttachment(fieldName: string, record: any): void {
    if (!record) {
      return;
    }

    // Prefer new attachments array from backend if available
    if (Array.isArray(record.attachments) && record.attachments.length > 0) {
      const existing = this.existingAttachments[fieldName] || [];
      const existingByLink = new Map<string, ExistingAttachment>();
      for (const item of existing) {
        if (item.documentLink) {
          existingByLink.set(item.documentLink, item);
        }
      }

      const next: ExistingAttachment[] = [...existing];
      for (const att of record.attachments) {
        const documentLink: string | null = att.document_link || null;
        const documentName: string | null = att.name || att.document_name || null;
        const documentUrl: string | null = att.document_url || null;
        const uploadedAt: string | undefined = att.created_at ?? undefined;

        if (!documentLink && !documentName) {
          continue;
        }

        const normalizedName = documentName || this.extractFileName(documentLink);
        const key = documentLink || normalizedName;
        if (existingByLink.has(key)) {
          continue;
        }

        const attachment: ExistingAttachment = {
          name: normalizedName,
          url: documentUrl,
          documentLink,
          uploadedAt,
          fieldId: record.field_id || fieldName,
          recordId: att.id ?? record.id
        };

        existingByLink.set(key, attachment);
        next.push(attachment);
      }

      this.existingAttachments[fieldName] = next;
      return;
    }

    // Legacy single-attachment path for backward compatibility
    const documentLink: string | null = record.document_link || null;
    const documentName: string | null = record.document_name || null;
    const documentUrl: string | null = (record as any).document_url || null;
    const uploadedAt: string | undefined = record.created_at ?? undefined;

    if (!documentLink && !documentName) {
      return;
    }

    const normalizedName = documentName || this.extractFileName(documentLink);
    const attachment: ExistingAttachment = {
      name: normalizedName,
      url: documentUrl,
      documentLink,
      uploadedAt,
      fieldId: record.field_id || fieldName,
      recordId: record.id
    };

    const existing = this.existingAttachments[fieldName] || [];
    const withoutDuplicate = existing.filter(item => item.documentLink !== attachment.documentLink);
    this.existingAttachments[fieldName] = [...withoutDuplicate, attachment];
  }

  private extractFileName(path: string | null): string {
    if (!path) {
      return 'attachment';
    }

    const sanitizedPath = path.split('?')[0];
    const segments = sanitizedPath.split('/');
    return segments.pop() || sanitizedPath;
  }

  // Helper method to get sub-data for fields
  private getSubData(field: any, formValues: any, attachmentPayload?: AttachmentPayload[] | null): string {
    const subData: any = {};

    // Add field metadata
    subData.field_type = field.type;
    subData.field_title = field.title;
    subData.required = field.required;

    // Add field-specific sub-data
    if (field.type === 'radio' && field.options) {
      subData.options = field.options;
    }

    if (field.type === 'checkbox' && field.options) {
      subData.options = field.options;
    }

    if (field.type === 'select' && field.options) {
      subData.options = field.options;
    }

    if (field.unit) {
      subData.unit = field.unit;
    }

    if (attachmentPayload && attachmentPayload.length > 0) {
      subData.has_attachments = true;
      subData.attachment_count = attachmentPayload.length;
      subData.attachment_names = attachmentPayload.map(file => file.name);
    }

    return JSON.stringify(subData);
  }

  private async prepareAttachmentPayload(fieldName: string): Promise<AttachmentPayload[] | null> {
    const dedupedFiles = new Map<string, File>();
    const pushFile = (file: File | null | undefined) => {
      if (!file) {
        return;
      }
      const cacheKey = `${file.name}_${file.size}_${file.lastModified}`;
      if (!dedupedFiles.has(cacheKey)) {
        dedupedFiles.set(cacheKey, file);
      }
    };

    const selected = this.selectedFiles[fieldName];
    if (Array.isArray(selected)) {
      selected.forEach(pushFile);
    }

    const attachmentControl = this.form.get(fieldName + '_attachments');
    const controlValue = attachmentControl?.value;

    if (Array.isArray(controlValue)) {
      controlValue.forEach(pushFile);
    } else if (typeof FileList !== 'undefined' && controlValue instanceof FileList) {
      Array.from(controlValue).forEach(pushFile);
    } else if (controlValue instanceof File) {
      pushFile(controlValue);
    }

    const files = Array.from(dedupedFiles.values());
    if (files.length === 0) {
      return null;
    }

    const payload: AttachmentPayload[] = [];
    for (const file of files) {
      try {
        const content = await this.readFileAsBase64(file);
        payload.push({
          name: file.name,
          type: file.type || 'application/octet-stream',
          size: file.size,
          content
        });
      } catch (error) {
      }
    }

    return payload.length > 0 ? payload : null;
  }

  private readFileAsBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result;
        if (typeof result === 'string') {
          const base64 = result.includes(',') ? result.split(',')[1] : result;
          resolve(base64);
        } else {
          reject(new Error('Unexpected FileReader result type'));
        }
      };
      reader.onerror = () => reject(reader.error || new Error('Error reading file'));
      reader.readAsDataURL(file);
    });
  }

  // Table functionality will be recreated from scratch

  // Lock fields in frontend after submission
  private lockFields(fieldNames: string[], lockedBy: string): void {
    const currentTime = new Date().toISOString();
    
    fieldNames.forEach(fieldName => {
      this.fieldLockStatus[fieldName] = {
        isLocked: true,
        lockedAt: currentTime,
        lockedBy: lockedBy
      };
      
      // Disable the form control
      const formControl = this.form.get(fieldName);
      if (formControl) {
        formControl.disable();
      }
    });
    
    // Store submitted fields for current session only (no localStorage)
    this.submittedFields = [...this.submittedFields, ...fieldNames];
  }

  // Note: localStorage methods removed - locking now based only on SQL data

  saveFormFields(): void {
    if (this.currentForm) {
      this.currentForm.fields = this.fields;
      // this.saveTemplate();
    }
  }

  toggleSideNav(): void {
    this.isSidebarVisible = !this.isSidebarVisible;
  }

  // Initialize sidebar visibility based on screen size
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (event.target.innerWidth > 1200) {
      this.isSidebarVisible = true; // Always visible on large screens
    }
  }

  private saveTemplate() {
    // Save to API first
    this.apiService.saveTemplates(this.template).subscribe(
      (response) => {
        // Also update localStorage as backup
        const savedTemplates = localStorage.getItem('ecrfTemplates');
        if (savedTemplates) {
          const templates = JSON.parse(savedTemplates);
          const index = templates.findIndex((t: any) => t.id.toString() === this.template_id);
          if (index !== -1) {
            templates[index] = this.template;
            localStorage.setItem('ecrfTemplates', JSON.stringify(templates));
          }
        }
      },
      (error) => {
        // Fallback to localStorage only
        const savedTemplates = localStorage.getItem('ecrfTemplates');
        if (savedTemplates) {
          const templates = JSON.parse(savedTemplates);
          const index = templates.findIndex((t: any) => t.id.toString() === this.template_id);
          if (index !== -1) {
            templates[index] = this.template;
            localStorage.setItem('ecrfTemplates', JSON.stringify(templates));
          }
        }
      }
    );
  }

  // Table functionality will be recreated from scratch

  // Simplified table data population
  private populateTableWithBackendData(field: any, formData: any[]): void {
    if (!field || !formData) {
      return;
    }
    // Filter data for this specific table field
    const fieldData = formData.filter(item => {
      return item.field_name === field.name || (item.field_id && item.field_id.startsWith(field.id || field.name));
    });
    
    if (fieldData.length > 0) {
      try {
        // Parse table data from the first item's value_config
        const firstItem = fieldData[0];
        if (firstItem.value_config) {
          const tableData = JSON.parse(firstItem.value_config);
          if (Array.isArray(tableData)) {
            const tableControl = this.form.get(field.name);
            if (tableControl) {
              tableControl.setValue(tableData);
            }
          }
        }
      } catch (error) {
      }
    } else {
      // Initialize with empty table if no data
      this.initializeEmptyTable(field);
    }
  }

  private initializeEmptyTable(field: any): void {
    const tableControl = this.form.get(field.name);
    if (tableControl) {
      // Initialize with one empty row
      tableControl.setValue([{}]);
    }
  }

  // Helper function to convert numbers to alphabetic characters
  private numberToAlphabetic(num: number): string {
    const alphabet = 'abcdefghijklmnopqrstuvwxyz';
    let result = '';
    let n = num;
    
    if (n === 0) return 'a';
    
    while (n > 0) {
      n--; // Adjust for 0-based indexing
      result = alphabet[n % 26] + result;
      n = Math.floor(n / 26);
    }
    
    return result;
  }

  // Helper function to create alphabetic form control name
  private createAlphabeticControlName(fieldName: string, rowIndex: number, colIndex: number): string {
    const rowChar = this.numberToAlphabetic(rowIndex);
    const colChar = this.numberToAlphabetic(colIndex);
    return `${fieldName}${rowChar}${colChar}`;
  }

  // Table-related methods
  getTableRows(fieldName: string): any[] {
    // Get the current number of rows for this table field
    const tableData = this.getTableData(fieldName);
    if (tableData.length === 0) {
      // Initialize with one empty row
      return [{}];
    }
    return tableData;
  }



  // Table column management for new field creation




  // Navigation methods for conditional navigation

  navigateToAdverseEvents(): void {
    this.router.navigate(['/folders/adverse-events/adverse-events'], {
      queryParams: { 
        study_id: this.study_id, 
        subjectId: this.study_id,
        formName: 'adverse-event-report'
      }
    });
  }

  navigateToLaboratory(): void {
    this.router.navigate(['/folders/laboratory-investigation-log/laboratory-investigation-log'], {
      queryParams: { 
        study_id: this.study_id, 
        subjectId: this.study_id 
      }
    });
  }

  navigateToPhysicalSystemic(): void {
    this.router.navigate(['/folders/physical-systemic/physical-systemic'], {
      queryParams: { 
        study_id: this.study_id, 
        subjectId: this.study_id 
      }
    });
  }

  navigateToIDRS(): void {
    this.router.navigate(['/folders/idrs/idrs-form-log'], {
      queryParams: { 
        study_id: this.study_id, 
        subjectId: this.study_id 
      }
    });
  }

  navigateToPriorMedication(): void {
    this.router.navigate(['/folders/prior-medication-log/prior-medication-log'], {
      queryParams: { 
        study_id: this.study_id, 
        subjectId: this.study_id,
        formName: 'prior-medication-log'
      }
    });
  }

  navigateToConcomitantMedication(): void {
    this.router.navigate(['/folders/concomitant-medication-log/concomitant-medication-log'], {
      queryParams: { 
        study_id: this.study_id, 
        subjectId: this.study_id,
        formName: 'concomitant-medication-log'
      }
    });
  }

  navigateToRescueMedication(): void {
    this.router.navigate(['/folders/rescue-medication-log/rescue-medication-log'], {
      queryParams: { 
        study_id: this.study_id, 
        subjectId: this.study_id,
        formName: 'rescue-medication-log'
      }
    });
  }

  navigateToProtocolDeviation(): void {
    this.router.navigate(['/folders/protocol-deviation/protocol-deviation'], {
      queryParams: { 
        study_id: this.study_id, 
        subjectId: this.study_id,
        formName: 'protocol-deviation-log'
      }
    });
  }

  navigateToStudyCompletion(): void {
    this.router.navigate(['/folders/study-completion-termination/study-completion-termination'], {
      queryParams: { 
        study_id: this.study_id, 
        subjectId: this.study_id,
        formName: 'study-completion-termination'
      }
    });
  }

  navigateToMedicalHistory(): void {
    this.router.navigate(['/folders/medical-history/medical-history'], {
      queryParams: { 
        study_id: this.study_id, 
        subjectId: this.study_id 
      }
    });
  }

  // Additional navigation methods for baseline, follow-up, and medicine dispensing

  navigateToBaselinePhysicalExam(): void {
    this.router.navigate(['/folders/baseline-visits/baseline-visits'], {
      queryParams: { 
        study_id: this.study_id, 
        subjectId: this.study_id,
        formName: 'baseline-physical-exam'
      }
    });
  }

  navigateToBaselineLabInvestigation(): void {
    this.router.navigate(['/folders/baseline-visits/baseline-visits'], {
      queryParams: { 
        study_id: this.study_id, 
        subjectId: this.study_id,
        formName: 'baseline-lab-investigation'
      }
    });
  }



  navigateToFollowUpPhysical(): void {
    this.router.navigate(['/folders/follow-up-visit/follow-up-visit'], {
      queryParams: { 
        study_id: this.study_id, 
        subjectId: this.study_id,
        formName: 'follow-up-physical'
      }
    });
  }

  navigateToFollowUpLabInvestigation(): void {
    this.router.navigate(['/folders/follow-up-visit/follow-up-visit'], {
      queryParams: { 
        study_id: this.study_id, 
        subjectId: this.study_id,
        formName: 'follow-up-laboratory-investigation'
      }
    });
  }

  navigateToVitalSigns(): void {
    this.router.navigate(['/folders/vital-signs/vital-signs'], {
      queryParams: { 
        study_id: this.study_id, 
        subjectId: this.study_id,
        formName: 'vital-signs'
      }
    });
  }



  // Helper method to check if a field value is "yes"
  isFieldValueYes(fieldName: string): boolean {
    const field = this.fields.find(f => f.name === fieldName);
    if (field && this.form) {
      const value = this.form.get(fieldName)?.value;
      return value === 'yes' || value === 'Yes';
    }
    return false;
  }

  // Navigation method to go back to study list page
  navigateToBuildTemplates(): void {
    this.location.back();
  }

  // Note: Folder management methods removed as three dots menu is no longer available

  // Form management methods
  editForm(form: any): void {
    const newName = prompt('Enter new form name:', form.name);
    if (newName && newName.trim() && newName !== form.name) {
      form.name = newName.trim();
      // this.saveTemplate();
      
      // Update current form if it's the one being edited
      if (this.currentForm && this.currentForm.name === form.name) {
        this.currentForm.name = newName.trim();
      }
    }
  }

  deleteForm(form: any): void {
    if (confirm(`Are you sure you want to delete the form "${form.name}"?`)) {
      // Find the folder containing this form
      const folder = this.template.folders.find((f: any) => 
        f.forms && f.forms.some((formItem: any) => formItem.name === form.name)
      );
      
      if (folder) {
        const formIndex = folder.forms.findIndex((f: any) => f.name === form.name);
        if (formIndex > -1) {
          folder.forms.splice(formIndex, 1);
          // this.saveTemplate();
          
          // Clear selection if the deleted form was selected
          if (this.currentForm && this.currentForm.name === form.name) {
            this.currentForm = null;
            this.fields = [];
            this.selectedForm = null;
          }
        }
      }
    }
  }






  // Method to check if a field should be visible based on its dependency
  shouldShowField(field: any): boolean {
    if (!field.hasDependency || !field.dependency) {
      return true; // Show field if no dependency
    }

    const dependency = field.dependency;
    
    // Get the dependency field name - try multiple approaches
    let dependencyFieldName = field.dependencyFieldName || this.getDependencyFieldName(dependency);
    
    // If still no field name, try to find it in the current form fields
    if (!dependencyFieldName) {
      // Look for a field with the same title as the dependency field
      const dependencyField = this.fields.find(f => 
        f.title === dependency.fieldTitle || 
        f.name === dependency.fieldName
      );
      if (dependencyField) {
        dependencyFieldName = dependencyField.name;
      }
    }
    
    if (!dependencyFieldName) {
      return false; // Hide field if dependency field not found
    }

    // Check if this is a cross-form dependency
    const crossFormKey = `${dependency.folderId}_${dependency.formId}_${dependencyFieldName}`;
    let dependencyValue = null;
    
    if (this.formValuesCache[crossFormKey] !== undefined) {
      // This is a cross-form dependency
      dependencyValue = this.formValuesCache[crossFormKey];
    } else {
            // This is a same-form dependency - try without formId suffix first
      let dependencyControl = this.form.get(dependencyFieldName);
      
      // If not found, try with formId suffix
      if (!dependencyControl && dependency.formId) {
        const dependencyControlNameWithSuffix = dependencyFieldName + "_" + parseInt(dependency.formId);
        dependencyControl = this.form.get(dependencyControlNameWithSuffix);
      }
      
      if (dependencyControl) {
        dependencyValue = dependencyControl.value;
      } else {
        return false; // Hide field if dependency field not found
      }
    }
    
    // Check if trigger value is properly defined
    if (dependency.triggerValue === '' || dependency.triggerValue === null || dependency.triggerValue === undefined) {
      return false; // Hide field if no trigger value specified
    }
    
    // Check if dependency value is null/undefined/empty - hide field if so
    if (dependencyValue === null || dependencyValue === undefined || dependencyValue === '') {
      return false; // Hide field if dependency field has no value
    }
    // Compare values based on field type
    let shouldShow = false;
    const triggerValue: any = dependency.triggerValue;
    
    // Handle different data types
    if (typeof dependencyValue === 'boolean') {
      shouldShow = dependencyValue === (triggerValue === 'true' || triggerValue === true);
    } else if (Array.isArray(dependencyValue)) {
      shouldShow = (dependencyValue as any[]).includes(triggerValue);
    } else if (typeof dependencyValue === 'string') {
      // Handle string comparison (case-insensitive for better UX)
      const triggerStr = String(triggerValue || '');
      shouldShow = (dependencyValue as any).toLowerCase() === (triggerStr as any).toLowerCase();
    } else if (typeof dependencyValue === 'number') {
      shouldShow = dependencyValue === parseFloat(String(triggerValue));
    } else {
      shouldShow = dependencyValue === triggerValue;
    }
    return shouldShow;
  }

  // Get all fields that depend on a given field
  getDependentFields(field: any): any[] {
    if (!field || !field.name) {
      return [];
    }

    // Find all fields that have this field as a dependency
    return this.fields.filter(f => {
      if (!f.hasDependency || !f.dependency) {
        return false;
      }

      // Check if this field is the dependency field
      const dependencyFieldName = this.getDependencyFieldName(f.dependency);
      return dependencyFieldName === field.name;
    });
  }

  // Populate dependency dropdowns when editing a field with dependencies

  // Set up dependency field listeners for all fields with dependencies
  private setupDependencyFieldListeners(): void {
    this.fields.forEach(field => {
      if (field.hasDependency && field.dependencyFieldName) {
        const dependencyControl = this.form.get(field.dependencyFieldName);
        if (dependencyControl) {
          dependencyControl.valueChanges.subscribe(value => {
            // Check validation for all fields that depend on this field when dependency value changes
            setTimeout(() => {
              this.checkFieldValidations(this.getFormValuesForValidation());
            }, 100);
            this.cdr.detectChanges();
          });
        } else {
        }
      }
    });
  }

  // Set up listeners for dependency fields that exist in the current form
  private setupCurrentFormDependencyListeners(): void {
    // Check if any current form fields are dependency fields for other fields
    this.fields.forEach(field => {
      if (this.form.get(field.name)) {
        this.form.get(field.name)?.valueChanges.subscribe(value => {
          // Check if this field is a dependency for any other fields
          const dependentFields = this.fields.filter(f => 
            f.hasDependency && 
            f.dependencyFieldName === field.name
          );
          
          if (dependentFields.length > 0) {
            this.cdr.detectChanges();
          }
        });
      }
    });
  }

  // Check for cross-form dependencies when a field value changes
  private checkCrossFormDependencies(fieldName: string, value: any): void {
    const currentFormKey = `${this.selectedFolderId}_${this.currentForm?.name}_${fieldName}`;
    
    // Check if this field is a dependency for fields in other forms
    if (this.globalDependencies[currentFormKey]) {
      const dependentFields = this.globalDependencies[currentFormKey];
      // Update the form values cache
      this.formValuesCache[currentFormKey] = value;
      
      // Trigger change detection for all dependent forms
      dependentFields.forEach(dependentField => {
        // Check if the dependent field should be visible
        const shouldShow = this.shouldShowCrossFormField(dependentField, value);
      });
      
      // Trigger change detection
      this.cdr.detectChanges();
    }
  }

  // Check if a cross-form dependent field should be visible
  private shouldShowCrossFormField(dependentField: any, dependencyValue: any): boolean {
    if (!dependentField.triggerValue) {
      return true;
    }
    
    // Compare values based on field type
    if (typeof dependencyValue === 'boolean') {
      return dependencyValue === (dependentField.triggerValue === 'true' || dependentField.triggerValue === true);
    } else if (Array.isArray(dependencyValue)) {
      return (dependencyValue as any[]).includes(dependentField.triggerValue);
    } else {
      return dependencyValue === dependentField.triggerValue;
    }
  }

  // Populate form with existing data if available
  private populateFormWithExistingData(form: any): void {
    // Check if form has existing data
    if (form.data && typeof form.data === 'object') {
      this.setFormData(form.data);
    } else {
      this.loadFormDataFromAPI(form);
    }
  }

  // Set form data from a data object
  private setFormData(data: any): void {
    // Populate form controls with existing data
    Object.keys(data).forEach(key => {
      const formControl = this.form.get(key);
      if (formControl) {
        const value = data[key];
        
        // Handle different field types
        if (Array.isArray(value)) {
          // For checkbox fields or array values
          formControl.setValue(value);
        } else if (value !== null && value !== undefined) {
          // For other field types
          formControl.setValue(value);
        }
      }
    });
    
    // Handle special field types that might have different naming conventions
    this.fields.forEach(field => {
      if (field.type === 'table' && data[field.name]) {
        const tableControl = this.form.get(field.name);
        if (tableControl) {
          tableControl.setValue(data[field.name]);
        }
      }
    });

    this.populateFixedRowsTableFromValue();
    // Prefetch query status for locally provided form data
    this.prefetchQueryStatusesForCurrentForm();
    // Prefetch review status for locally provided form data
    this.prefetchReviewStatusesForCurrentForm();
  }

  // Set form data with lock status information
  private setFormDataWithLockStatus(data: any): void {
    // Reset existing attachment metadata before processing new data
    this.existingAttachments = {};
    
    const fieldsWithData: string[] = []; // Track fields that have data from SQL
    let formPiCheckStatus = false; // Track if any field in this form has PI check
    let formPiReviewedBy: string | undefined; // Track PI reviewer name
    let formPiReviewedAt: string | undefined; // Track PI review time
    let formPiComment: string | undefined; // Track PI comment

    // Handle array of database records (from API response with field_id)
    if (Array.isArray(data)) {
      data.forEach(record => {
        const fieldId = record.field_id;
        const value = record.value;
        const valueConfig = record.value_config;
        const piCheck = record.pi_check; // Get PI check status from database
        const piReviewedBy = record.pi_reviewed_by;
        const piReviewedAt = record.pi_review_time;
        const piComment = record.pi_comment; // Get PI comment from database
        
        // Debug: Log validation check data for each record
        if (piCheck !== undefined || piReviewedBy || piReviewedAt || piComment) {
        }
        
        // Capture PI reviewer info (use first non-null values found)
        if (piReviewedBy && !formPiReviewedBy) {
          formPiReviewedBy = piReviewedBy;
        }
        if (piReviewedAt && !formPiReviewedAt) {
          formPiReviewedAt = piReviewedAt;
        }
        if (piComment && !formPiComment) {
          formPiComment = piComment;
        }
        const documentLink = record.document_link;
        const documentName = record.document_name;
        const documentUrl = record.document_url;
        const recordId = record.id;
        const createdAt = record.created_at;
        
        // Track PI check status for the form
        if (piCheck === true || piCheck === 1) {
          formPiCheckStatus = true;
        }

        // Try to parse sub_data first to get field information
        let parsedSubData: any = null;
        try {
          if (record.sub_data) {
            parsedSubData = typeof record.sub_data === 'string' ? JSON.parse(record.sub_data) : record.sub_data;
          }
        } catch (e) {
          // Ignore parse errors
        }
        
        // PRIMARY STRATEGY: Find field by ID in current form fields (most reliable)
        let field = this.fields.find(f => f.id === parseInt(fieldId) || String(f.id) === String(fieldId));
        let fieldName: string = fieldId; // Default to fieldId
        
        if (field && field.name) {
          fieldName = field.name;
        } else {
          // FALLBACK: Try to get field name from template
          const templateFieldName = this.getFieldNameFromFieldId(fieldId);
          if (templateFieldName && templateFieldName !== fieldId) {
            fieldName = templateFieldName;
          }
          // Also try to get field from template
          if (!field) {
            field = this.getFieldById(fieldId);
          }
        }
        
        // If still not found, try to find by title from sub_data
        if (!field && parsedSubData?.field_title) {
          const fieldByTitle = this.fields.find(f => 
            f.title === parsedSubData.field_title && 
            f.type === (parsedSubData.field_type || 'radio')
          );
          if (fieldByTitle) {
            field = fieldByTitle;
            if (fieldByTitle.name) {
              fieldName = fieldByTitle.name;
            }
          }
        }
        
        // If field name lookup failed, try to find by field ID in current form fields again
        if (fieldName === fieldId) {
          const currentFormField = this.fields.find(f => f.id === parseInt(fieldId) || String(f.id) === String(fieldId));
          if (currentFormField && currentFormField.name) {
            fieldName = currentFormField.name;
            if (!field) {
              field = currentFormField;
            }
          }
        }
        
        // Try to find the form control by field name (try direct access first, then form.get)
        let formControl = this.form.controls[fieldName] || this.form.get(fieldName);
        
        // If form control not found by name, try to find by matching field in current form
        if (!formControl && field) {
          const matchingField = this.fields.find(f => f.id === field.id || (f.title === field.title && f.type === field.type));
          if (matchingField && matchingField.name) {
            fieldName = matchingField.name;
            formControl = this.form.controls[fieldName] || this.form.get(fieldName);
            // Update field reference to use the matching field
            if (!field || field.id !== matchingField.id) {
              field = matchingField;
            }
          }
        }
        
        if (formControl) {
          let dataToSet: any = null;
          let hasData = false;
          
          // Handle table fields specially (including fixed-rows-table)
          if (field && (field.type === 'table' || field.type === 'fixed-rows-table')) {
            // Collect all rows for this field from table_rows array
            // table_rows contains all table rows from getTemplateFormDataByQuery
            var tableData: any = []
            for (let index=0; index < this.table_rows.length; index++) {
              const item = this.table_rows[index];
              
              // Match fieldId (handle both string and number comparisons)
              const itemFieldId = String(item.field_id || '');
              const targetFieldId = String(fieldId || '');
              
              if (itemFieldId === targetFieldId) {
                try {
                  let parsedValue = JSON.parse(item.value);
                  parsedValue.id = item.id;
                  tableData.push(parsedValue);
                } catch (parseError) {
                  // Try to use value directly if parsing fails
                  if (item.value) {
                    tableData.push({ ...item.value, id: item.id });
                  }
                }
              }
            }

            if (field.type === 'fixed-rows-table' && Array.isArray(tableData) && tableData.length > 0) {
              const indexed = tableData.map((row: any, idx: number) => ({
                row,
                backendRowId: row?.id != null && row?.id !== undefined ? Number(row.id) : NaN,
                originalIndex: idx
              }));
              indexed.sort((a, b) => {
                const aOk = !Number.isNaN(a.backendRowId);
                const bOk = !Number.isNaN(b.backendRowId);
                if (aOk && bOk && a.backendRowId !== b.backendRowId) {
                  return a.backendRowId - b.backendRowId;
                }
                if (!aOk && !bOk) {
                  return a.originalIndex - b.originalIndex;
                }
                if (!aOk) {
                  return 1;
                }
                if (!bOk) {
                  return -1;
                }
                return a.backendRowId - b.backendRowId;
              });
              tableData = indexed.map((item) => item.row);
            }

            if (Array.isArray(tableData) && tableData.length > 0) {
              dataToSet = tableData;
              hasData = true;
            } else {
              // No rows found in table_rows, try using value directly
              if (value) {
                // If parsing fails, try to use the value directly if it's already an array
                try {
                  if (Array.isArray(value)) {
                    dataToSet = value;
                    hasData = value.length > 0;
                  } else if (typeof value === 'string') {
                    // Try parsing the value directly
                    const parsed = JSON.parse(value);
                    if (Array.isArray(parsed)) {
                      dataToSet = parsed;
                      hasData = parsed.length > 0;
                    } else {
                      dataToSet = [];
                      hasData = false;
                    }
                  } else {
                    dataToSet = [];
                    hasData = false;
                  }
                } catch (parseError) {
                  dataToSet = [];
                  hasData = false;
                }
              } else {
                dataToSet = [];
                hasData = false;
              }
            }
          } else {
            // Handle regular fields
            dataToSet = value;
            
            // For radio buttons, ensure the value matches one of the field options exactly
            if (field && field.type === 'radio') {
              const stringValue = String(value).trim();
              let matchedOption: any = undefined;
              
              // Get options from field first, then fallback to sub_data
              let options: any[] = [];
              if (field.options && Array.isArray(field.options)) {
                options = field.options;
              } else if (parsedSubData?.options && Array.isArray(parsedSubData.options)) {
                options = parsedSubData.options;
              }
              
              if (options.length > 0) {
                // First try exact match
                matchedOption = options.find((opt: any) => String(opt).trim() === stringValue);
                
                // If no exact match, try case-insensitive match
                if (!matchedOption) {
                  matchedOption = options.find((opt: any) => 
                    String(opt).trim().toLowerCase() === stringValue.toLowerCase()
                  );
                }
              }
              
              // If still no match, try matching with valueToLabelMap (reverse lookup)
              if (!matchedOption && field.valueToLabelMap) {
                // Find option where the label matches the value
                for (const [optValue, label] of Object.entries(field.valueToLabelMap)) {
                  if (String(label).trim().toLowerCase() === stringValue.toLowerCase() ||
                      String(optValue).trim().toLowerCase() === stringValue.toLowerCase()) {
                    matchedOption = optValue;
                    break;
                  }
                }
              }
              
              if (matchedOption !== undefined) {
                dataToSet = matchedOption;
              }
            }
            
            // For checkbox, ensure dataToSet is array (parse JSON string from API so toggleCheckbox preserves all selections)
            if (field && field.type === 'checkbox') {
              if (Array.isArray(value)) {
                dataToSet = value.map((v: any) => (typeof v === 'string' ? v : String(v)));
              } else if (typeof value === 'string' && value.trim()) {
                try {
                  const parsed = JSON.parse(value);
                  dataToSet = Array.isArray(parsed) ? parsed.map((v: any) => String(v)) : [];
                } catch {
                  dataToSet = value.split(',').map((s: string) => s.trim()).filter(Boolean);
                }
              } else {
                dataToSet = [];
              }
            }
            
            hasData = value !== null &&
                    value !== undefined &&
                    value !== '' &&
                    (typeof value !== 'string' || value.trim() !== '');
            }
        
          if (hasData) {
            // If backend already provided Age, keep it fixed (don't let DOB auto-calc overwrite it).
            const isAgeField =
              !!field &&
              typeof field.title === 'string' &&
              field.title.toLowerCase().includes('age') &&
              field.title.toLowerCase().includes('years');
            if (isAgeField) {
              this.fixedAgeFromBackend = { fieldName, value: dataToSet };
            }

            // Normalize table cell strings (trim + strip trailing slash) so dropdown selected value matches options
            if (field && (field.type === 'table' || field.type === 'fixed-rows-table') && Array.isArray(dataToSet)) {
              dataToSet = dataToSet.map((row: any) => {
                const r = { ...row };
                for (const k of Object.keys(r)) {
                  if (typeof r[k] === 'string') r[k] = this.normalizeTableCellValueForDisplay(r[k]);
                }
                return r;
              });
            }
            formControl.setValue(dataToSet);
            // Immediately disable the control after setting value to ensure it stays disabled
            formControl.disable({ emitEvent: false });
            fieldsWithData.push(fieldName);
            
            // Track original table data for new vs existing row detection
            if (field && (field.type === 'table' || field.type === 'fixed-rows-table')) {
              this.originalTableData[fieldName] = JSON.parse(JSON.stringify(dataToSet));
              this.clearTableRowReasons(fieldName);
            }
          } else {
            // Track empty table data
            if (field && (field.type === 'table' || field.type === 'fixed-rows-table')) {
              this.originalTableData[fieldName] = [];
              this.clearTableRowReasons(fieldName);
            }
          }

          if (documentLink || documentName || (Array.isArray((record as any).attachments) && (record as any).attachments.length > 0)) {
            // Pass the full record so storeExistingAttachment can also read the attachments array
            this.storeExistingAttachment(fieldName, {
              ...record,
              id: recordId,
              field_id: fieldId,
              document_link: documentLink,
              document_name: documentName,
              document_url: documentUrl,
              created_at: createdAt
            });
          }
        } else {
          // Log when form control is not found for debugging
          const fieldTitle = field ? field.title : 'Unknown';
          //console.warn(`⚠️ Form control not found for field_id: ${fieldId}, fieldName: ${fieldName}, fieldTitle: ${fieldTitle}`);
          
          // Try to parse sub_data to get field title if field is not found
          let parsedSubData: any = null;
          let subDataFieldTitle: string | null = null;
          try {
            if (record.sub_data) {
              parsedSubData = typeof record.sub_data === 'string' ? JSON.parse(record.sub_data) : record.sub_data;
              subDataFieldTitle = parsedSubData?.field_title || null;
            }
          } catch (e) {
            // Ignore parse errors
          }
          
          // Try multiple strategies to find the field
          let fieldByTitle: any = null;
          
          // Strategy 1: Use field.title if field was found
          if (field && field.title) {
            fieldByTitle = this.fields.find(f => f.title === field.title && f.type === field.type);
          }
          
          // Strategy 2: Use sub_data field_title if available
          if (!fieldByTitle && subDataFieldTitle) {
            fieldByTitle = this.fields.find(f => f.title === subDataFieldTitle && f.type === (parsedSubData?.field_type || 'radio'));
          }
          
          // Strategy 3: Try case-insensitive title match
          if (!fieldByTitle && (field?.title || subDataFieldTitle)) {
            const searchTitle = (field?.title || subDataFieldTitle || '').toLowerCase();
            fieldByTitle = this.fields.find(f => 
              f.title?.toLowerCase() === searchTitle && 
              f.type === (field?.type || parsedSubData?.field_type || 'radio')
            );
          }
          
          // Strategy 4: Find by field ID in current form fields
          if (!fieldByTitle) {
            fieldByTitle = this.fields.find(f => f.id === parseInt(fieldId) || String(f.id) === String(fieldId));
          }
          
          if (fieldByTitle && fieldByTitle.name) {
            let fallbackFormControl = this.form.get(fieldByTitle.name);
            
            // If form control not found by name, try to find it by checking all form controls
            // and matching by field ID in this.fields
            if (!fallbackFormControl) {
              // Try to find form control by matching field ID
              const fieldById = this.fields.find(f => f.id === parseInt(fieldId) || String(f.id) === String(fieldId));
              if (fieldById && fieldById.name) {
                fallbackFormControl = this.form.get(fieldById.name);
              }
            }
            
            // If still not found, try to find by iterating through all form controls
            // and matching with field title (case-insensitive)
            if (!fallbackFormControl) {
              const searchTitle = (field?.title || subDataFieldTitle || '').toLowerCase().trim();
              const matchingField = this.fields.find(f => 
                f.title?.toLowerCase().trim() === searchTitle && 
                f.type === (field?.type || parsedSubData?.field_type || 'radio')
              );
              if (matchingField && matchingField.name) {
                fallbackFormControl = this.form.get(matchingField.name);
                if (fallbackFormControl) {
                  //console.log(`🔍 Found form control by title match: "${matchingField.name}" for field_id: ${fieldId}`);
                  // Update fieldByTitle to use the matching field
                  fieldByTitle = matchingField;
                }
              }
            }
            
            // If still not found, list all available form control names for debugging
            if (!fallbackFormControl) {
              const allControlNames = Object.keys(this.form.controls);
              //console.warn(`⚠️ Form control "${fieldByTitle.name}" not found in form. Available controls:`, allControlNames);
              //console.warn(`⚠️ Field details - ID: ${fieldId}, Title: ${field?.title || subDataFieldTitle}, Found field name: ${fieldByTitle.name}`);
              
              // Strategy 1: Try to find by field ID first (most reliable)
              const fieldById = this.fields.find(f => f.id === parseInt(fieldId) || String(f.id) === String(fieldId));
              if (fieldById && fieldById.name) {
                // Try direct access first, then form.get
                const controlByName = this.form.controls[fieldById.name] || this.form.get(fieldById.name);
                if (controlByName) {
                  fallbackFormControl = controlByName;
                  fieldByTitle = fieldById;
                  //console.log(`🔍 Found form control by field ID match: "${fieldById.name}" for field_id: ${fieldId}`);
                } else {
                  //console.warn(`⚠️ Field ID ${fieldId} found with name "${fieldById.name}" but control not found in form`);
                }
              }
              
              // Strategy 2: Try exact name match from fieldName (the original field name from record)
              if (!fallbackFormControl && fieldName) {
                // Try direct access first, then form.get
                fallbackFormControl = this.form.controls[fieldName] || this.form.get(fieldName);
                if (fallbackFormControl) {
                  const fieldByOriginalName = this.fields.find(f => f.name === fieldName);
                  if (fieldByOriginalName) {
                    fieldByTitle = fieldByOriginalName;
                  }
                  //console.log(`🔍 Found form control by original field name: "${fieldName}" for field_id: ${fieldId}`);
                }
              }
              
              // Strategy 2.5: Try exact name match from fieldByTitle.name (in case fieldName didn't match)
              if (!fallbackFormControl && fieldByTitle && fieldByTitle.name) {
                fallbackFormControl = this.form.controls[fieldByTitle.name] || this.form.get(fieldByTitle.name);
                if (fallbackFormControl) {
                  //console.log(`🔍 Found form control by fieldByTitle.name: "${fieldByTitle.name}" for field_id: ${fieldId}`);
                }
              }
              
              // Strategy 3: Try to find a control that contains similar characters (fuzzy match)
              if (!fallbackFormControl) {
                const normalizedSearchName = (field?.title || subDataFieldTitle || '').toLowerCase().replace(/\s+/g, '_');
                const fuzzyMatch = allControlNames.find(controlName => {
                  const normalizedControl = controlName.toLowerCase();
                  // Check if control name contains key parts of the search name
                  const searchParts = normalizedSearchName.split('_').filter(p => p.length > 2);
                  return searchParts.some(part => normalizedControl.includes(part));
                });
                
                if (fuzzyMatch) {
                  // Since fuzzyMatch comes from allControlNames, the control should exist
                  // Try to get the control - use direct access first, then form.get as fallback
                  fallbackFormControl = this.form.controls[fuzzyMatch] || this.form.get(fuzzyMatch);
                  
                  if (fallbackFormControl) {
                    //console.log(`🔍 Found form control by fuzzy match: "${fuzzyMatch}" for field_id: ${fieldId}`);
                    
                    // Find the actual field that matches this control name
                    const matchingFieldByControlName = this.fields.find(f => f.name === fuzzyMatch);
                    if (matchingFieldByControlName) {
                      fieldByTitle = matchingFieldByControlName;
                      //console.log(`🔍 Updated fieldByTitle to match control name: "${fuzzyMatch}"`);
                    } else {
                      // Try to find by field ID as fallback
                      const matchingFieldById = this.fields.find(f => f.id === parseInt(fieldId) || String(f.id) === String(fieldId));
                      if (matchingFieldById) {
                        fieldByTitle = matchingFieldById;
                        //console.log(`🔍 Updated fieldByTitle by field ID for fuzzy match: "${fuzzyMatch}"`);
                      }
                    }
                  } else {
                    // Debug: Try to see what's in form.controls
                  }
                }
              }
            }
            
            // Log value information for debugging
            if (fallbackFormControl) {
              //console.log(`🔍 Form control found for field_id: ${fieldId}, value from record:`, value, `(type: ${typeof value}, isNull: ${value === null}, isUndefined: ${value === undefined}, isEmpty: ${value === ''})`);
            }
            
            if (fallbackFormControl && value !== null && value !== undefined && value !== '') {
              let valueToSet = value;
              
              // For radio buttons, ensure the value matches one of the field options exactly
              if (fieldByTitle && fieldByTitle.type === 'radio') {
                const stringValue = String(value).trim();
                let matchedOption: any = undefined;
                
                // Get options from field first, then fallback to sub_data
                let options: any[] = [];
                if (fieldByTitle.options && Array.isArray(fieldByTitle.options)) {
                  options = fieldByTitle.options;
                } else if (parsedSubData?.options && Array.isArray(parsedSubData.options)) {
                  options = parsedSubData.options;
                }
                
                if (options.length > 0) {
                  // First try exact match
                  matchedOption = options.find((opt: any) => String(opt).trim() === stringValue);
                  
                  // If no exact match, try case-insensitive match
                  if (!matchedOption) {
                    matchedOption = options.find((opt: any) => 
                      String(opt).trim().toLowerCase() === stringValue.toLowerCase()
                    );
                  }
                }
                
                // If still no match, try matching with valueToLabelMap (reverse lookup)
                if (!matchedOption && fieldByTitle.valueToLabelMap) {
                  // Find option where the label matches the value
                  for (const [optValue, label] of Object.entries(fieldByTitle.valueToLabelMap)) {
                    if (String(label).trim().toLowerCase() === stringValue.toLowerCase() ||
                        String(optValue).trim().toLowerCase() === stringValue.toLowerCase()) {
                      matchedOption = optValue;
                      break;
                    }
                  }
                }
                
                if (matchedOption !== undefined) {
                  valueToSet = matchedOption;
                  //console.log(`🔄 Radio button value matched (fallback): "${value}" -> "${matchedOption}" for field "${fieldByTitle.name}"`);
                } else {
                  //console.warn(`⚠️ Radio button value "${value}" not found in options for field "${fieldByTitle.name}". Available options:`, options.length > 0 ? options : 'none');
                }
              }
              
              try {
                fallbackFormControl.setValue(valueToSet);
                // Immediately disable the control after setting value to ensure it stays disabled
                fallbackFormControl.disable({ emitEvent: false });
                // Use fieldByTitle.name as the primary field name for locking (this is what lockFields expects)
                // This ensures lockFields can find and disable the correct control
                const fieldNameForLocking = fieldByTitle && fieldByTitle.name ? fieldByTitle.name : 
                  (Object.keys(this.form.controls).find(name => this.form.get(name) === fallbackFormControl) || 'unknown');
                
                // Verify the field name exists in form controls before adding to fieldsWithData
                if (this.form.controls[fieldNameForLocking] || this.form.get(fieldNameForLocking)) {
                  fieldsWithData.push(fieldNameForLocking);
                  //console.log(`✅ Set form control "${fieldNameForLocking}" (fallback by title, from field_id: ${fieldId}) to:`, valueToSet);
                  //console.log(`🔒 Field "${fieldNameForLocking}" will be locked after data load`);
                } else {
                  //console.warn(`⚠️ Field name "${fieldNameForLocking}" not found in form controls, cannot lock field for field_id: ${fieldId}`);
                }
              } catch (error) {
                //console.error(`❌ Error setting form control value for field_id: ${fieldId}:`, error);
                //console.warn(`⚠️ Form control found but failed to set value. Control:`, fallbackFormControl, `Value:`, valueToSet);
              }
            } else if (!fallbackFormControl) {
              //console.warn(`⚠️ Form control not found for field_id: ${fieldId}, tried name: "${fieldByTitle ? fieldByTitle.name : 'unknown'}", title: "${field?.title || subDataFieldTitle}"`);
            } else {
              //console.warn(`⚠️ Form control found but value is empty/null for field_id: ${fieldId}, value:`, value);
            }
          } else {
            //console.warn(`⚠️ Could not find field in this.fields for field_id: ${fieldId}, title: ${field?.title || subDataFieldTitle || 'Unknown'}`);
          }
        }
      });

      // Update PI signature review status for this form
      if (this.currentForm) {
        this.setPiSignatureReviewed(formPiCheckStatus, formPiReviewedBy, formPiReviewedAt, formPiComment);
      }

    } else if (data && typeof data === 'object') {
      // Handle object structure (legacy format with field names as keys)
      Object.keys(data).forEach(key => {
        const fieldData = data[key];
        const formControl = this.form.get(key);
        
        
        if (formControl && fieldData) {
          const value = fieldData.value || fieldData;
          const piCheck = fieldData.pi_check;
          
          // Track PI check status
          if (piCheck === true || piCheck === 1) {
            formPiCheckStatus = true;
          }
          
          // Find the field definition to check if it's a radio button
          const field = this.fields.find(f => f.name === key);
          let valueToSet = value;
          
          // For radio buttons, ensure the value matches one of the field options exactly
          if (field && field.type === 'radio' && field.options && Array.isArray(field.options)) {
            const stringValue = String(value).trim();
            // First try exact match
            let matchedOption = field.options.find((opt: any) => String(opt).trim() === stringValue);
            
            // If no exact match, try case-insensitive match
            if (!matchedOption) {
              matchedOption = field.options.find((opt: any) => 
                String(opt).trim().toLowerCase() === stringValue.toLowerCase()
              );
            }
            
            // If still no match, try matching with valueToLabelMap (reverse lookup)
            if (!matchedOption && field.valueToLabelMap) {
              // Find option where the label matches the value
              for (const [optValue, label] of Object.entries(field.valueToLabelMap)) {
                if (String(label).trim().toLowerCase() === stringValue.toLowerCase() ||
                    String(optValue).trim().toLowerCase() === stringValue.toLowerCase()) {
                  matchedOption = optValue;
                  break;
                }
              }
            }
            
            if (matchedOption !== undefined) {
              valueToSet = matchedOption;
            }
          }
          
          const hasData = Array.isArray(valueToSet) ? valueToSet.length > 0 :
                        valueToSet !== null && 
                        valueToSet !== undefined && 
                        valueToSet !== '' && 
                        (typeof valueToSet !== 'string' || valueToSet.trim() !== '');
          
          if (hasData) {
            formControl.setValue(valueToSet);
            // Immediately disable the control after setting value to ensure it stays disabled
            formControl.disable({ emitEvent: false });
            fieldsWithData.push(key);
          } else {
          }
        }
      });

      // Update PI signature review status for this form
      if (this.currentForm) {
        this.setPiSignatureReviewed(formPiCheckStatus, undefined, undefined);
      }
    }
    
    // Lock only fields that have data from SQL
    if (fieldsWithData.length > 0) {
      this.lockFields(fieldsWithData, 'Data exists from previous submission');
    }
    
    // Re-apply locks to any fields that were previously locked (safeguard)
    // This ensures fields remain disabled even if they weren't in the current data load
    Object.keys(this.fieldLockStatus).forEach(fieldName => {
      if (this.fieldLockStatus[fieldName]?.isLocked) {
        const formControl = this.form?.get(fieldName);
        if (formControl && !formControl.disabled) {
          formControl.disable();
        }
      }
    });
    
    // Prefetch query status once the form data and table rows are ready
    this.prefetchQueryStatusesForCurrentForm();
    // Prefetch review status once the form data and table rows are ready
    this.prefetchReviewStatusesForCurrentForm();

    // Trigger change detection after data is loaded to ensure dropdowns update properly
    // This is especially important for table dropdowns that are rendered after async data fetch
    setTimeout(() => {
      this.cdr.detectChanges();
      
      // Additional safeguard: Disable all form controls that have non-empty values
      // This catches any fields that may have been missed in the fieldsWithData array
      // (e.g., due to field name matching issues)
      // Run this AFTER change detection to ensure all setValue operations have completed
      if (this.form) {
        Object.keys(this.form.controls).forEach(fieldName => {
          const formControl = this.form.get(fieldName);
          if (formControl && !formControl.disabled) {
            const value = formControl.value;
            // Check if the field has a non-empty value
            const hasValue = value !== null && 
                            value !== undefined && 
                            value !== '' && 
                            !(Array.isArray(value) && value.length === 0) &&
                            !(typeof value === 'object' && Object.keys(value).length === 0);
            
            if (hasValue) {
              // Lock and disable the field if it has data
              this.fieldLockStatus[fieldName] = {
                isLocked: true,
                lockedAt: new Date().toISOString(),
                lockedBy: 'Data exists from previous submission'
              };
              formControl.disable({ emitEvent: false });
            }
          }
        });
      }
    }, 0);
    
    // Disable all form controls if user is Monitor, Data Manager, or CRO (after data is loaded)
    if (this.isFieldDisabledUser()) {
      this.disableAllFormControls();
    }

    // Capture baseline hash after data is populated
    this.updateInitialFormDataHash();
    
    // Populate fixed-rows-table from template after load, then refresh query row marks on final grid state
    setTimeout(() => {
      this.populateFixedRowsTableFromValue();
      this.prefetchQueryStatusesForCurrentForm();
    }, 100);
  }

  // Load form data from API
  private loadFormDataFromAPI(form: any): void {
    // Check if we have valid required IDs
    if (!this.study_id || !this.subject_id) {
      return;
    }

    // Get the required parameters for the API call as requested
    const studyId = this.study_id;
    const subjectId = this.subject_id;
    const formId = form.id || form.name; // Use form ID or name as form_id
    // Call the API to get form data using the template endpoint
    // Using the get-form-data endpoint with query parameters
    // Clear table_rows before loading new data to ensure we don't mix old and new data
    this.table_rows = [];
    
    this.apiService.getTemplateFormDataByQuery(studyId, subjectId, formId).subscribe(
      (response) => {
        const responseData = Array.isArray(response?.data) ? response.data : [];
        if (responseData.length > 0) {
          // Collect all table-related rows (including fixed-rows-table) into table_rows array
          // This must happen before setFormDataWithLockStatus so all rows are available
          responseData.forEach((item: any) => {
            const field = this.getFieldById(item.field_id);
            // Store all table-related rows in table_rows array
            if (field && (field.type === 'table' || field.type === 'fixed-rows-table')) {
              this.table_rows.push(item);
            }
          });
          
          // Log table fields for debugging
          const tableFields = responseData.filter((item: any) => {
            const field = this.getFieldById(item.field_id);
            return field && (field.type === 'table' || field.type === 'fixed-rows-table');
          });
          
        }
        
        // Populate form with the loaded data and lock status (even if no data)
        this.setFormDataWithLockStatus(responseData);
        
        // Map study details if available in response
        if (response && response.studyDetails) {
          this.mapStudyDetails(response.studyDetails);
        }
        // Set participant_id from response (e.g. when data is empty but backend returns participant_id)
        if (response && response.participant_id != null && response.participant_id !== undefined) {
          this.participantId = String(response.participant_id);
          this.cdr.detectChanges();
        }

        // Capture hash for the fetched state (including empty state)
        this.updateInitialFormDataHash();
      },
      (error) => {
        // Continue with empty form if data loading fails
        this.updateInitialFormDataHash();
      }
    );
  }

  // Setup dependencies when opening a form
  private setupFormDependencies(form: any): void {
    if (!form.fields || form.fields.length === 0) {
      return;
    }

    // Process each field in the current form
    form.fields.forEach((field: any, fieldIndex: number) => {
      if (field.hasDependency && field.dependency) {
        // Ensure dependency object has all required properties
        this.ensureDependencyProperties(field, fieldIndex);
        
        // Resolve dependency field name if not already set
        if (!field.dependencyFieldName) {
          field.dependencyFieldName = this.resolveDependencyFieldName(field.dependency);
        }
        
        // Update dependency registries
        this.updateDependencyRegistries(field, fieldIndex);
        
        // Setup dependency field listener
        this.setupDependencyFieldListener(field);
      }
    });
  }

  // Ensure dependency object has all required properties
  private ensureDependencyProperties(field: any, fieldIndex: number): void {
    const dependency = field.dependency;
    
    // Set folderId if not present (assume current folder)
    if (!dependency.folderId) {
      dependency.folderId = this.selectedFolderId || '0';
    }
    
    // Set formId if not present (assume current form)
    if (!dependency.formId) {
      dependency.formId = this.currentForm?.id || '0';
    }
    
    // Ensure other required properties exist
    if (!dependency.fieldId) {
      // Field ID is required
    }
    
    if (!dependency.triggerValue) {
      // Trigger value is optional
    }
  }

  // Resolve dependency field name from dependency information
  private resolveDependencyFieldName(dependency: any): string | null {
    if (!dependency.fieldId) {
      return null;
    }

    try {
      // If we have the template structure, use it to resolve the field name
      if (this.template && this.template.folders) {
        const folderIndex = parseInt(dependency.folderId) || 0;
        const formIndex = parseInt(dependency.formId) || 0;
        const fieldIndex = parseInt(dependency.fieldId);
        
        const dependencyFolder = this.template.folders[folderIndex];
        if (dependencyFolder && dependencyFolder.forms) {
          const dependencyForm = dependencyFolder.forms[formIndex];
          if (dependencyForm && dependencyForm.fields) {
            const dependencyField = dependencyForm.fields[fieldIndex];
            if (dependencyField) {
              return dependencyField.name || dependencyField.title?.toLowerCase().replace(/\s+/g, '_');
            }
          }
        }
      }
      
      // Fallback: try to use the fieldTitle or fieldName from dependency
      if (dependency.fieldTitle) {
        return dependency.fieldTitle.toLowerCase().replace(/\s+/g, '_');
      }
      
      if (dependency.fieldName) {
        return dependency.fieldName;
      }
      
      return null;
    } catch (error) {
      return null;
    }
  }

  // Update dependency registries
  private updateDependencyRegistries(field: any, fieldIndex: number): void {
    if (!field.dependencyFieldName) {
      return;
    }

    const dependency = field.dependency;
    
    // Update dependency field registry
    const dependencyKey = `${dependency.folderId}_${dependency.formId}_${dependency.fieldId}`;
    this.dependencyFieldRegistry[dependencyKey] = {
      fieldName: field.dependencyFieldName,
      fieldTitle: dependency.fieldTitle || field.dependencyFieldName,
      fieldType: dependency.fieldType,
      options: dependency.options || []
    };

    // Register global dependency
    const globalDependencyKey = `${dependency.folderId}_${dependency.formId}_${field.dependencyFieldName}`;
    if (!this.globalDependencies[globalDependencyKey]) {
      this.globalDependencies[globalDependencyKey] = [];
    }
    
    // Check if this dependency is already registered
    const existingDependency = this.globalDependencies[globalDependencyKey].find(
      dep => dep.fieldName === field.name
    );
    
    if (!existingDependency) {
      this.globalDependencies[globalDependencyKey].push({
        folderId: this.selectedFolderId || '0',
        formId: this.currentForm?.id || '0',
        fieldName: field.name,
        fieldTitle: field.title,
        triggerValue: dependency.triggerValue
      });
    }
  }

  // Setup dependency field listener for a specific field
  private setupDependencyFieldListener(field: any): void {
    if (!field.dependencyFieldName) {
      return;
    }

    const dependencyControl = this.form.get(field.dependencyFieldName);
    if (dependencyControl) {
      // Subscribe to value changes of the dependency field
      dependencyControl.valueChanges.subscribe(value => {
        // Check validation for all fields when dependency value changes
        setTimeout(() => {
          this.checkFieldValidations(this.getFormValuesForValidation());
        }, 100);
        // Trigger change detection to update dependent field visibility
        this.cdr.detectChanges();
      });
    } else {
    }
  }

  // Initialize form values cache for cross-form dependencies
  private initializeFormValuesCache(): void {
    // Cache current form field values
    this.fields.forEach(field => {
      const formKey = `${this.selectedFolderId}_${this.currentForm?.name}_${field.name}`;
      const fieldValue = this.form.get(field.name)?.value;
      this.formValuesCache[formKey] = fieldValue;
    });
  }

  // Helper method to get the dependency field name from current selection

  // Helper method to get the dependency field name
  private getDependencyFieldName(dependency: any): string | null {
    if (!dependency.folderId || !dependency.formId || !dependency.fieldId) {
      return null;
    }

    // Try to get from registry first
    const dependencyKey = `${dependency.folderId}_${dependency.formId}_${dependency.fieldId}`;
    const registryEntry = this.dependencyFieldRegistry[dependencyKey];
    if (registryEntry) {
      return registryEntry.fieldName;
    }

    // Note: availableFields was removed with field creation functionality
    // This fallback is no longer available

    // Fallback: try to find in current form fields
    const currentField = this.fields.find(f => 
      f.dependency && 
      f.dependency.folderId === dependency.folderId &&
      f.dependency.formId === dependency.formId &&
      f.dependency.fieldId === dependency.fieldId
    );
    
    if (currentField) {
      return currentField.name;
    }
    
    return null;
  }

  // Function to map study details
  mapStudyDetails(studyDetails: any): void {
    if (studyDetails) {
      // Check if studyDetails has the expected properties
      this.studyCode = studyDetails.study_code ?? this.study_id ?? 'N/A';  // Use study_id as fallback
      this.study_name = studyDetails.study_name ?? this.study_name ?? 'Unknown Study';  // Update study_name if available
      this.siteLocation = studyDetails.site_location ?? 'Unknown Location';  // Default to 'Unknown Location' if site_location is undefined
      this.subjectName = studyDetails.subject_name ?? studyDetails.subject_id ?? 'N/A';  // Use subject_id as fallback
      this.participantId = studyDetails.participant_id != null && studyDetails.participant_id !== undefined
        ? String(studyDetails.participant_id) : this.participantId;
    } else {
      // Set default values from existing properties
      this.studyCode = this.study_id ?? 'N/A';
      this.subjectName = 'N/A';
    }
  }

  private isDobField(field?: any): boolean {
    const title = String(field?.title ?? '').toLowerCase();
    return title.includes('date of birth') || title.includes('dob');
  }

  private getTodayIsoDate(): string {
    return new Date().toISOString().split('T')[0];
  }

  // Allow future dates for non-DOB date inputs; keep DOB bounded.
  getMaxDateForField(field?: any): string {
    return this.isDobField(field) ? this.getTodayIsoDate() : '2100-12-31';
  }

  // Get maximum date for date inputs (far future; DOB handled separately)
  getMaxDate(): string {
    return '2100-12-31';
  }

  // Date validation for DOB (4-digit year)
  validateDOBYear(event: any, field?: any): void {
    const input = event.target;
    const value = input.value;
    
    if (value) {
      // For date inputs, the format is YYYY-MM-DD
      const dateParts = value.split('-');
      if (dateParts.length === 3) {
        const year = dateParts[0];
        
        // Check if year is exactly 4 digits
        if (year.length !== 4 || !/^\d{4}$/.test(year)) {
          // Set validation error message
          input.setCustomValidity('Year must be exactly 4 digits (e.g., 1990)');
          return;
        }
        
        // Validate year range:
        // - For DOB fields: 1900..current year (cannot be in the future)
        // - For other date fields: keep only a reasonable lower bound; allow future years
        const currentYear = new Date().getFullYear();
        const yearNum = parseInt(year);

        if (yearNum < 1900) {
          input.setCustomValidity('Year must be 1900 or later');
          return;
        }

        if (this.isDobField(field) && yearNum > currentYear) {
          input.setCustomValidity(`Year must be between 1900 and ${currentYear}`);
          return;
        }
        
        // Clear any previous validation errors
        input.setCustomValidity('');
      }
    } else {
      // Clear validation errors when field is empty
      input.setCustomValidity('');
    }
    
    // Update form control value
    const fieldName = input.getAttribute('formControlName');
    if (fieldName && this.form.get(fieldName)) {
      this.form.get(fieldName)?.setValue(value);
    }
  }

  // Auto-calculate age from date of birth
  updateAge(): void {
    // Find DOB and Age fields
    const dobField = this.fields.find(f => f.title.toLowerCase().includes('date of birth') || f.title.toLowerCase().includes('dob'));
    const ageField = this.fields.find(f => f.title.toLowerCase().includes('age') && f.title.toLowerCase().includes('years'));
    
    if (dobField && ageField && this.form.get(dobField.name)) {
      // If Age came from backend (saved data), keep it fixed unless user clears it manually.
      if (this.fixedAgeFromBackend?.fieldName === ageField.name) {
        const currentAge = this.form.get(ageField.name)?.value;
        if (currentAge !== null && currentAge !== undefined && String(currentAge).trim() !== '') {
          return;
        }
      }

      const dobValue = this.form.get(dobField.name)?.value;
      
      if (dobValue) {
        const dob = new Date(dobValue);
        const today = new Date();
        
        let years = today.getFullYear() - dob.getFullYear();
        let months = today.getMonth() - dob.getMonth();
        const dayDiff = today.getDate() - dob.getDate();
        
        if (months < 0 || (months === 0 && dayDiff < 0)) {
          years--;
          months += 12;
        }
        
        if (dayDiff < 0) {
          months--;
          if (months < 0) {
            months += 12;
            years--;
          }
        }
        
        const calculatedAge = `${years} Years ${months} Months`;
        this.form.get(ageField.name)?.setValue(calculatedAge);
      }
    }
  }

  // Auto-calculate BMI from weight and height (similar to screening component)
  calculateBMI(): void {
    // Find Weight, Height, and BMI fields
    const weightField = this.fields.find(f => f.title.toLowerCase().includes('weight') && f.title.toLowerCase().includes('kg'));
    const heightField = this.fields.find(f => f.title.toLowerCase().includes('height') && f.title.toLowerCase().includes('m'));
    const bmiField = this.fields.find(f => f.title.toLowerCase().includes('bmi') || f.title.toLowerCase().includes('body mass index'));
    
    if (weightField && heightField && bmiField && 
        this.form.get(weightField.name) && this.form.get(heightField.name)) {
      
      const weightRaw = this.form.get(weightField.name)?.value;
      const heightRaw = this.form.get(heightField.name)?.value;

      // Support decimals entered with either "." or "," (common locale difference).
      const weight = parseFloat(String(weightRaw ?? '').replace(',', '.'));
      const height = parseFloat(String(heightRaw ?? '').replace(',', '.'));

      if (Number.isFinite(weight) && Number.isFinite(height) && weight > 0 && height > 0) {
        const bmi = parseFloat((weight / (height * height)).toFixed(1));
        this.form.get(bmiField.name)?.setValue(bmi);
      } else {
        // If inputs are incomplete/invalid, don't force BMI to 0 (keeps "exact" behavior).
        this.form.get(bmiField.name)?.setValue('');
      }
    } else {
    }
  }

  // Handle field value changes for calculations
  onFieldValueChange(field: any, value: any): void {
    // Check if this is a DOB field and trigger age calculation
    if (field.title.toLowerCase().includes('date of birth') || field.title.toLowerCase().includes('dob')) {
      setTimeout(() => this.updateAge(), 100); // Small delay to ensure form value is updated
    }
    
    // Check if this is a weight or height field and trigger BMI calculation
    if ((field.title.toLowerCase().includes('weight') && field.title.toLowerCase().includes('kg')) ||
        (field.title.toLowerCase().includes('height') && field.title.toLowerCase().includes('m'))) {
      setTimeout(() => this.calculateBMI(), 100); // Small delay to ensure form value is updated
    }
  }

  /**
   * Check if a field should prevent negative values based on validation options
   * @param fieldTitle - The title of the field to check
   * @returns true if the field should not accept negative values
   */
  shouldPreventNegative(fieldTitle: string): boolean {
    const title = fieldTitle.toLowerCase();
    return this.validationOptions.preventNegativeFields.some(fieldType => 
      title.includes(fieldType)
    );
  }

  /**
   * Validate and correct negative values for number fields
   * @param fieldTitle - The title of the field
   * @param value - The current value
   * @param event - The input event
   * @returns the corrected value
   */
  validateNegativeNumber(fieldTitle: string, value: any, event: any): any {
    // Don't apply negative correction when value contains '/' or '\' (e.g. ratios, paths)
    const strVal = String(value ?? '');
    if (strVal.includes('/') || strVal.includes('\\')) {
      return value;
    }
    if (this.shouldPreventNegative(fieldTitle)) {
      const numValue = parseFloat(value);
      if (!isNaN(numValue) && numValue < 0) {
        const correctedValue = this.validationOptions.autoCorrectToZero ? 0 : Math.abs(numValue);
        event.target.value = correctedValue;
        
        if (this.validationOptions.showWarning) {
        }
        
        return correctedValue;
      }
    }
    return value;
  }

  // Handle number field input events (similar to screening component approach)
  onNumberFieldInput(field: any, event: any): void {
    const originalValue = event.target.value;
    let value = originalValue;
    
    // Validate and correct negative values based on options
    value = this.validateNegativeNumber(field.title, value, event);
    
    // IMPORTANT: Don't forcibly rewrite the control value on every keystroke.
    // Doing so on <input type="number"> often breaks decimal typing (caret jumps / "." not accepted).
    // Only push a value when we actually corrected it (e.g., negative -> 0).
    if (value !== originalValue && this.form.get(field.name)) {
      this.form.get(field.name)?.setValue(value);
    }
    // Check if this is a weight or height field and trigger BMI calculation immediately
    if ((field.title.toLowerCase().includes('weight') && field.title.toLowerCase().includes('kg')) ||
        (field.title.toLowerCase().includes('height') && field.title.toLowerCase().includes('m'))) {
      // Trigger BMI calculation immediately like in screening component
      this.calculateBMI();
    }
  }

  // Handle table number field input events
  onTableNumberInput(field: any, column: any, rowIndex: number, colIndex: number, event: any): void {
    let value = event.target.value;
    const controlName = this.createAlphabeticControlName(field.name, rowIndex, colIndex);
    
    // Validate and correct negative values based on options
    value = this.validateNegativeNumber(column.title, value, event);
    
    // Update the form control value immediately
    if (this.form.get(controlName)) {
      this.form.get(controlName)?.setValue(value);
    }
    // Check if this is a weight or height column and trigger BMI calculation
    if ((column.title.toLowerCase().includes('weight') && column.title.toLowerCase().includes('kg')) ||
        (column.title.toLowerCase().includes('height') && column.title.toLowerCase().includes('m'))) {
      // Trigger BMI calculation immediately like in screening component
      this.calculateBMI();
    }
  }

  // Get minimum date for date inputs (1900-01-01)
  getMinDate(): string {
    return '1900-01-01';
  }

  // New table functionality - simple and clean implementation
  
  // Get table data for a field
  // Get columns excluding Sr. No for fixed-rows-table
  getTableColumnsExcludingSrNo(field: any): any[] {
    if (field.type === 'fixed-rows-table') {
      return field.columns ? field.columns.filter((col: any) => !col.isSrNo && col.name !== '_sr_no') : [];
    }
    return field.columns || [];
  }

  private hasMeaningfulCellValue(value: any): boolean {
    if (value == null) return false;
    if (typeof value === 'string') return value.trim() !== '';
    if (typeof value === 'number') return !Number.isNaN(value);
    if (typeof value === 'boolean') return value;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === 'object') return Object.keys(value).length > 0;
    return !!value;
  }

  private getFixedRowsDataColumns(field: any): any[] {
    const columns = this.getTableColumnsExcludingSrNo(field);
    const statementColumns = columns.filter((col: any) => col.type === 'statement');
    const dataColumns = columns.filter((col: any) => col.type !== 'statement' && !col.readOnly);

    if (statementColumns.length === 0 && dataColumns.length === columns.length && columns.length > 0) {
      return columns.slice(1).filter((col: any) => !col.readOnly);
    }

    return dataColumns;
  }

  private hasFixedRowsRowDataInRow(field: any, row: any): boolean {
    if (!row || typeof row !== 'object') {
      return false;
    }
    const dataColumns = this.getFixedRowsDataColumns(field);
    if (dataColumns.length === 0) {
      return false;
    }
    return dataColumns.some((col: any) => {
      const columnKey = this.getDataColumnKey(field, col);
      return this.hasMeaningfulCellValue(row[columnKey]);
    });
  }

  private getOriginalFixedRowsRow(field: any, rowIndex: number): any {
    const originalData = this.originalTableData[field.name] || [];
    if (!Array.isArray(originalData) || originalData.length === 0) {
      return null;
    }

    const matchedByIndex = originalData.find((row: any) => {
      if (row?.row_index === undefined || row?.row_index === null) return false;
      const parsedIndex = Number(row.row_index);
      return !Number.isNaN(parsedIndex) && parsedIndex === rowIndex;
    });

    return matchedByIndex || originalData[rowIndex] || null;
  }

  private hasFixedRowsRowData(field: any, rowIndex: number): boolean {
    const originalRow = this.getOriginalFixedRowsRow(field, rowIndex);
    return this.hasFixedRowsRowDataInRow(field, originalRow);
  }

  isFixedRowsRowLocked(field: any, rowIndex: number): boolean {
    const tableData = this.getTableData(field.name);
    const row = tableData[rowIndex];
    if (row && !row.id && !row.existing_row_id) {
      return false;
    }
    const isLocked = this.editableRowIndex !== rowIndex && this.hasFixedRowsRowData(field, rowIndex);
    return isLocked;
  }

  isTableRowLocked(field: any, rowIndex: number): boolean {
    const tableData = this.getTableData(field.name);
    const row = tableData[rowIndex];
    // Fetched rows (with id) should always be non-editable.
    if (this.editableRowIndex === rowIndex) {
      return false;
    }
    return !!(row && (row.id || row.existing_row_id));
  }

  /**
   * Get the data column key used to read/write row values (col_0, col_1, ...).
   * Uses column.name when set by backend, otherwise the index in getTableColumnsExcludingSrNo
   * so the first data column is always col_0 regardless of whether Sr. No exists in field.columns.
   */
  getDataColumnKey(field: any, column: any): string {
    if (column?.name) return column.name;
    const dataCols = this.getTableColumnsExcludingSrNo(field);
    const idx = dataCols.indexOf(column);
    return idx >= 0 ? `col_${idx}` : 'col_0';
  }

  // Get Sr. No column for fixed-rows-table
  getSrNoColumn(field: any): any {
    if (field.type === 'fixed-rows-table' && field.columns) {
      return field.columns.find((col: any) => col.isSrNo || col.name === '_sr_no');
    }
    return null;
  }

  // Get the second column (first non-SrNo column) for fixed-rows-table
  getSecondColumn(field: any): any {
    if (field.type === 'fixed-rows-table' && field.columns) {
      const nonSrNoColumns = field.columns.filter((col: any) => !col.isSrNo && col.name !== '_sr_no');
      return nonSrNoColumns.length > 0 ? nonSrNoColumns[0] : null;
    }
    return null;
  }

  private getFieldLockFreezeStatus(field?: any): { isLocked: boolean; isFrozen: boolean } {
    const folder = this.getCurrentFolder();
    const form = this.currentForm;
    const isLocked = !!(folder?.is_locked || form?.is_locked || field?.is_locked);
    const isFrozen = !!(folder?.is_frozen || form?.is_frozen || field?.is_frozen);
    return { isLocked, isFrozen };
  }

  private shouldBlockEditByLockFreeze(field?: any): boolean {
    const status = this.getFieldLockFreezeStatus(field);
    console.log("Status:", status);
    return status.isLocked || status.isFrozen;
  }

  private showLockFreezeMessage(status: { isLocked: boolean; isFrozen: boolean }): void {
    if (status.isFrozen) {
      alert('The Field is freezed. Please contact the Monitor or Data Manager to unlock it.');
      return;
    }
    if (status.isLocked) {
      alert('The Field is locked. Please contact the Monitor or Data Manager to unlock it.');
    }
  }

  // Get all statement columns for fixed-rows-table
  getStatementColumns(field: any): any[] {
    if (field.type === 'fixed-rows-table' && field.columns) {
      return field.columns.filter((col: any) => 
        col.type === 'statement' && !col.isSrNo && col.name !== '_sr_no'
      );
    }
    return [];
  }

  // Ensure Sr. No column exists for fixed-rows-table (frontend only, auto-generated)
  ensureSrNoColumnForFixedRowsTable(field: any): void {
    if (field.type === 'fixed-rows-table') {
      // Initialize columns array if it doesn't exist
      if (!field.columns) {
        field.columns = [];
      }
      // Remove any existing Sr. No columns first to avoid duplicates
      field.columns = field.columns.filter((col: any) => !col.isSrNo && col.name !== '_sr_no');
      // Add Sr. No column at the beginning (it will always be added since we just removed any existing ones)
      field.columns.unshift({
        title: 'Sr. No',
        type: 'text',
        required: false,
        values: [],
        name: '_sr_no',
        isSrNo: true,
        readOnly: true
      });
    }
  }

  // Populate / merge statement data for fixed-rows-table from ecrf_table (field.columns[].value).
  // - If table is empty: create rows from template statement values.
  // - If table has rows: backfill empty statement cells from template; add rows for any extra template statements.
  populateFixedRowsTableFromValue(): void {
    if (!this.form || !this.fields) {
      return;
    }

    let didUpdateRows = false;
    this.fields.forEach((field: any) => {
      if (field.type !== 'fixed-rows-table' || !field.columns) {
        return;
      }

      let statementColumns = this.getStatementColumns(field);
      if (statementColumns.length === 0) {
        // Fallback: treat first non-SrNo column as statement to allow population
        const nonSrNoColumns = this.getTableColumnsExcludingSrNo(field);
        if (nonSrNoColumns.length === 0) {
          return;
        }
        statementColumns = [nonSrNoColumns[0]];
      }

      const tableControl = this.form.get(field.name);
      if (!tableControl) {
        return;
      }

      // Resolve statement values from ecrf_table (column.value from getTemplateData)
      let statementValues: any[] = [];
      for (const col of field.columns) {
        const rawValue = col.value ?? col.values;
        if (rawValue != null && rawValue !== '') {
          try {
            const parsed = typeof rawValue === 'string' ? JSON.parse(rawValue) : rawValue;
            if (Array.isArray(parsed) && parsed.length > 0) {
              statementValues = parsed;
              break;
            }
          } catch {
            // ignore
          }
        }
      }

      if (statementValues.length === 0) {
        return;
      }

      const numStatementColumns = statementColumns.length;
      const numRowsFromTemplate = Math.ceil(statementValues.length / numStatementColumns);
      const columnsToUse = this.getTableColumnsExcludingSrNo(field);
      const currentValue = Array.isArray(tableControl.value) ? tableControl.value : [];
      const numExisting = currentValue.length;

      // Empty table: build all rows from template statements
      if (numExisting === 0) {
        const rows: any[] = [];
        for (let rowIndex = 0; rowIndex < numRowsFromTemplate; rowIndex++) {
          const row: any = {};
          columnsToUse.forEach((column: any) => {
            const columnKey = this.getDataColumnKey(field, column);
            if (column.type !== 'statement') {
              row[columnKey] = null;
            }
          });
          statementColumns.forEach((col: any, colIndex: number) => {
            const columnKey = this.getDataColumnKey(field, col);
            const valueIndex = rowIndex * numStatementColumns + colIndex;
            row[columnKey] = valueIndex < statementValues.length ? (statementValues[valueIndex] || '') : '';
          });
          rows.push(row);
        }
        tableControl.setValue(rows);
        this.cdr.detectChanges();
        return;
      }

      // Merge: backfill empty statement cells and append rows for extra template statements
      const merged: any[] = [];
      const maxRows = Math.max(numExisting, numRowsFromTemplate);

      for (let rowIndex = 0; rowIndex < maxRows; rowIndex++) {
        const isNew = rowIndex >= numExisting;
        const row: any = isNew ? {} : { ...currentValue[rowIndex] };

        // Ensure all column keys exist; for new rows init non-statement to null
        columnsToUse.forEach((column: any) => {
          const columnKey = this.getDataColumnKey(field, column);
          if (column.type !== 'statement' && (isNew || !(columnKey in row))) {
            row[columnKey] = isNew ? null : (row[columnKey] ?? null);
          }
        });

        // Populate statement columns: backfill if empty, or set for new rows
        statementColumns.forEach((col: any, colIndex: number) => {
          const columnKey = this.getDataColumnKey(field, col);
          const valueIndex = rowIndex * numStatementColumns + colIndex;
          const fromTemplate = valueIndex < statementValues.length ? (statementValues[valueIndex] || '') : '';

          const current = row[columnKey];
          const isEmpty = current == null || current === '';

          if (isNew) {
            row[columnKey] = fromTemplate;
          } else if (isEmpty && fromTemplate !== '') {
            row[columnKey] = fromTemplate;
          }
          // else: keep existing non-empty value
        });

        merged.push(row);
      }

      tableControl.setValue(merged);
      this.cdr.detectChanges();
      didUpdateRows = true;
    });

    if (didUpdateRows) {
      this.prefetchReviewStatusesForCurrentForm();
    }
  }

  // Get column key for statement modal (helper method for template)
  getStatementColumnKey(column: any): string {
    const field = this.fields.find(f => f.name === this.statementModalFieldName);
    if (!field) return column?.name || 'col_0';
    return this.getDataColumnKey(field, column);
  }

  getTableData(fieldName: string): any[] {
    const tableControl = this.form.get(fieldName);
    if (!tableControl || !tableControl.value) {
      return [];
    }
    
    const value = tableControl.value;
    // Simplified: only handle arrays directly, which is the expected format
    return Array.isArray(value) ? value : [];
  }
  
  // Add a new row to the table
  addTableRow(fieldName: string): void {
    console.log(fieldName);
    const tableControl = this.form.get(fieldName);
    if (tableControl) {
      // Find the field configuration to get column definitions
      const field = this.fields.find(f => f.name === fieldName);
      if (!field || !field.columns) {
        return;
      }
      
      // For fixed-rows-table, open modal to input statement column values
      if (field.type === 'fixed-rows-table') {
        const statementColumns = this.getStatementColumns(field);
        if (statementColumns.length > 0) {
          // Open modal to collect statement values
          this.statementModalFieldName = fieldName;
          this.statementModalColumns = statementColumns;
          this.statementModalValues = {};
          // Initialize empty values for each statement column
          statementColumns.forEach((column: any) => {
            const columnKey = this.getDataColumnKey(field, column);
            this.statementModalValues[columnKey] = '';
          });
          this.isStatementModalOpen = true;
          return;
        }
      }
      
      // For regular tables, initialize all columns with null values
      const newRow: any = {};
      const columnsToUse = field.columns || [];
      
      columnsToUse.forEach((column: any, index: number) => {
        const columnKey = column.name || 'col_' + index;
        newRow[columnKey] = null;
      });
      
      const currentData = Array.isArray(tableControl.value) ? [...tableControl.value] : [];
      currentData.push(newRow);
      
      // Use emitEvent: false to prevent triggering valueChanges subscriptions
      // This avoids cascading dependency checks and change detection
      tableControl.setValue(currentData, { emitEvent: false });
      
      const newRowIndex = currentData.length - 1;
      this.editableRowIndex = newRowIndex;
      this.isOptionsModalOpen = false;
      this.showReviewModal = false; // Close review modal when options modal closes
      
      // Defer heavy operations to next tick to keep UI responsive
      // This allows the DOM to update first before processing
      setTimeout(() => {
        // Track table changes asynchronously to avoid blocking UI
        this.trackTableChange(fieldName, currentData);
        // Trigger change detection only once after all operations
        this.cdr.detectChanges();
      }, 0);
    }
  }
  
  // Handle statement modal submission
  submitStatementModal(): void {
    // Get the field first
    const field = this.fields.find(f => f.name === this.statementModalFieldName);
    if (!field) {
      this.closeStatementModal();
      return;
    }

    // Validate that all required statement columns have values
    const missingValues: string[] = [];
    this.statementModalColumns.forEach((column: any) => {
      const columnKey = this.getDataColumnKey(field, column);
      if (column.required && (!this.statementModalValues[columnKey] || this.statementModalValues[columnKey].trim() === '')) {
        missingValues.push(column.title || 'this field');
      }
    });

    if (missingValues.length > 0) {
      alert(`Please enter values for the following required fields: ${missingValues.join(', ')}`);
      return;
    }

    const tableControl = this.form.get(this.statementModalFieldName);
    
    if (!tableControl) {
      this.closeStatementModal();
      return;
    }

    // Create new row with statement values
    const newRow: any = {};
    const columnsToUse = this.getTableColumnsExcludingSrNo(field);
    
    // Set statement column values
    this.statementModalColumns.forEach((column: any) => {
      const columnKey = this.getDataColumnKey(field, column);
      newRow[columnKey] = this.statementModalValues[columnKey]?.trim() || null;
    });

    // Initialize all other columns with null
    columnsToUse.forEach((column: any) => {
      const columnKey = this.getDataColumnKey(field, column);
      // Skip statement columns as we've already set them
      if (column.type !== 'statement') {
        newRow[columnKey] = null;
      }
    });

    const currentData = Array.isArray(tableControl.value) ? [...tableControl.value] : [];
    currentData.push(newRow);

    // Use emitEvent: false to prevent triggering valueChanges subscriptions
    tableControl.setValue(currentData, { emitEvent: false });

    const newRowIndex = currentData.length - 1;
    this.editableRowIndex = newRowIndex;
    this.isOptionsModalOpen = false;
    this.showReviewModal = false;

    // Defer heavy operations to next tick to keep UI responsive
    setTimeout(() => {
      this.trackTableChange(this.statementModalFieldName, currentData);
      this.cdr.detectChanges();
    }, 0);

    // Close modal
    this.closeStatementModal();
  }

  // Close statement modal
  closeStatementModal(): void {
    this.isStatementModalOpen = false;
    this.statementModalFieldName = '';
    this.statementModalColumns = [];
    this.statementModalValues = {};
  }

  // Remove a row from the table
  removeTableRow(fieldName: string, field_id: number, rowIndex: number): void {
    if (!confirm('Are you sure you want to delete this row? This action cannot be undone.')) {
      return;
    }
    
    const tableControl = this.form.get(fieldName);
    if (!tableControl) return;
    
    const currentData = Array.isArray(tableControl.value) ? [...tableControl.value] : [];
    if (rowIndex < 0 || rowIndex >= currentData.length) return;
    
    const id = currentData[rowIndex]?.id || 0;
    
    this.apiService.deleteTableRow(field_id, rowIndex, id).subscribe(
      response => {
        if (response.success) {
          // Remove from table_rows array if it has an ID
          if (id && id !== 0) {
            const rowIndexInTableRows = this.table_rows.findIndex((row: any) => row.id === id);
            if (rowIndexInTableRows !== -1) {
              this.table_rows.splice(rowIndexInTableRows, 1);
            }
          }
          
          // Remove from form data
          currentData.splice(rowIndex, 1);
          
          // Use emitEvent: false to prevent triggering subscriptions
          tableControl.setValue(currentData, { emitEvent: false });
          
          // Reindex edit reasons for remaining rows
          this.reindexTableRowReasons(fieldName, rowIndex);
          
          // Defer tracking to avoid blocking UI
          setTimeout(() => {
            this.trackTableChange(fieldName, currentData);
            this.cdr.detectChanges();
          }, 0);
        }
      }
    );
  }
  
  // Update table cell value
  updateTableCell(fieldName: string, rowIndex: number, columnName: string, value: any): void {
    const tableControl = this.form.get(fieldName);
    if (!tableControl) return;
    
    // Prevent updating Sr. No column - it's auto-generated
    if (columnName === '_sr_no' || columnName.startsWith('sr_no')) {
      const field = this.fields.find(f => f.name === fieldName);
      if (field && field.type === 'fixed-rows-table') {
        const srNoColumn = field.columns?.find((col: any) => col.isSrNo || col.name === '_sr_no');
        if (srNoColumn && (columnName === srNoColumn.name || columnName === '_sr_no')) {
          return;
        }
      }
    }
    
    const currentData = Array.isArray(tableControl.value) ? [...tableControl.value] : [];
    if (rowIndex < 0 || rowIndex >= currentData.length) return;
    
    // Initialize row if needed
    if (!currentData[rowIndex]) {
      currentData[rowIndex] = {};
    }
    
    // Update cell value (normalize string: trim + strip trailing slash so it matches dropdown options)
    const normalized = typeof value === 'string' ? this.normalizeTableCellValueForDisplay(value) : value;
    currentData[rowIndex][columnName] = normalized;

    const field = this.fields.find(f => f.name === fieldName);
    if (field?.type === 'fixed-rows-table' && this.editableRowIndex === null) {
      if (this.hasFixedRowsRowDataInRow(field, currentData[rowIndex])) {
        this.editableRowIndex = rowIndex;
      }
    }
    
    // Use emitEvent: false to prevent triggering valueChanges subscriptions
    tableControl.setValue(currentData, { emitEvent: false });
    
    // Debounce table change tracking to avoid formatting on every keystroke
    // Clear existing timer for this field
    if (this.tableChangeTimers[fieldName]) {
      clearTimeout(this.tableChangeTimers[fieldName]);
    }
    
    // Set new timer to track changes after 300ms of inactivity
    this.tableChangeTimers[fieldName] = setTimeout(() => {
      this.trackTableChange(fieldName, currentData);
      delete this.tableChangeTimers[fieldName];
    }, 300);
  }

  /** Normalize dropdown option to { value, label } for display and binding. */
  private normalizeDropdownOption(opt: any): { value: string; label: string } {
    if (opt == null) return { value: '', label: '' };
    if (typeof opt === 'string') return { value: opt, label: opt };
    const value = (opt.value ?? opt.id ?? opt.name ?? '').toString().trim();
    const label = (opt.label ?? opt.name ?? opt.value ?? value ?? '').toString().trim();
    return { value, label: label || value };
  }

  /** Get dropdown options for a table column (values, value_config, or options). */
  getDropdownOptions(column: any): { value: string; label: string }[] {
    if (!column) return [];
    let raw: any[] = column.values;
    if (!Array.isArray(raw) && column.value_config != null) {
      const config = column.value_config;
      raw = typeof config === 'string' ? (() => { try { return JSON.parse(config); } catch { return []; } })() : (Array.isArray(config) ? config : []);
    }
    if (!Array.isArray(raw)) raw = column.options ?? [];
    if (!Array.isArray(raw)) return [];
    return raw.map((o: any) => this.normalizeDropdownOption(o)).filter((o: { value: string; label: string }) => o.value !== '' || o.label !== '');
  }
  
  /** Normalize cell value for display/binding: trim and strip trailing slashes so backend "option_1/" matches "option_1". */
  private normalizeTableCellValueForDisplay(val: any): string {
    if (val === null || val === undefined || val === '') return '';
    const s = String(val).trim().replace(/\/+$/, '');
    return s;
  }
  
  // Get table cell value
  getTableCellValue(fieldName: string, rowIndex: number, columnName: string): any {
    const tableData = this.getTableData(fieldName);
    if (rowIndex >= 0 && rowIndex < tableData.length && tableData[rowIndex]) {
      const value = tableData[rowIndex][columnName];
      return this.normalizeTableCellValueForDisplay(value);
    }
    return '';
  }

  // Track table changes and auto-submit
  private trackTableChange(fieldName: string, tableData: any[]): void {
    // Find the field to get proper formatting
    const field = this.fields.find(f => f.name === fieldName);
    if (!field) {
      return;
    }
    
    // Format the table data with proper operation types (same as auto-update format)
    const formattedData = this.formatTableFieldValue(field, tableData);
    
    // Store the current table data with proper formatting
    const hasMeaningfulData = Array.isArray(formattedData)
      ? formattedData.length > 0
      : !!formattedData;

    this.tableChangeTracker[fieldName] = {
      data: formattedData, // Use formatted data with operation types
      timestamp: Date.now(),
      hasChanges: hasMeaningfulData
    };
    
    // Table change tracking is now manual - no auto-submission
    // Removed excessive logging and form validity checks to improve performance
  }


  // Check if there are pending table changes
  public hasPendingTableChanges(): boolean {
    return Object.keys(this.tableChangeTracker).some(
      fieldName => this.tableChangeTracker[fieldName].hasChanges
    );
  }

  // Get pending table changes count
  public getPendingTableChangesCount(): number {
    return Object.keys(this.tableChangeTracker).filter(
      fieldName => this.tableChangeTracker[fieldName].hasChanges
    ).length;
  }

  ngOnDestroy(): void {
    // Clean up all debounce timers to prevent memory leaks
    Object.keys(this.tableChangeTimers).forEach(fieldName => {
      if (this.tableChangeTimers[fieldName]) {
        clearTimeout(this.tableChangeTimers[fieldName]);
      }
    });
    this.tableChangeTimers = {};
  }

  SignatureCheck(form?: any): boolean {
    // Allow checking either the passed form or the current form.
    // PI signature is now allowed for all forms that have a name.
    const name = form?.name || this.currentForm?.name;
    return !!name;
  }

  getPiSignatureReviewed(): boolean {
    if (!this.currentForm) return false;
    return this.formReviewStatus[this.currentForm.id]?.piSignatureReviewed || false;
  }

  hasPiSignatureForForm(form: any): boolean {
    if (!form) {
      return false;
    }
    const formId = form.id ?? form.form_id ?? form.name;
    if (!formId) {
      return false;
    }
    return !!this.formReviewStatus[formId]?.piSignatureReviewed;
  }

  getPiReviewedBy(): string | undefined {
    if (!this.currentForm) return undefined;
    return this.formReviewStatus[this.currentForm.id]?.piReviewedBy;
  }

  getPiReviewedAt(): string | undefined {
    if (!this.currentForm) return undefined;
    return this.formReviewStatus[this.currentForm.id]?.piReviewedAt;
  }

  getPiComment(): string | undefined {
    if (!this.currentForm) return undefined;
    return this.formReviewStatus[this.currentForm.id]?.piComment;
  }

  getPiValidationText(): string {
    // Don't show validation text if pi-check is false
    if (!this.getPiSignatureReviewed()) {
      return '';
    }
    const reviewedBy = this.getPiReviewedBy();
    const reviewedAt = this.getPiReviewedAt();
    const piComment = this.getPiComment();
    
    if (reviewedBy && reviewedAt) {
      const formattedDate = this.formatDate(reviewedAt);
      let validationText = `${reviewedBy} - ${formattedDate}`;
      
      // Add comment if available
      if (piComment && piComment.trim()) {
        // validationText += ` - ${piComment.trim()}`;
      }
      
      return validationText;
    }
    return '';
  }

  piSignatureStep: number = 1;

  openPiSignatureModal(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // Only PI users can manage PI signature
    if (!this.isUserPI() || !this.SignatureCheck()) {
      return;
    }

    const currentValue = this.getPiSignatureReviewed();
    this.pendingPiCheckValue = !currentValue;

    const userData = this.commonService.getUserData();
    this.piCheckEmail = userData?.email || '';
    this.piCheckPassword = '';
    this.piCheckComment = '';
    this.piCheckError = '';
    this.piCheckVerifying = false;
    this.piSignatureStep = 1;
    this.piCheckConfirmationAccepted = false;
    
    // Initialize PI Signature folder/form selection
    // Auto-select current folder and form if available
    this.piSignatureFolderId = this.selectedFolderId || '';
    this.piSignatureFormCheckboxes = {};
    this.piSignatureFolderCheckboxes = {};
    
    // Auto-select current folder checkbox if folder is selected
    if (this.selectedFolderId) {
      this.piSignatureFolderCheckboxes[this.selectedFolderId] = true;
    }
    
    this.showPiSignatureFolderDropdown = false;
    this.showPiSignatureFormDropdown = false;
    
    // Build targets first to populate available folders and forms
    this.buildPiSignatureTargets();
    
    // After forms are populated, set the form ID and checkbox
    if (this.currentForm?.id) {
      this.piSignatureFormId = this.currentForm.id;
      this.piSignatureFormCheckboxes[this.currentForm.id] = true;
    }
    
    this.showPiCheckModal = true;
  }

  EditHide(): boolean {
    if (this.userRole === 'Monitor' || this.userRole === 'Data Manager' || this.userRole === 'CRO') {
      return false
    }
    return true;
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return dateString; // Return original if invalid date
      }
      
      // Format as: "MMM DD, YYYY at HH:MM AM/PM"
      const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      };
      
      return date.toLocaleString('en-US', options);
    } catch (error) {
      return dateString; // Return original if parsing fails
    }
  }

  isUserPI() {
    const { designation } = JSON.parse(this.cookieService.get('userData'));
    const normalized = (designation || '').toString().trim();
    return normalized === 'PI' || normalized === 'Principal Investigator';
  }

  isUserMonitor(): boolean {
    try {
      if (!this.currentUser) {
        this.currentUser = JSON.parse(this.cookieService.get('userData'));
      }
      const designation = this.currentUser?.designation || '';
      return designation === 'Monitor';
    } catch (error) {
      return false;
    }
  }

  isUserMonitorOrDataManager(): boolean {
    try {
      if (!this.currentUser) {
        this.currentUser = JSON.parse(this.cookieService.get('userData'));
      }
      const designation = this.currentUser?.designation || '';
      return designation === 'Monitor' || designation === 'Data Manager';
    } catch (error) {
      return false;
    }
  }

  isUserDataManager(): boolean {
    try {
      if (!this.currentUser) {
        this.currentUser = JSON.parse(this.cookieService.get('userData'));
      }
      const designation = this.currentUser?.designation || '';
      const role = (this.userRole || designation || '').toString().trim();
      return role === 'Data Manager' || designation === 'Data Manager';
    } catch (error) {
      return false;
    }
  }

  getReviewRoleLabel(): string {
    try {
      if (!this.currentUser) {
        this.currentUser = JSON.parse(this.cookieService.get('userData'));
      }
      const designation = this.currentUser?.designation || '';
      if (designation === 'Monitor') {
        return 'Monitor';
      } else if (designation === 'Data Manager') {
        return 'Data Manager';
      }
      return 'Monitor'; // Default fallback
    } catch (error) {
      return 'Monitor'; // Default fallback
    }
  }

  canSeeReviewOption(): boolean {
    try {
      if (!this.currentUser) {
        this.currentUser = JSON.parse(this.cookieService.get('userData'));
      }
      const designation = this.currentUser?.designation || '';
      const role = this.userRole || designation;
      // Allow CRO, PI, and CRC to see the Review option (they'll see approver details in read-only mode)
      // Monitor and Data Manager should NOT see this option (they use the "Review Monitor/Data Manager" button instead)
      const allowedRoles = ['CRO', 'PI', 'CRC'];
      return allowedRoles.includes(role) || allowedRoles.includes(designation);
    } catch (error) {
      return false;
    }
  }

  openReviewMonitorHeader(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.isUserMonitorOrDataManager()) {
      return;
    }

    // Open modal without forcing a specific field; user can select folder/form/field in step 2
    this.isOptionsModalOpen = false;
    this.showReviewModal = false;

    const userData = this.commonService.getUserData();
    this.monitorReviewEmail = userData?.email || '';
    this.monitorReviewPassword = '';
    this.monitorReviewReason = '';
    this.monitorReviewError = '';
    this.monitorReviewVerifying = false;
    this.showMonitorReviewPassword = false;

    this.monitorReviewStep = 1;
    this.monitorReviewConfirmationAccepted = false;

    // Preselect current folder/form context
    this.monitorReviewFolderId = this.selectedFolderId || '';
    this.monitorReviewFormId = this.currentForm?.id || '';
    this.monitorReviewFieldId = '';

    this.monitorReviewFolderCheckboxes = {};
    this.monitorReviewFormCheckboxes = {};
    this.monitorReviewFieldCheckboxes = {};

    if (this.monitorReviewFolderId) {
      this.monitorReviewFolderCheckboxes[this.monitorReviewFolderId] = true;
    }
    if (this.monitorReviewFormId) {
      this.monitorReviewFormCheckboxes[this.monitorReviewFormId] = true;
    }

    this.showMonitorReviewFolderDropdown = false;
    this.showMonitorReviewFormDropdown = false;
    this.showMonitorReviewFieldDropdown = false;

    this.buildMonitorReviewTargets();
    this.showMonitorReviewModal = true;
  }

  isUserCRO() {
    const { designation } = JSON.parse(this.cookieService.get('userData'));

    return designation === 'CRO';
  }

  isUserCRC() {
    try {
      if (!this.currentUser) {
        this.currentUser = JSON.parse(this.cookieService.get('userData'));
      }
      const designation = this.currentUser?.designation || '';
      return designation === 'CRC' || designation === 'CRC_Standard' || designation === 'CRC_Premium' || designation === 'CRC_Enterprise';
    } catch (error) {
      return false;
    }
  }

  shouldShowQueryOption(field: any, rowIndex?: number): boolean {
    if (!field) return false;
    if (field.type === 'instruction') return false;
    
    const isFixedRowsWithRow = field.type === 'fixed-rows-table' && rowIndex !== undefined && rowIndex !== null;
    
    // Handle read-only fields
    if (this.isFieldReadOnly(field)) {
      if (!isFixedRowsWithRow) return false;
      const lockStatus = this.getFieldLockFreezeStatus(field);
      if (lockStatus.isFrozen) return false;
    }
    
    // For CRC role: show query option unless field is actually locked or frozen from database
    // Only check actual lock/freeze status, not fieldLockStatus which may be set incorrectly
    if (this.isUserCRC()) {
      const lockStatus = this.getFieldLockFreezeStatus(field);
      
      // Hide query option only if field is actually locked or frozen from locked_data table
      if (lockStatus.isLocked || lockStatus.isFrozen) {
        return false;
      }
      
      return true;
    }
    
    return true;
  }

  canCreateQuery(): boolean {
    // Only Monitor and Data Manager can create queries (PI cannot)
    try {
      if (!this.currentUser) {
        this.currentUser = JSON.parse(this.cookieService.get('userData'));
      }
      const designation = (this.currentUser?.designation || '').toString().trim();
      return (
        designation === 'Monitor' ||
        designation === 'Data Manager'
      );
    } catch (error) {
      return false;
    }
  }

  // Check if user should have fields disabled (Monitor, Data Manager, CRO)
  // CRC and PI can edit, but fields are locked if there are open queries
  isFieldDisabledUser() {
    try {
      if (!this.currentUser) {
        this.currentUser = JSON.parse(this.cookieService.get('userData'));
      }
      const designation = this.currentUser?.designation;
      
      if (!designation) {
        return false;
      }
      
      // Read-only roles: Monitor, Data Manager, CRO cannot edit
      // CRC and PI can edit all fields
      const disabledDesignations = [
        'Monitor',
        'Data Manager',
        'CRO',
        'CRO_Premium',
        'CRO_Enterprise'
      ];

      const readOnlyByRole = disabledDesignations.includes(designation);
      return readOnlyByRole || this.isFieldReadOnly();
    } catch (error) {
      return false;
    }
  }

  private getCurrentFolder(): any {
    if (!this.template?.folders || !this.selectedFolderId) {
      return null;
    }
    return this.template.folders.find((f: any) => f.id === this.selectedFolderId) || null;
  }

  isFieldReadOnly(field?: any): boolean {
    const folder = this.getCurrentFolder();
    const form = this.currentForm;
    if (folder?.is_locked || folder?.is_frozen) return true;
    if (form?.is_locked || form?.is_frozen) return true;
    if (field?.is_locked || field?.is_frozen) return true;
    return false;
  }

  canManageFreezeLock(): boolean {
    try {
      if (!this.currentUser) {
        this.currentUser = JSON.parse(this.cookieService.get('userData'));
      }
      const designation = this.currentUser?.designation || '';
      return designation === 'Monitor' || designation === 'Data Manager';
    } catch (error) {
      return false;
    }
  }

  // Check if field has open queries
  hasOpenQueriesForField(fieldName?: string): boolean {
    if (!this.queries || this.queries.length === 0) {
      return false;
    }
    
    // Check if any query is open (not closed)
    return this.queries.some(query => !query.isClosed);
  }

  isReadOnlyUser() {
    const { designation } = JSON.parse(this.cookieService.get('userData'));
    
    return designation === 'Monitor' || 
           designation === 'Data Manager';
  }

  setPiSignatureReviewed(value: boolean, piReviewedBy?: string, piReviewedAt?: string, piComment?: string): void {
    if (!this.currentForm) return;
    if (!this.formReviewStatus[this.currentForm.id]) {
      this.formReviewStatus[this.currentForm.id] = {
        piSignatureReviewed: false,
        reviewOptions: {
          dataManager: false,
          monitor: false,
          pi: false
        }
      };
    }
    this.formReviewStatus[this.currentForm.id].piSignatureReviewed = value;
    if (piReviewedBy !== undefined) {
      this.formReviewStatus[this.currentForm.id].piReviewedBy = piReviewedBy;
    }
    if (piReviewedAt !== undefined) {
      this.formReviewStatus[this.currentForm.id].piReviewedAt = piReviewedAt;
    }
    if (piComment !== undefined) {
      this.formReviewStatus[this.currentForm.id].piComment = piComment;
    }
  }

  onPiCheckboxChange(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    const target = event.target as HTMLInputElement;
    const currentValue = this.getPiSignatureReviewed();
    const newValue = !currentValue; // Toggle value
    
    // Only show modal if the value is actually changing
    if (newValue !== currentValue) {
      this.pendingPiCheckValue = newValue;
      
      // Get current user's email
      const userData = this.commonService.getUserData();
      this.piCheckEmail = userData?.email || '';
      this.piCheckPassword = '';
      this.piCheckComment = '';
      this.piCheckError = '';
      this.piCheckVerifying = false;
      this.showPiCheckModal = true;
      
      // Force checkbox to stay in current state until confirmed
      setTimeout(() => {
        target.checked = currentValue;
      }, 0);
    }
  }

  confirmPiCheckChange(): void {
    // Validate inputs
    if (!this.piCheckPassword) {
      this.piCheckError = 'Please enter your password';
      return;
    }
    
    // Ensure email is set from current user
    if (!this.piCheckEmail) {
      const userData = this.commonService.getUserData();
      this.piCheckEmail = userData?.email || '';
      if (!this.piCheckEmail) {
        this.piCheckError = 'Unable to retrieve user email. Please refresh the page.';
        return;
      }
    }

    // Validate required data for API call
    if (!this.study_id || !this.subject_id) {
      this.piCheckError = 'Missing required data. Please refresh the page.';
      return;
    }

    // Collect all selected forms - ONLY explicitly checked forms
    const selectedFormIds = new Set<string>();
    
    // Priority 1: Add forms from checked form checkboxes (most specific selection)
    if (this.hasAnyPiSignatureFormCheckboxChecked()) {
      Object.keys(this.piSignatureFormCheckboxes).forEach(formId => {
        if (this.piSignatureFormCheckboxes[formId]) {
          selectedFormIds.add(formId);
        }
      });
    }
    
    // Priority 2: If no form checkboxes are checked, check for folder selections
    // Only include forms from checked folders if no specific forms were selected
    if (selectedFormIds.size === 0 && this.hasAnyPiSignatureFolderCheckboxChecked()) {
      if (this.template && this.template.folders) {
        this.template.folders.forEach((folder: any) => {
          if (this.piSignatureFolderCheckboxes[folder.id] && folder.forms) {
            folder.forms.forEach((form: any) => {
              selectedFormIds.add(form.id);
            });
          }
        });
      }
    }
    
    // Priority 3: Add single selected form if no checkboxes are checked
    if (selectedFormIds.size === 0) {
      if (this.piSignatureFormId) {
        selectedFormIds.add(this.piSignatureFormId);
      } else if (this.currentForm?.id) {
        selectedFormIds.add(this.currentForm.id);
      } else {
        this.piCheckError = 'Please select at least one folder or form.';
        return;
      }
    }

    this.piCheckError = '';
    this.piCheckVerifying = true;

    const purpose = 'pi_check'
    // Verify credentials using login API
    this.apiService.login(this.piCheckEmail, this.piCheckPassword, purpose).subscribe(
      async response => {
        // Authentication successful - don't update local state yet, wait for API response
        // The local state will be updated after successful API call
        
        // Get user data for API call
        const userData = this.commonService.getUserData();
        if (!userData) {
          this.piCheckVerifying = false;
          this.piCheckError = 'User data not available. Please login again.';
          return;
        }

        // Build payloads for all selected forms
        const piCheckUpdatePayload: any[] = [];
        const formIdsToUpdate: string[] = Array.from(selectedFormIds);
        
        for (const formId of formIdsToUpdate) {
          // Find the form in template to get its fields
          let targetForm: any = null;
          let targetFolder: any = null;
          
          if (this.template && this.template.folders) {
            for (const folder of this.template.folders) {
              const form = folder.forms?.find((f: any) => f.id === formId);
              if (form) {
                targetForm = form;
                targetFolder = folder;
                break;
              }
            }
          }
          
          // Get a field from the form (prefer first field, or use placeholder)
          let fieldToUse: any = null;
          let fieldValue = '';
          
          if (targetForm && targetForm.fields && targetForm.fields.length > 0) {
            fieldToUse = targetForm.fields[0];
            // Use appropriate placeholder based on field type
            if (fieldToUse.type === 'table') {
              fieldValue = '[]';
            } else if (fieldToUse.type === 'number') {
              fieldValue = '0';
            } else {
              fieldValue = 'pi_review_update';
            }
          } else {
            // Use a placeholder field if no fields exist
            fieldToUse = { id: 'pi_review_status', name: 'pi_review_status', type: 'text', title: 'PI Review Status', required: false };
            fieldValue = 'pi_review_update';
          }

          // Build payload for this form
          piCheckUpdatePayload.push({
            study_id: this.study_id,
            subject_id: this.subject_id,
            form_id: formId,
            field_id: fieldToUse.id || fieldToUse.name,
            is_table: fieldToUse.type === 'table' ? true : false,
            value: fieldValue,
            sub_data: null,
            updated_by: userData.id,
            edit_reason: null,
            pi_check: !!this.pendingPiCheckValue,
            pi_comment: this.piCheckComment?.trim() || null
          });
        }

        // Make API call to update PI check status for all selected forms
        this.apiService.submitTemplateFormData(piCheckUpdatePayload).subscribe(
          apiResponse => {
            // API call successful - update local state for all affected forms
            const userData = this.commonService.getUserData();
            const reviewerName = userData ? `${userData.first_name || ''} ${userData.last_name || ''}`.trim() || userData.email : 'Unknown';
            const reviewTime = new Date().toISOString();
            
            // Update local state for all selected forms
            formIdsToUpdate.forEach(formId => {
              // Find the form object to update its review status
              if (this.template && this.template.folders) {
                for (const folder of this.template.folders) {
                  const form = folder.forms?.find((f: any) => f.id === formId);
                  if (form) {
                    // Update form review status
                    if (!this.formReviewStatus[formId]) {
                      this.formReviewStatus[formId] = {
                        piSignatureReviewed: false,
                        reviewOptions: {
                          dataManager: false,
                          monitor: false,
                          pi: false
                        }
                      };
                    }
                    this.formReviewStatus[formId].piSignatureReviewed = this.pendingPiCheckValue;
                    this.formReviewStatus[formId].piReviewedBy = reviewerName;
                    this.formReviewStatus[formId].piReviewedAt = reviewTime;
                    this.formReviewStatus[formId].piComment = this.piCheckComment?.trim() || undefined;
                    break;
                  }
                }
              }
            });
            
            // Also update current form if it's in the list
            if (this.currentForm && formIdsToUpdate.includes(this.currentForm.id)) {
              this.setPiSignatureReviewed(this.pendingPiCheckValue, reviewerName, reviewTime, this.piCheckComment?.trim() || undefined);
            }
            
            this.piCheckVerifying = false;
            this.showPiCheckModal = false;
            this.pendingPiCheckValue = false;
            this.piCheckPassword = '';
            this.piCheckComment = '';
            this.piCheckError = '';
            // Don't reset confirmation checkbox - keep it checked if user already accepted
            // Keep email for next time (it's readonly anyway)
          },
          apiError => {
            // API call failed - revert local change (preserve existing values)
            if (this.currentForm) {
              const existingReviewedBy = this.getPiReviewedBy();
              const existingReviewedAt = this.getPiReviewedAt();
              const existingComment = this.getPiComment();
              this.setPiSignatureReviewed(!this.pendingPiCheckValue, existingReviewedBy, existingReviewedAt, existingComment);
            }
            this.piCheckVerifying = false;
            this.piCheckError = apiError.error?.message || 'Failed to update PI check status. Please try again.';
          }
        );
      },
      error => {
        this.piCheckVerifying = false;
        this.piCheckError = error.error?.message || 'Invalid email or password. Please try again.';
      }
    );
  }

  cancelPiCheckChange(): void {
    this.showPiCheckModal = false;
    this.piSignatureStep = 1;
    this.pendingPiCheckValue = false;
    this.piCheckEmail = '';
    this.piCheckPassword = '';
    this.piCheckComment = '';
    this.piCheckError = '';
    this.piCheckVerifying = false;
    // Don't reset confirmation checkbox when canceling - keep it checked if user already accepted
  }

  onConfirmationCheckboxChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.piCheckConfirmationAccepted = target.checked;
  }

  onPasswordInput(event: Event): void {
    // Update password value from input event
    const target = event.target as HTMLInputElement;
    this.piCheckPassword = target.value;
    this.cdr.detectChanges();
  }

  onCommentInput(event: Event): void {
    // Update comment value from input event
    const target = event.target as HTMLTextAreaElement;
    this.piCheckComment = target.value;
    this.cdr.detectChanges();
  }

  isPasswordEntered(): boolean {
    return !!(this.piCheckPassword && this.piCheckPassword.trim().length > 0);
  }

  // --- Review Monitor (authenticated) ---
  canOpenReviewMonitor(field?: any): boolean {
    // Only Monitor or Data Manager role should see/use this authenticated flow
    const role = this.userRole || this.currentUser?.designation || '';
    // Keep simple and explicit
    return (role === 'Monitor' || role === 'Data Manager') && !!field;
  }

  openReviewMonitorModal(field: any, event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.canOpenReviewMonitor(field)) {
      return;
    }

    // Close kebab/options popover
    this.isOptionsModalOpen = false;
    this.showReviewModal = false;

    const userData = this.commonService.getUserData();
    this.monitorReviewEmail = userData?.email || '';
    this.monitorReviewPassword = '';
    this.monitorReviewReason = '';
    this.monitorReviewError = '';
    this.monitorReviewVerifying = false;
    this.showMonitorReviewPassword = false;

    this.monitorReviewStep = 1;
    this.monitorReviewConfirmationAccepted = false;

    // Preselect current context (folder/form/field) for convenience
    this.monitorReviewFolderId = this.selectedFolderId || '';
    this.monitorReviewFormId = this.currentForm?.id || '';
    this.monitorReviewFieldId = field?.id || '';

    this.monitorReviewFolderCheckboxes = {};
    this.monitorReviewFormCheckboxes = {};
    this.monitorReviewFieldCheckboxes = {};

    if (this.monitorReviewFolderId) {
      this.monitorReviewFolderCheckboxes[this.monitorReviewFolderId] = true;
    }
    if (this.monitorReviewFormId) {
      this.monitorReviewFormCheckboxes[this.monitorReviewFormId] = true;
    }
    if (this.monitorReviewFieldId) {
      this.monitorReviewFieldCheckboxes[this.monitorReviewFieldId] = true;
    }

    this.showMonitorReviewFolderDropdown = false;
    this.showMonitorReviewFormDropdown = false;
    this.showMonitorReviewFieldDropdown = false;

    this.buildMonitorReviewTargets();

    this.showMonitorReviewModal = true;
  }

  closeMonitorReviewModal(): void {
    this.showMonitorReviewModal = false;
    this.monitorReviewStep = 1;
    this.monitorReviewConfirmationAccepted = false;
    this.monitorReviewPassword = '';
    this.monitorReviewReason = '';
    this.monitorReviewError = '';
    this.monitorReviewVerifying = false;

    this.monitorReviewFolderId = '';
    this.monitorReviewFormId = '';
    this.monitorReviewFieldId = '';
    this.monitorReviewFolderCheckboxes = {};
    this.monitorReviewFormCheckboxes = {};
    this.monitorReviewFieldCheckboxes = {};
    this.monitorReviewAvailableFolders = [];
    this.monitorReviewAvailableForms = [];
    this.monitorReviewAvailableFields = [];
    this.closeMonitorReviewDropdowns();
  }

  goToMonitorReviewStep2(): void {
    if (!this.monitorReviewConfirmationAccepted) {
      this.monitorReviewError = 'Please accept the terms to continue.';
      return;
    }
    this.monitorReviewError = '';
    this.monitorReviewStep = 2;
  }

  goToMonitorReviewStep3(): void {
    if (!this.monitorReviewFolderId && !this.hasAnyMonitorReviewFolderCheckboxChecked()) {
      this.monitorReviewError = 'Please select at least one folder.';
      return;
    }
    this.monitorReviewError = '';
    this.monitorReviewStep = 3;
  }

  backToMonitorReviewStep1(): void {
    this.monitorReviewStep = 1;
  }

  backToMonitorReviewStep2(): void {
    this.monitorReviewStep = 2;
  }

  toggleMonitorReviewPasswordVisibility(): void {
    this.showMonitorReviewPassword = !this.showMonitorReviewPassword;
  }

  closeMonitorReviewDropdowns(): void {
    this.showMonitorReviewFolderDropdown = false;
    this.showMonitorReviewFormDropdown = false;
    this.showMonitorReviewFieldDropdown = false;
  }

  toggleMonitorReviewFolderDropdown(): void {
    this.showMonitorReviewFolderDropdown = !this.showMonitorReviewFolderDropdown;
    this.showMonitorReviewFormDropdown = false;
    this.showMonitorReviewFieldDropdown = false;
  }

  toggleMonitorReviewFormDropdown(): void {
    this.showMonitorReviewFormDropdown = !this.showMonitorReviewFormDropdown;
    this.showMonitorReviewFieldDropdown = false;
  }

  toggleMonitorReviewFieldDropdown(): void {
    this.showMonitorReviewFieldDropdown = !this.showMonitorReviewFieldDropdown;
  }

  selectMonitorReviewFolder(folderId: any): void {
    this.monitorReviewFolderId = folderId;
    this.showMonitorReviewFolderDropdown = false;
    this.onMonitorReviewFolderChange();
  }

  selectMonitorReviewForm(formId: any): void {
    this.monitorReviewFormId = formId;
    this.showMonitorReviewFormDropdown = false;
    this.onMonitorReviewFormChange();
  }

  selectMonitorReviewField(fieldId: any): void {
    this.monitorReviewFieldId = fieldId;
    this.showMonitorReviewFieldDropdown = false;
  }

  toggleMonitorReviewFolderCheckbox(folderId: any): void {
    this.monitorReviewFolderCheckboxes[folderId] = !this.monitorReviewFolderCheckboxes[folderId];
    this.onMonitorReviewFolderChange();
  }

  toggleMonitorReviewFormCheckbox(formId: any): void {
    this.monitorReviewFormCheckboxes[formId] = !this.monitorReviewFormCheckboxes[formId];
    this.onMonitorReviewFormChange();
  }

  toggleMonitorReviewFieldCheckbox(fieldId: any): void {
    this.monitorReviewFieldCheckboxes[fieldId] = !this.monitorReviewFieldCheckboxes[fieldId];
  }

  hasAnyMonitorReviewFolderCheckboxChecked(): boolean {
    return Object.values(this.monitorReviewFolderCheckboxes).some(v => v === true);
  }

  hasAnyMonitorReviewFormCheckboxChecked(): boolean {
    return Object.values(this.monitorReviewFormCheckboxes).some(v => v === true);
  }

  private hasAnyMonitorReviewFieldCheckboxChecked(): boolean {
    return Object.values(this.monitorReviewFieldCheckboxes).some(v => v === true);
  }

  private buildMonitorReviewTargets(): void {
    if (!this.template || !this.template.folders) {
      this.monitorReviewAvailableFolders = [];
      this.monitorReviewAvailableForms = [];
      this.monitorReviewAvailableFields = [];
      return;
    }

    this.monitorReviewAvailableFolders = this.template.folders.map((f: any) => ({
      id: f.id,
      name: f.name
    }));

    this.populateMonitorReviewFormsFromCheckedFolders();
    this.populateMonitorReviewFieldsFromCheckedForms();
  }

  private populateMonitorReviewFormsFromCheckedFolders(): void {
    if (!this.template || !this.template.folders) {
      this.monitorReviewAvailableForms = [];
      return;
    }

    const allForms: any[] = [];
    const formIds = new Set();

    for (const folder of this.template.folders) {
      if (this.monitorReviewFolderCheckboxes[folder.id] && folder.forms) {
        folder.forms.forEach((form: any) => {
          if (!formIds.has(form.id)) {
            formIds.add(form.id);
            allForms.push({ id: form.id, name: form.name, folderId: folder.id });
          }
        });
      }
    }

    // Ensure selected folder's forms are present even if checkbox not used
    if (this.monitorReviewFolderId && !this.monitorReviewFolderCheckboxes[this.monitorReviewFolderId]) {
      const selectedFolder = this.template.folders.find((f: any) => f.id === this.monitorReviewFolderId);
      if (selectedFolder?.forms) {
        selectedFolder.forms.forEach((form: any) => {
          if (!formIds.has(form.id)) {
            formIds.add(form.id);
            allForms.push({ id: form.id, name: form.name, folderId: selectedFolder.id });
          }
        });
      }
    }

    this.monitorReviewAvailableForms = allForms;
  }

  private populateMonitorReviewFieldsFromCheckedForms(): void {
    if (!this.template || !this.template.folders) {
      this.monitorReviewAvailableFields = [];
      return;
    }

    const allFields: any[] = [];
    const fieldIds = new Set();

    for (const folder of this.template.folders) {
      if (!folder.forms) continue;
      for (const form of folder.forms) {
        if (this.monitorReviewFormCheckboxes[form.id] && form.fields) {
          form.fields.forEach((field: any) => {
            if (!fieldIds.has(field.id)) {
              fieldIds.add(field.id);
              allFields.push({ id: field.id, title: field.title || field.name, formId: form.id });
            }
          });
        }
      }
    }

    // Ensure selected form's fields are present even if checkbox not used
    if (this.monitorReviewFormId && !this.monitorReviewFormCheckboxes[this.monitorReviewFormId]) {
      for (const folder of this.template.folders) {
        const form = folder.forms?.find((frm: any) => frm.id === this.monitorReviewFormId);
        if (form?.fields) {
          form.fields.forEach((field: any) => {
            if (!fieldIds.has(field.id)) {
              fieldIds.add(field.id);
              allFields.push({ id: field.id, title: field.title || field.name, formId: form.id });
            }
          });
          break;
        }
      }
    }

    this.monitorReviewAvailableFields = allFields;
  }

  private onMonitorReviewFolderChange(): void {
    // Reset dependent selections
    this.monitorReviewFormId = '';
    this.monitorReviewFieldId = '';
    this.monitorReviewFormCheckboxes = {};
    this.monitorReviewFieldCheckboxes = {};
    this.populateMonitorReviewFormsFromCheckedFolders();
    this.monitorReviewAvailableFields = [];
  }

  private onMonitorReviewFormChange(): void {
    this.monitorReviewFieldId = '';
    this.monitorReviewFieldCheckboxes = {};
    this.populateMonitorReviewFieldsFromCheckedForms();
  }

  getMonitorReviewFolderLabel(): string {
    const checkedIds = Object.keys(this.monitorReviewFolderCheckboxes).filter(id => this.monitorReviewFolderCheckboxes[id]);
    if (checkedIds.length > 0) {
      return `${checkedIds.length} folder(s) selected`;
    }
    if (this.monitorReviewFolderId) {
      const f = this.monitorReviewAvailableFolders.find(x => x.id === this.monitorReviewFolderId);
      return f?.name || 'Selected folder';
    }
    return 'Select folder(s)';
  }

  getMonitorReviewFormLabel(): string {
    const checkedIds = Object.keys(this.monitorReviewFormCheckboxes).filter(id => this.monitorReviewFormCheckboxes[id]);
    if (checkedIds.length > 0) {
      return `${checkedIds.length} form(s) selected`;
    }
    if (this.monitorReviewFormId) {
      const f = this.monitorReviewAvailableForms.find(x => x.id === this.monitorReviewFormId);
      return f?.name || 'Selected form';
    }
    return 'Select form(s)';
  }

  getMonitorReviewFieldLabel(): string {
    const checkedIds = Object.keys(this.monitorReviewFieldCheckboxes).filter(id => this.monitorReviewFieldCheckboxes[id]);
    if (checkedIds.length > 0) {
      return `${checkedIds.length} field(s) selected`;
    }
    if (this.monitorReviewFieldId) {
      const f = this.monitorReviewAvailableFields.find(x => x.id === this.monitorReviewFieldId);
      return f?.title || 'Selected field';
    }
    return 'Select field(s)';
  }

  private collectMonitorReviewTargets(): Array<{ formId: string; fieldId: string }> {
    if (!this.template || !this.template.folders) return [];

    // Priority 1: explicit field checkbox selections
    if (this.hasAnyMonitorReviewFieldCheckboxChecked()) {
      const targets: Array<{ formId: string; fieldId: string }> = [];
      const selectedFieldIds = Object.keys(this.monitorReviewFieldCheckboxes).filter(id => this.monitorReviewFieldCheckboxes[id]);
      const fieldToForm = new Map<string, string>();
      this.monitorReviewAvailableFields.forEach((f: any) => {
        if (f?.id != null && f?.formId != null) fieldToForm.set(String(f.id), String(f.formId));
      });
      selectedFieldIds.forEach(fid => {
        const formId = fieldToForm.get(String(fid));
        if (formId) targets.push({ formId: String(formId), fieldId: String(fid) });
      });
      return targets;
    }

    // Priority 2: explicit form checkbox selections
    if (this.hasAnyMonitorReviewFormCheckboxChecked()) {
      const selectedFormIds = Object.keys(this.monitorReviewFormCheckboxes).filter(id => this.monitorReviewFormCheckboxes[id]);
      const targets: Array<{ formId: string; fieldId: string }> = [];
      for (const folder of this.template.folders) {
        for (const form of (folder.forms || [])) {
          if (!selectedFormIds.includes(String(form.id))) continue;
          (form.fields || []).forEach((field: any) => {
            if (field?.id != null) targets.push({ formId: String(form.id), fieldId: String(field.id) });
          });
        }
      }
      return targets;
    }

    // Priority 3: explicit folder checkbox selections
    if (this.hasAnyMonitorReviewFolderCheckboxChecked()) {
      const selectedFolderIds = Object.keys(this.monitorReviewFolderCheckboxes).filter(id => this.monitorReviewFolderCheckboxes[id]);
      const targets: Array<{ formId: string; fieldId: string }> = [];
      for (const folder of this.template.folders) {
        if (!selectedFolderIds.includes(String(folder.id))) continue;
        for (const form of (folder.forms || [])) {
          (form.fields || []).forEach((field: any) => {
            if (field?.id != null) targets.push({ formId: String(form.id), fieldId: String(field.id) });
          });
        }
      }
      return targets;
    }

    // Fallback: single selection (folder/form/field)
    if (this.monitorReviewFieldId && this.monitorReviewFormId) {
      return [{ formId: String(this.monitorReviewFormId), fieldId: String(this.monitorReviewFieldId) }];
    }
    if (this.monitorReviewFormId) {
      const targets: Array<{ formId: string; fieldId: string }> = [];
      for (const folder of this.template.folders) {
        const form = folder.forms?.find((frm: any) => String(frm.id) === String(this.monitorReviewFormId));
        if (form) {
          (form.fields || []).forEach((field: any) => {
            if (field?.id != null) targets.push({ formId: String(form.id), fieldId: String(field.id) });
          });
          break;
        }
      }
      return targets;
    }
    return [];
  }

  authenticateAndApplyMonitorReview(): void {
    if (this.monitorReviewVerifying) return;

    if (!this.monitorReviewPassword || !this.monitorReviewPassword.trim()) {
      this.monitorReviewError = 'Please enter your password';
      return;
    }
    if (!this.monitorReviewReason || !this.monitorReviewReason.trim()) {
      this.monitorReviewError = 'Please enter a reason';
      return;
    }
    if (!this.study_id || !this.subject_id) {
      this.monitorReviewError = 'Missing required data. Please refresh the page.';
      return;
    }

    // Ensure email is always from current logged-in user
    const userData = this.commonService.getUserData();
    this.monitorReviewEmail = userData?.email || this.monitorReviewEmail || '';
    if (!this.monitorReviewEmail) {
      this.monitorReviewError = 'Unable to retrieve user email. Please login again.';
      return;
    }

    const targets = this.collectMonitorReviewTargets();
    if (!targets.length) {
      this.monitorReviewError = 'Please select at least one folder/form/field to review.';
      return;
    }

    this.monitorReviewError = '';
    this.monitorReviewVerifying = true;

    const purpose = 'monitor_review';
    this.apiService.login(this.monitorReviewEmail, this.monitorReviewPassword, purpose).subscribe({
      next: () => {
        const currentUser: any = this.currentUser || this.commonService.getUserData() || {};
        const reviewedBy = currentUser?.id || null;
        const reviewedByName =
          currentUser.first_name && currentUser.last_name
            ? `${currentUser.first_name} ${currentUser.last_name}`.trim()
            : currentUser.name || currentUser.email || this.monitorReviewEmail || 'Unknown';

        const requests = targets.map(t =>
          this.apiService.updateReviewStatus({
            study_id: this.study_id,
            subject_id: this.subject_id,
            form_id: t.formId,
            field_id: t.fieldId,
            review_type: 'monitor',
            is_reviewed: true,
            reviewed_by: reviewedBy,
            reviewed_by_name: reviewedByName,
            review_reason: this.monitorReviewReason?.trim() || null
          })
        );

        forkJoin(requests).subscribe({
          next: () => {
            this.monitorReviewVerifying = false;
            this.closeMonitorReviewModal();
            alert('Review applied successfully.');
          },
          error: () => {
            this.monitorReviewVerifying = false;
            this.monitorReviewError = 'Failed to apply review. Please try again.';
          }
        });
      },
      error: (error) => {
        this.monitorReviewVerifying = false;
        this.monitorReviewError = error?.error?.message || 'Invalid email or password. Please try again.';
      }
    });
  }

  // --- Review Data Manager (authenticated) ---
  openReviewDataManagerHeader(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.isUserDataManager()) {
      return;
    }

    this.isOptionsModalOpen = false;
    this.showReviewModal = false;

    const userData = this.commonService.getUserData();
    this.dataManagerReviewEmail = userData?.email || '';
    this.dataManagerReviewPassword = '';
    this.dataManagerReviewReason = '';
    this.dataManagerReviewError = '';
    this.dataManagerReviewVerifying = false;
    this.showDataManagerReviewPassword = false;

    this.dataManagerReviewStep = 1;
    this.dataManagerReviewConfirmationAccepted = false;

    this.dataManagerReviewFolderId = this.selectedFolderId || '';
    this.dataManagerReviewFormId = this.currentForm?.id || '';
    this.dataManagerReviewFieldId = '';

    this.dataManagerReviewFolderCheckboxes = {};
    this.dataManagerReviewFormCheckboxes = {};
    this.dataManagerReviewFieldCheckboxes = {};

    if (this.dataManagerReviewFolderId) {
      this.dataManagerReviewFolderCheckboxes[this.dataManagerReviewFolderId] = true;
    }
    if (this.dataManagerReviewFormId) {
      this.dataManagerReviewFormCheckboxes[this.dataManagerReviewFormId] = true;
    }

    this.showDataManagerReviewFolderDropdown = false;
    this.showDataManagerReviewFormDropdown = false;
    this.showDataManagerReviewFieldDropdown = false;

    this.buildDataManagerReviewTargets();
    this.showDataManagerReviewModal = true;
  }

  closeDataManagerReviewModal(): void {
    this.showDataManagerReviewModal = false;
    this.dataManagerReviewStep = 1;
    this.dataManagerReviewConfirmationAccepted = false;
    this.dataManagerReviewPassword = '';
    this.dataManagerReviewReason = '';
    this.dataManagerReviewError = '';
    this.dataManagerReviewVerifying = false;

    this.dataManagerReviewFolderId = '';
    this.dataManagerReviewFormId = '';
    this.dataManagerReviewFieldId = '';
    this.dataManagerReviewFolderCheckboxes = {};
    this.dataManagerReviewFormCheckboxes = {};
    this.dataManagerReviewFieldCheckboxes = {};
    this.dataManagerReviewAvailableFolders = [];
    this.dataManagerReviewAvailableForms = [];
    this.dataManagerReviewAvailableFields = [];
    this.closeDataManagerReviewDropdowns();
  }

  goToDataManagerReviewStep2(): void {
    if (!this.dataManagerReviewConfirmationAccepted) {
      this.dataManagerReviewError = 'Please accept the terms to continue.';
      return;
    }
    this.dataManagerReviewError = '';
    this.dataManagerReviewStep = 2;
  }

  goToDataManagerReviewStep3(): void {
    if (!this.dataManagerReviewFolderId && !this.hasAnyDataManagerReviewFolderCheckboxChecked()) {
      this.dataManagerReviewError = 'Please select at least one folder.';
      return;
    }
    this.dataManagerReviewError = '';
    this.dataManagerReviewStep = 3;
  }

  backToDataManagerReviewStep1(): void {
    this.dataManagerReviewStep = 1;
  }

  backToDataManagerReviewStep2(): void {
    this.dataManagerReviewStep = 2;
  }

  toggleDataManagerReviewPasswordVisibility(): void {
    this.showDataManagerReviewPassword = !this.showDataManagerReviewPassword;
  }

  closeDataManagerReviewDropdowns(): void {
    this.showDataManagerReviewFolderDropdown = false;
    this.showDataManagerReviewFormDropdown = false;
    this.showDataManagerReviewFieldDropdown = false;
  }

  toggleDataManagerReviewFolderDropdown(): void {
    this.showDataManagerReviewFolderDropdown = !this.showDataManagerReviewFolderDropdown;
    this.showDataManagerReviewFormDropdown = false;
    this.showDataManagerReviewFieldDropdown = false;
  }

  toggleDataManagerReviewFormDropdown(): void {
    this.showDataManagerReviewFormDropdown = !this.showDataManagerReviewFormDropdown;
    this.showDataManagerReviewFieldDropdown = false;
  }

  toggleDataManagerReviewFieldDropdown(): void {
    this.showDataManagerReviewFieldDropdown = !this.showDataManagerReviewFieldDropdown;
  }

  selectDataManagerReviewFolder(folderId: any): void {
    this.dataManagerReviewFolderId = folderId;
    this.showDataManagerReviewFolderDropdown = false;
    this.onDataManagerReviewFolderChange();
  }

  selectDataManagerReviewForm(formId: any): void {
    this.dataManagerReviewFormId = formId;
    this.showDataManagerReviewFormDropdown = false;
    this.onDataManagerReviewFormChange();
  }

  selectDataManagerReviewField(fieldId: any): void {
    this.dataManagerReviewFieldId = fieldId;
    this.showDataManagerReviewFieldDropdown = false;
  }

  toggleDataManagerReviewFolderCheckbox(folderId: any): void {
    this.dataManagerReviewFolderCheckboxes[folderId] = !this.dataManagerReviewFolderCheckboxes[folderId];
    this.onDataManagerReviewFolderChange();
  }

  toggleDataManagerReviewFormCheckbox(formId: any): void {
    this.dataManagerReviewFormCheckboxes[formId] = !this.dataManagerReviewFormCheckboxes[formId];
    this.onDataManagerReviewFormChange();
  }

  toggleDataManagerReviewFieldCheckbox(fieldId: any): void {
    this.dataManagerReviewFieldCheckboxes[fieldId] = !this.dataManagerReviewFieldCheckboxes[fieldId];
  }

  hasAnyDataManagerReviewFolderCheckboxChecked(): boolean {
    return Object.values(this.dataManagerReviewFolderCheckboxes).some(v => v === true);
  }

  hasAnyDataManagerReviewFormCheckboxChecked(): boolean {
    return Object.values(this.dataManagerReviewFormCheckboxes).some(v => v === true);
  }

  private hasAnyDataManagerReviewFieldCheckboxChecked(): boolean {
    return Object.values(this.dataManagerReviewFieldCheckboxes).some(v => v === true);
  }

  private buildDataManagerReviewTargets(): void {
    if (!this.template || !this.template.folders) {
      this.dataManagerReviewAvailableFolders = [];
      this.dataManagerReviewAvailableForms = [];
      this.dataManagerReviewAvailableFields = [];
      return;
    }

    this.dataManagerReviewAvailableFolders = this.template.folders.map((f: any) => ({
      id: f.id,
      name: f.name
    }));

    this.populateDataManagerReviewFormsFromCheckedFolders();
    this.populateDataManagerReviewFieldsFromCheckedForms();
  }

  private populateDataManagerReviewFormsFromCheckedFolders(): void {
    if (!this.template || !this.template.folders) {
      this.dataManagerReviewAvailableForms = [];
      return;
    }

    const allForms: any[] = [];
    const formIds = new Set();

    for (const folder of this.template.folders) {
      if (this.dataManagerReviewFolderCheckboxes[folder.id] && folder.forms) {
        folder.forms.forEach((form: any) => {
          if (!formIds.has(form.id)) {
            formIds.add(form.id);
            allForms.push({ id: form.id, name: form.name, folderId: folder.id });
          }
        });
      }
    }

    if (this.dataManagerReviewFolderId && !this.dataManagerReviewFolderCheckboxes[this.dataManagerReviewFolderId]) {
      const selectedFolder = this.template.folders.find((f: any) => f.id === this.dataManagerReviewFolderId);
      if (selectedFolder?.forms) {
        selectedFolder.forms.forEach((form: any) => {
          if (!formIds.has(form.id)) {
            formIds.add(form.id);
            allForms.push({ id: form.id, name: form.name, folderId: selectedFolder.id });
          }
        });
      }
    }

    this.dataManagerReviewAvailableForms = allForms;
  }

  private populateDataManagerReviewFieldsFromCheckedForms(): void {
    if (!this.template || !this.template.folders) {
      this.dataManagerReviewAvailableFields = [];
      return;
    }

    const allFields: any[] = [];
    const fieldIds = new Set();

    for (const folder of this.template.folders) {
      if (!folder.forms) continue;
      for (const form of folder.forms) {
        if (this.dataManagerReviewFormCheckboxes[form.id] && form.fields) {
          form.fields.forEach((field: any) => {
            if (!fieldIds.has(field.id)) {
              fieldIds.add(field.id);
              allFields.push({ id: field.id, title: field.title || field.name, formId: form.id });
            }
          });
        }
      }
    }

    if (this.dataManagerReviewFormId && !this.dataManagerReviewFormCheckboxes[this.dataManagerReviewFormId]) {
      for (const folder of this.template.folders) {
        const form = folder.forms?.find((frm: any) => frm.id === this.dataManagerReviewFormId);
        if (form?.fields) {
          form.fields.forEach((field: any) => {
            if (!fieldIds.has(field.id)) {
              fieldIds.add(field.id);
              allFields.push({ id: field.id, title: field.title || field.name, formId: form.id });
            }
          });
          break;
        }
      }
    }

    this.dataManagerReviewAvailableFields = allFields;
  }

  private onDataManagerReviewFolderChange(): void {
    this.dataManagerReviewFormId = '';
    this.dataManagerReviewFieldId = '';
    this.dataManagerReviewFormCheckboxes = {};
    this.dataManagerReviewFieldCheckboxes = {};
    this.populateDataManagerReviewFormsFromCheckedFolders();
    this.dataManagerReviewAvailableFields = [];
  }

  private onDataManagerReviewFormChange(): void {
    this.dataManagerReviewFieldId = '';
    this.dataManagerReviewFieldCheckboxes = {};
    this.populateDataManagerReviewFieldsFromCheckedForms();
  }

  getDataManagerReviewFolderLabel(): string {
    const checkedIds = Object.keys(this.dataManagerReviewFolderCheckboxes).filter(id => this.dataManagerReviewFolderCheckboxes[id]);
    if (checkedIds.length > 0) {
      return `${checkedIds.length} folder(s) selected`;
    }
    if (this.dataManagerReviewFolderId) {
      const f = this.dataManagerReviewAvailableFolders.find(x => x.id === this.dataManagerReviewFolderId);
      return f?.name || 'Selected folder';
    }
    return 'Select folder(s)';
  }

  getDataManagerReviewFormLabel(): string {
    const checkedIds = Object.keys(this.dataManagerReviewFormCheckboxes).filter(id => this.dataManagerReviewFormCheckboxes[id]);
    if (checkedIds.length > 0) {
      return `${checkedIds.length} form(s) selected`;
    }
    if (this.dataManagerReviewFormId) {
      const f = this.dataManagerReviewAvailableForms.find(x => x.id === this.dataManagerReviewFormId);
      return f?.name || 'Selected form';
    }
    return 'Select form(s)';
  }

  getDataManagerReviewFieldLabel(): string {
    const checkedIds = Object.keys(this.dataManagerReviewFieldCheckboxes).filter(id => this.dataManagerReviewFieldCheckboxes[id]);
    if (checkedIds.length > 0) {
      return `${checkedIds.length} field(s) selected`;
    }
    if (this.dataManagerReviewFieldId) {
      const f = this.dataManagerReviewAvailableFields.find(x => x.id === this.dataManagerReviewFieldId);
      return f?.title || 'Selected field';
    }
    return 'Select field(s)';
  }

  private collectDataManagerReviewTargets(): Array<{ formId: string; fieldId: string }> {
    if (!this.template || !this.template.folders) return [];

    if (this.hasAnyDataManagerReviewFieldCheckboxChecked()) {
      const targets: Array<{ formId: string; fieldId: string }> = [];
      const selectedFieldIds = Object.keys(this.dataManagerReviewFieldCheckboxes).filter(id => this.dataManagerReviewFieldCheckboxes[id]);
      const fieldToForm = new Map<string, string>();
      this.dataManagerReviewAvailableFields.forEach((f: any) => {
        if (f?.id != null && f?.formId != null) fieldToForm.set(String(f.id), String(f.formId));
      });
      selectedFieldIds.forEach(fid => {
        const formId = fieldToForm.get(String(fid));
        if (formId) targets.push({ formId: String(formId), fieldId: String(fid) });
      });
      return targets;
    }

    if (this.hasAnyDataManagerReviewFormCheckboxChecked()) {
      const selectedFormIds = Object.keys(this.dataManagerReviewFormCheckboxes).filter(id => this.dataManagerReviewFormCheckboxes[id]);
      const targets: Array<{ formId: string; fieldId: string }> = [];
      for (const folder of this.template.folders) {
        for (const form of (folder.forms || [])) {
          if (!selectedFormIds.includes(String(form.id))) continue;
          (form.fields || []).forEach((field: any) => {
            if (field?.id != null) targets.push({ formId: String(form.id), fieldId: String(field.id) });
          });
        }
      }
      return targets;
    }

    if (this.hasAnyDataManagerReviewFolderCheckboxChecked()) {
      const selectedFolderIds = Object.keys(this.dataManagerReviewFolderCheckboxes).filter(id => this.dataManagerReviewFolderCheckboxes[id]);
      const targets: Array<{ formId: string; fieldId: string }> = [];
      for (const folder of this.template.folders) {
        if (!selectedFolderIds.includes(String(folder.id))) continue;
        for (const form of (folder.forms || [])) {
          (form.fields || []).forEach((field: any) => {
            if (field?.id != null) targets.push({ formId: String(form.id), fieldId: String(field.id) });
          });
        }
      }
      return targets;
    }

    if (this.dataManagerReviewFieldId && this.dataManagerReviewFormId) {
      return [{ formId: String(this.dataManagerReviewFormId), fieldId: String(this.dataManagerReviewFieldId) }];
    }
    if (this.dataManagerReviewFormId) {
      const targets: Array<{ formId: string; fieldId: string }> = [];
      for (const folder of this.template.folders) {
        const form = folder.forms?.find((frm: any) => String(frm.id) === String(this.dataManagerReviewFormId));
        if (form) {
          (form.fields || []).forEach((field: any) => {
            if (field?.id != null) targets.push({ formId: String(form.id), fieldId: String(field.id) });
          });
          break;
        }
      }
      return targets;
    }
    return [];
  }

  authenticateAndApplyDataManagerReview(): void {
    if (this.dataManagerReviewVerifying) return;

    if (!this.dataManagerReviewPassword || !this.dataManagerReviewPassword.trim()) {
      this.dataManagerReviewError = 'Please enter your password';
      return;
    }
    if (!this.dataManagerReviewReason || !this.dataManagerReviewReason.trim()) {
      this.dataManagerReviewError = 'Please enter a reason';
      return;
    }
    if (!this.study_id || !this.subject_id) {
      this.dataManagerReviewError = 'Missing required data. Please refresh the page.';
      return;
    }

    const userData = this.commonService.getUserData();
    this.dataManagerReviewEmail = userData?.email || this.dataManagerReviewEmail || '';
    if (!this.dataManagerReviewEmail) {
      this.dataManagerReviewError = 'Unable to retrieve user email. Please login again.';
      return;
    }

    const targets = this.collectDataManagerReviewTargets();
    if (!targets.length) {
      this.dataManagerReviewError = 'Please select at least one folder/form/field to review.';
      return;
    }

    this.dataManagerReviewError = '';
    this.dataManagerReviewVerifying = true;

    const purpose = 'data_manager_review';
    this.apiService.login(this.dataManagerReviewEmail, this.dataManagerReviewPassword, purpose).subscribe({
      next: () => {
        const currentUser: any = this.currentUser || this.commonService.getUserData() || {};
        const reviewedBy = currentUser?.id || null;
        const reviewedByName =
          currentUser.first_name && currentUser.last_name
            ? `${currentUser.first_name} ${currentUser.last_name}`.trim()
            : currentUser.name || currentUser.email || this.dataManagerReviewEmail || 'Unknown';

        const requests = targets.map(t =>
          this.apiService.updateReviewStatus({
            study_id: this.study_id,
            subject_id: this.subject_id,
            form_id: t.formId,
            field_id: t.fieldId,
            review_type: 'dataManager',
            is_reviewed: true,
            reviewed_by: reviewedBy,
            reviewed_by_name: reviewedByName,
            review_reason: this.dataManagerReviewReason?.trim() || null
          })
        );

        forkJoin(requests).subscribe({
          next: () => {
            this.dataManagerReviewVerifying = false;
            this.closeDataManagerReviewModal();
            alert('Data Manager review applied successfully.');
          },
          error: () => {
            this.dataManagerReviewVerifying = false;
            this.dataManagerReviewError = 'Failed to apply data manager review. Please try again.';
          }
        });
      },
      error: (error) => {
        this.dataManagerReviewVerifying = false;
        this.dataManagerReviewError = error?.error?.message || 'Invalid email or password. Please try again.';
      }
    });
  }

  // Helper methods for instruction images (similar to ecrf-template)
  getInstructionImageSrc(image: any): string {
    if (typeof image === 'string') {
      return image;
    }
    // Handle attachment-like structure from backend (url, documentLink, etc.)
    const src = image?.url || image?.documentLink || image?.preview || image || '';
    return src;
  }

  getInstructionImageAlt(image: any): string {
    if (typeof image === 'string') {
      // Extract filename from URL if it's a string
      return this.extractFileNameFromUrl(image);
    }
    return image?.name || 'Instruction image';
  }

  hasImageName(image: any): boolean {
    if (typeof image === 'string') {
      // If it's a URL string, try to extract filename
      const fileName = this.extractFileNameFromUrl(image);
      return fileName !== 'Instruction image';
    }
    return !!image?.name;
  }

  getInstructionImageName(image: any): string {
    if (typeof image === 'string') {
      return this.extractFileNameFromUrl(image);
    }
    return image?.name || 'Instruction image';
  }

  extractFileNameFromUrl(url: string): string {
    if (!url) return 'Instruction image';
    try {
      // Remove query parameters
      const sanitizedPath = url.split('?')[0];
      // Get the last segment of the path
      const segments = sanitizedPath.split('/');
      const fileName = segments.pop() || sanitizedPath;
      // Return filename or default
      return fileName || 'Instruction image';
    } catch {
      return 'Instruction image';
    }
  }

  // Get instruction table data (for display-only instruction tables)
  getInstructionTableData(field: any): any[] {
    // Return instruction table data from backend
    // Check for instructionTableData or predefinedRows
    if (field.instructionTableData && Array.isArray(field.instructionTableData)) {
      return field.instructionTableData;
    }
    if (field.predefinedRows && Array.isArray(field.predefinedRows)) {
      return field.predefinedRows;
    }
    return [];
  }

  checkInstructionImages(field: any): boolean {
    const hasImages = field.instructionImages && field.instructionImages.length > 0;
    return hasImages;
  }

  logInstructionField(field: any): boolean {
    return true; // Always return true to render the field
  }

  openImageModal(imageUrl: string): void {
    if (imageUrl) {
      window.open(imageUrl, '_blank');
    }
  }

  handleImageError(event: any, image: any): void {
    const imgSrc = this.getInstructionImageSrc(image);
    
    
    // Check for CORS errors
    if (event.target && event.target.naturalWidth === 0 && event.target.naturalHeight === 0) {
      
    }
    
    // Try to get a fresh URL if it's expired
    if (imgSrc && imgSrc.includes('X-Goog-Expires')) {
      // Extract expiration time from URL
      const expiresMatch = imgSrc.match(/X-Goog-Expires=(\d+)/);
    }
    
    // Set fallback image
    event.target.src = 'data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'200\' height=\'200\'%3E%3Crect fill=\'%23ddd\' width=\'200\' height=\'200\'/%3E%3Ctext fill=\'%23999\' font-family=\'sans-serif\' font-size=\'14\' dy=\'10.5\' font-weight=\'bold\' x=\'50%25\' y=\'50%25\' text-anchor=\'middle\'%3EImage not available%3C/text%3E%3C/svg%3E';
  }

  handleImageLoad(event: any, image: any): void {
  }

  // =============================
  // Freeze / Lock helper methods
  // =============================

  private buildFreezeTargets(): void {
    if (!this.template || !this.template.folders) {
      this.freezeAvailableFolders = [];
      this.freezeAvailableForms = [];
      this.freezeAvailableFields = [];
      return;
    }
    this.freezeAvailableFolders = this.template.folders.map((folder: any) => ({
      id: folder.id,
      name: folder.name
    }));
    this.onFreezeFolderChange();
  }

  onFreezeFolderChange(): void {
    this.freezeFormId = '';
    this.freezeFieldId = '';
    this.freezeAvailableFields = [];
    this.populateFreezeFormsFromCheckedFolders();

    if (this.freezeFolderId && this.template && this.template.folders) {
      const folder = this.template.folders.find((f: any) => f.id === this.freezeFolderId);
      if (folder) {
        this.isFreezing = !folder.is_frozen;
      }
    }
  }

  onFreezeFormChange(): void {
    this.freezeFieldId = '';
    this.populateFreezeFieldsFromCheckedForms();

    if (this.freezeFormId && this.template && this.template.folders) {
      for (const folder of this.template.folders) {
        const form = folder?.forms?.find((frm: any) => frm.id === this.freezeFormId);
        if (form) {
          this.isFreezing = !form.is_frozen;
          break;
        }
      }
    }
  }

  private buildLockTargets(): void {
    if (!this.template || !this.template.folders) {
      this.lockAvailableFolders = [];
      this.lockAvailableForms = [];
      this.lockAvailableFields = [];
      return;
    }
    this.lockAvailableFolders = this.template.folders.map((folder: any) => ({
      id: folder.id,
      name: folder.name
    }));
    this.onLockFolderChange();
  }

  private collectTemplateFieldIds(): string[] {
    if (!this.template || !this.template.folders) {
      return [];
    }
    const ids = new Set<string>();
    this.template.folders.forEach((folder: any) => {
      folder?.forms?.forEach((form: any) => {
        form?.fields?.forEach((field: any) => {
          if (field?.id != null) {
            ids.add(String(field.id));
          }
        });
      });
    });
    return Array.from(ids);
  }

  private prefillLockCheckboxesFromLockedData(): void {
    if (!this.template || !this.template.folders) return;

    const fieldIds = this.collectTemplateFieldIds();
    if (!fieldIds.length) return;

    this.apiService.fetchLockedFields({
      locked_data_id: fieldIds,
      data_type: 'template_field',
      ...(this.study_id != null && { study_id: this.study_id }),
      ...(this.subject_id != null && { subject_id: this.subject_id })
    }).subscribe({
      next: (response: any) => {
        const rows = Array.isArray(response?.data) ? response.data : [];
        const lockedMap = new Map<string, { is_locked: boolean; is_freezed: boolean }>();
        rows.forEach((row: any) => {
          const id = row?.locked_data_id != null ? String(row.locked_data_id) : null;
          if (!id) return;
          const isLocked = row?.is_locked === 1 || row?.is_locked === true;
          const isFreezed = row?.is_freezed === 1 || row?.is_freezed === true;
          if (isLocked || isFreezed) {
            lockedMap.set(id, { is_locked: isLocked, is_freezed: isFreezed });
          }
        });

        this.template.folders.forEach((folder: any) => {
          folder?.forms?.forEach((form: any) => {
            form?.fields?.forEach((field: any) => {
              const fieldId = field?.id != null ? String(field.id) : null;
              if (!fieldId) return;
              const status = lockedMap.get(fieldId);
              if (status?.is_locked) field.is_locked = true;
              if (status?.is_freezed) field.is_frozen = true;
              if (field?.is_locked || field?.is_frozen) {
                this.lockFieldCheckboxes[fieldId] = true;
              }
            });
          });
        });
        this.syncLockFormCheckboxesFromFields();
      },
      error: (error) => {
      }
    });
  }

  private syncLockFormCheckboxesFromFields(): void {
    if (!this.template || !this.template.folders) return;
    this.template.folders.forEach((folder: any) => {
      folder?.forms?.forEach((form: any) => {
        const fieldIds = (form?.fields || [])
          .map((field: any) => (field?.id != null ? String(field.id) : null))
          .filter((id: string | null) => id != null) as string[];
        if (!fieldIds.length) {
          this.lockFormCheckboxes[form.id] = false;
          return;
        }
        const allChecked = fieldIds.every((id) => this.lockFieldCheckboxes[id]);
        this.lockFormCheckboxes[form.id] = allChecked;
      });
    });
  }

  private prefillFreezeCheckboxesFromLockedData(): void {
    if (!this.template || !this.template.folders) return;

    const fieldIds = this.collectTemplateFieldIds();
    if (!fieldIds.length) return;

    this.apiService.fetchLockedFields({
      locked_data_id: fieldIds,
      data_type: 'template_field',
      ...(this.study_id != null && { study_id: this.study_id }),
      ...(this.subject_id != null && { subject_id: this.subject_id })
    }).subscribe({
      next: (response: any) => {
        const rows = Array.isArray(response?.data) ? response.data : [];
        const lockedMap = new Map<string, { is_locked: boolean; is_freezed: boolean }>();
        rows.forEach((row: any) => {
          const id = row?.locked_data_id != null ? String(row.locked_data_id) : null;
          if (!id) return;
          const isLocked = row?.is_locked === 1 || row?.is_locked === true;
          const isFreezed = row?.is_freezed === 1 || row?.is_freezed === true;
          if (isLocked || isFreezed) {
            lockedMap.set(id, { is_locked: isLocked, is_freezed: isFreezed });
          }
        });

        this.template.folders.forEach((folder: any) => {
          folder?.forms?.forEach((form: any) => {
            form?.fields?.forEach((field: any) => {
              const fieldId = field?.id != null ? String(field.id) : null;
              if (!fieldId) return;
              const status = lockedMap.get(fieldId);
              if (status?.is_locked) field.is_locked = true;
              if (status?.is_freezed) field.is_frozen = true;
              if (field?.is_locked || field?.is_frozen) {
                this.freezeFieldCheckboxes[fieldId] = true;
              }
            });
          });
        });
        this.syncFreezeFormCheckboxesFromFields();
      },
      error: (error) => {
      }
    });
  }

  private syncFreezeFormCheckboxesFromFields(): void {
    if (!this.template || !this.template.folders) return;
    this.template.folders.forEach((folder: any) => {
      folder?.forms?.forEach((form: any) => {
        const fieldIds = (form?.fields || [])
          .map((field: any) => (field?.id != null ? String(field.id) : null))
          .filter((id: string | null) => id != null) as string[];
        if (!fieldIds.length) {
          this.freezeFormCheckboxes[form.id] = false;
          return;
        }
        const allChecked = fieldIds.every((id) => this.freezeFieldCheckboxes[id]);
        this.freezeFormCheckboxes[form.id] = allChecked;
      });
    });
  }

  private populateLockFormsFromCheckedFolders(): void {
    if (!this.template || !this.template.folders) {
      this.lockAvailableForms = [];
      return;
    }

    const allForms: any[] = [];
    const formIds = new Set();

    for (const folder of this.template.folders) {
      if (this.lockFolderCheckboxes[folder.id] && folder.forms) {
        folder.forms.forEach((form: any) => {
          if (!formIds.has(form.id)) {
            formIds.add(form.id);
            allForms.push({
              id: form.id,
              name: form.name,
              folderId: folder.id
            });
          }
        });
      }
    }

    if (this.lockFolderId && !this.lockFolderCheckboxes[this.lockFolderId]) {
      const selectedFolder = this.template.folders.find((f: any) => f.id === this.lockFolderId);
      if (selectedFolder && selectedFolder.forms) {
        selectedFolder.forms.forEach((form: any) => {
          if (!formIds.has(form.id)) {
            formIds.add(form.id);
            allForms.push({
              id: form.id,
              name: form.name,
              folderId: selectedFolder.id
            });
          }
        });
      }
    }

    this.lockAvailableForms = allForms;
  }

  private populateLockFieldsFromCheckedForms(): void {
    if (!this.template || !this.template.folders) {
      this.lockAvailableFields = [];
      return;
    }

    const allFields: any[] = [];
    const fieldIds = new Set();

    for (const folder of this.template.folders) {
      if (folder.forms) {
        for (const form of folder.forms) {
          if (this.lockFormCheckboxes[form.id] && form.fields) {
            form.fields.forEach((field: any) => {
              if (!fieldIds.has(field.id)) {
                fieldIds.add(field.id);
                allFields.push({
                  id: field.id,
                  title: field.title,
                  formId: form.id
                });
              }
            });
          }
        }
      }
    }

    if (this.lockFormId && !this.lockFormCheckboxes[this.lockFormId]) {
      for (const folder of this.template.folders) {
        const form = folder.forms?.find((frm: any) => frm.id === this.lockFormId);
        if (form && form.fields) {
          form.fields.forEach((field: any) => {
            if (!fieldIds.has(field.id)) {
              fieldIds.add(field.id);
              allFields.push({
                id: field.id,
                title: field.title,
                formId: form.id
              });
            }
          });
        }
      }
    }

    this.lockAvailableFields = allFields;
  }

  onLockFolderChange(): void {
    this.lockFormId = '';
    this.lockFieldId = '';
    this.lockAvailableFields = [];
    this.populateLockFormsFromCheckedFolders();
  }

  onLockFormChange(): void {
    this.lockFieldId = '';
    this.populateLockFieldsFromCheckedForms();
  }

  // Open/close modals from folder dropdown
  openFreezeModalForFolder(folder: any, event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    if (!this.canManageFreezeLock()) {
      return;
    }
    if (this.showLockModal) {
      this.closeLockModal();
    }
    this.freezeStep = 1;
    this.freezeOpenedFromFolderMenu = true;
    this.freezeFolderId = folder.id;
    this.freezeFormId = '';
    this.freezeFieldId = '';
    this.freezeFolderCheckboxes = {};
    this.freezeFormCheckboxes = {};
    this.freezeFieldCheckboxes = {};
    this.showFreezeFolderDropdown = false;
    this.showFreezeFormDropdown = false;
    this.showFreezeFieldDropdown = false;
    this.buildFreezeTargets();
    this.prefillFreezeCheckboxesFromLockedData();
    this.isFreezing = !folder.is_frozen;
    this.freezeConfirmationAccepted = false;
    this.freezeEmail = '';
    this.freezePassword = '';
    this.freezeReason = '';
    this.freezeError = '';
    this.showFreezePassword = false;
    this.showFreezeModal = true;
  }

  openLockModalForFolder(folder: any, event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    if (!this.canManageFreezeLock()) {
      return;
    }
    if (this.showFreezeModal) {
      this.closeFreezeModal();
    }
    if (folder.is_locked) {
      alert('This folder is already locked.');
      return;
    }
    this.lockStep = 1;
    this.lockOpenedFromFolderMenu = true;
    this.lockFolderId = folder.id;
    this.lockFormId = '';
    this.lockFieldId = '';
    this.lockFolderCheckboxes = {};
    this.lockFormCheckboxes = {};
    this.lockFieldCheckboxes = {};
    this.showLockFolderDropdown = false;
    this.showLockFormDropdown = false;
    this.showLockFieldDropdown = false;
    this.buildLockTargets();
    this.prefillLockCheckboxesFromLockedData();
    this.lockConfirmationAccepted = false;
    this.lockEmail = '';
    this.lockPassword = '';
    this.lockReason = '';
    this.lockError = '';
    this.showLockPassword = false;
    this.showLockModal = true;
  }

  closeFreezeModal(): void {
    this.showFreezeModal = false;
    this.freezeStep = 1;
    this.freezeOpenedFromFolderMenu = false;
    this.freezeConfirmationAccepted = false;
    this.freezeEmail = '';
    this.freezePassword = '';
    this.freezeReason = '';
    this.freezeError = '';
    this.freezeFolderId = '';
    this.freezeFormId = '';
    this.freezeFieldId = '';
    this.freezeFolderCheckboxes = {};
    this.freezeFormCheckboxes = {};
    this.freezeFieldCheckboxes = {};
    this.showFreezeFolderDropdown = false;
    this.showFreezeFormDropdown = false;
    this.showFreezeFieldDropdown = false;
  }

  closeLockModal(): void {
    this.showLockModal = false;
    this.lockStep = 1;
    this.lockOpenedFromFolderMenu = false;
    this.lockConfirmationAccepted = false;
    this.lockEmail = '';
    this.lockPassword = '';
    this.lockReason = '';
    this.lockError = '';
    this.lockFolderId = '';
    this.lockFormId = '';
    this.lockFieldId = '';
    this.lockFolderCheckboxes = {};
    this.lockFormCheckboxes = {};
    this.lockFieldCheckboxes = {};
    this.showLockFolderDropdown = false;
    this.showLockFormDropdown = false;
    this.showLockFieldDropdown = false;
  }

  getFolderNameById(folderId: any): string {
    if (!folderId || !this.template?.folders) return '—';
    const f = this.template.folders.find((x: any) => x.id === folderId);
    return f?.name || '—';
  }

  toggleFreezePasswordVisibility(): void {
    this.showFreezePassword = !this.showFreezePassword;
  }

  toggleLockPasswordVisibility(): void {
    this.showLockPassword = !this.showLockPassword;
  }

  goToFreezeStep2(): void {
    if (!this.freezeConfirmationAccepted) {
      this.freezeError = 'Please accept the terms to continue.';
      return;
    }
    this.freezeError = '';
    this.freezeStep = 2;
  }

  goToFreezeStep3(): void {
    if (!this.freezeFolderId && !this.hasAnyFreezeFolderCheckboxChecked()) {
      this.freezeError = 'Please select at least one folder.';
      return;
    }
    this.freezeError = '';
    this.freezeStep = 3;
  }

  backToFreezeStep1(): void {
    this.freezeStep = 1;
  }

  backToFreezeStep2(): void {
    this.freezeStep = 2;
  }

  goToLockStep2(): void {
    if (!this.lockConfirmationAccepted) {
      this.lockError = 'Please accept the terms to continue.';
      return;
    }
    this.lockError = '';
    this.lockStep = 2;
  }

  goToLockStep3(): void {
    if (!this.lockFolderId && !this.hasAnyLockFolderCheckboxChecked()) {
      this.lockError = 'Please select at least one folder.';
      return;
    }
    this.lockError = '';
    this.lockStep = 3;
  }

  backToLockStep1(): void {
    this.lockStep = 1;
  }

  backToLockStep2(): void {
    this.lockStep = 2;
  }

  private getFreezeTarget(): { type: 'folder' | 'form' | 'field', folder?: any, form?: any, field?: any } | null {
    if (!this.template || !this.template.folders || !this.freezeFolderId) {
      return null;
    }
    const folder = this.template.folders.find((f: any) => f.id === this.freezeFolderId);
    if (!folder) {
      return null;
    }
    if (this.freezeFormId) {
      const form = folder.forms?.find((frm: any) => frm.id === this.freezeFormId);
      if (!form) {
        return null;
      }
      if (this.freezeFieldId) {
        const field = form.fields?.find((fld: any) => fld.id === this.freezeFieldId);
        if (!field) {
          return null;
        }
        return { type: 'field', folder, form, field };
      }
      return { type: 'form', folder, form };
    }
    return { type: 'folder', folder };
  }

  private getLockTarget(): { type: 'folder' | 'form' | 'field', folder?: any, form?: any, field?: any } | null {
    if (!this.template || !this.template.folders || !this.lockFolderId) {
      return null;
    }
    const folder = this.template.folders.find((f: any) => f.id === this.lockFolderId);
    if (!folder) {
      return null;
    }
    if (this.lockFormId) {
      const form = folder.forms?.find((frm: any) => frm.id === this.lockFormId);
      if (!form) {
        return null;
      }
      if (this.lockFieldId) {
        const field = form.fields?.find((fld: any) => fld.id === this.lockFieldId);
        if (!field) {
          return null;
        }
        return { type: 'field', folder, form, field };
      }
      return { type: 'form', folder, form };
    }
    return { type: 'folder', folder };
  }

  closeFreezeDropdowns(): void {
    this.showFreezeFolderDropdown = false;
    this.showFreezeFormDropdown = false;
    this.showFreezeFieldDropdown = false;
  }

  closeLockDropdowns(): void {
    this.showLockFolderDropdown = false;
    this.showLockFormDropdown = false;
    this.showLockFieldDropdown = false;
  }

  toggleFreezeFolderDropdown(): void {
    this.showFreezeFolderDropdown = !this.showFreezeFolderDropdown;
    this.showFreezeFormDropdown = false;
    this.showFreezeFieldDropdown = false;
  }

  toggleFreezeFormDropdown(): void {
    this.showFreezeFormDropdown = !this.showFreezeFormDropdown;
    this.showFreezeFieldDropdown = false;
  }

  toggleFreezeFieldDropdown(): void {
    this.showFreezeFieldDropdown = !this.showFreezeFieldDropdown;
  }

  selectFreezeFolder(folderId: any): void {
    this.freezeFolderId = folderId;
    this.showFreezeFolderDropdown = false;
    this.onFreezeFolderChange();
  }

  selectFreezeForm(formId: any): void {
    this.freezeFormId = formId;
    this.showFreezeFormDropdown = false;
    this.onFreezeFormChange();
  }

  selectFreezeField(fieldId: any): void {
    this.freezeFieldId = fieldId;
    this.showFreezeFieldDropdown = false;
  }

  hasAnyFreezeFolderCheckboxChecked(): boolean {
    return Object.values(this.freezeFolderCheckboxes).some(checked => checked === true);
  }

  hasAnyFreezeFormCheckboxChecked(): boolean {
    return Object.values(this.freezeFormCheckboxes).some(checked => checked === true);
  }

  private hasAnyFreezeFieldCheckboxChecked(): boolean {
    return Object.values(this.freezeFieldCheckboxes).some(checked => checked === true);
  }

  private populateFreezeFormsFromCheckedFolders(): void {
    if (!this.template || !this.template.folders) {
      this.freezeAvailableForms = [];
      return;
    }

    const allForms: any[] = [];
    const formIds = new Set();

    for (const folder of this.template.folders) {
      if (this.freezeFolderCheckboxes[folder.id] && folder.forms) {
        folder.forms.forEach((form: any) => {
          if (!formIds.has(form.id)) {
            formIds.add(form.id);
            allForms.push({
              id: form.id,
              name: form.name,
              folderId: folder.id
            });
          }
        });
      }
    }

    if (this.freezeFolderId && !this.freezeFolderCheckboxes[this.freezeFolderId]) {
      const selectedFolder = this.template.folders.find((f: any) => f.id === this.freezeFolderId);
      if (selectedFolder && selectedFolder.forms) {
        selectedFolder.forms.forEach((form: any) => {
          if (!formIds.has(form.id)) {
            formIds.add(form.id);
            allForms.push({
              id: form.id,
              name: form.name,
              folderId: selectedFolder.id
            });
          }
        });
      }
    }

    this.freezeAvailableForms = allForms;
  }

  private populateFreezeFieldsFromCheckedForms(): void {
    if (!this.template || !this.template.folders) {
      this.freezeAvailableFields = [];
      return;
    }

    const allFields: any[] = [];
    const fieldIds = new Set();

    for (const folder of this.template.folders) {
      if (folder.forms) {
        for (const form of folder.forms) {
          if (this.freezeFormCheckboxes[form.id] && form.fields) {
            form.fields.forEach((field: any) => {
              if (!fieldIds.has(field.id)) {
                fieldIds.add(field.id);
                allFields.push({
                  id: field.id,
                  title: field.title,
                  formId: form.id
                });
              }
            });
          }
        }
      }
    }

    if (this.freezeFormId && !this.freezeFormCheckboxes[this.freezeFormId]) {
      for (const folder of this.template.folders) {
        const form = folder.forms?.find((frm: any) => frm.id === this.freezeFormId);
        if (form && form.fields) {
          form.fields.forEach((field: any) => {
            if (!fieldIds.has(field.id)) {
              fieldIds.add(field.id);
              allFields.push({
                id: field.id,
                title: field.title,
                formId: form.id
              });
            }
          });
        }
      }
    }

    this.freezeAvailableFields = allFields;
  }

  toggleFreezeFolderCheckbox(folderId: any): void {
    this.freezeFolderCheckboxes[folderId] = !this.freezeFolderCheckboxes[folderId];

    if (this.freezeFolderCheckboxes[folderId] && !this.freezeFolderId) {
      this.freezeFolderId = folderId;
    }

    this.populateFreezeFormsFromCheckedFolders();

    if (this.freezeFolderCheckboxes[folderId]) {
      this.freezeFormId = '';
      this.freezeFieldId = '';
      this.freezeFormCheckboxes = {};
      this.freezeFieldCheckboxes = {};
      this.freezeAvailableFields = [];
    }
  }

  toggleFreezeFormCheckbox(formId: any): void {
    this.freezeFormCheckboxes[formId] = !this.freezeFormCheckboxes[formId];

    if (this.freezeFormCheckboxes[formId] && this.template && this.template.folders) {
      for (const folder of this.template.folders) {
        if (folder.forms?.some((frm: any) => frm.id === formId)) {
          if (!this.freezeFolderId) {
            this.freezeFolderId = folder.id;
          }
          break;
        }
      }
    }

    this.populateFreezeFieldsFromCheckedForms();

    if (this.freezeFormCheckboxes[formId]) {
      this.freezeFieldId = '';
      this.freezeFieldCheckboxes = {};
    }
  }

  toggleFreezeFieldCheckbox(fieldId: any): void {
    this.freezeFieldCheckboxes[fieldId] = !this.freezeFieldCheckboxes[fieldId];
  }

  toggleLockFolderDropdown(): void {
    this.showLockFolderDropdown = !this.showLockFolderDropdown;
    this.showLockFormDropdown = false;
    this.showLockFieldDropdown = false;
  }

  toggleLockFormDropdown(): void {
    this.showLockFormDropdown = !this.showLockFormDropdown;
    this.showLockFieldDropdown = false;
  }

  toggleLockFieldDropdown(): void {
    this.showLockFieldDropdown = !this.showLockFieldDropdown;
  }

  toggleLockFolderCheckbox(folderId: any): void {
    this.lockFolderCheckboxes[folderId] = !this.lockFolderCheckboxes[folderId];

    if (this.lockFolderCheckboxes[folderId] && !this.lockFolderId) {
      this.lockFolderId = folderId;
    }

    this.populateLockFormsFromCheckedFolders();

    if (this.lockFolderCheckboxes[folderId]) {
      this.lockFormId = '';
      this.lockFieldId = '';
      this.lockFormCheckboxes = {};
      this.lockFieldCheckboxes = {};
      this.lockAvailableFields = [];
    }
  }

  toggleLockFormCheckbox(formId: any): void {
    this.lockFormCheckboxes[formId] = !this.lockFormCheckboxes[formId];

    if (this.lockFormCheckboxes[formId] && this.template && this.template.folders) {
      for (const folder of this.template.folders) {
        if (folder.forms?.some((frm: any) => frm.id === formId)) {
          if (!this.lockFolderId) {
            this.lockFolderId = folder.id;
          }
          break;
        }
      }
    }

    this.populateLockFieldsFromCheckedForms();

    if (this.lockFormCheckboxes[formId]) {
      this.lockFieldId = '';
      this.lockFieldCheckboxes = {};
    }
  }

  toggleLockFieldCheckbox(fieldId: any): void {
    this.lockFieldCheckboxes[fieldId] = !this.lockFieldCheckboxes[fieldId];
  }

  // PI Signature methods
  private buildPiSignatureTargets(): void {
    if (!this.template || !this.template.folders) {
      this.piSignatureAvailableFolders = [];
      this.piSignatureAvailableForms = [];
      return;
    }
    this.piSignatureAvailableFolders = this.template.folders.map((folder: any) => ({
      id: folder.id,
      name: folder.name
    }));
    this.onPiSignatureFolderChange();
  }

  onPiSignatureFolderChange(): void {
    this.piSignatureFormId = '';
    this.populatePiSignatureFormsFromCheckedFolders();
  }

  onPiSignatureFormChange(): void {
    // Form change logic if needed
  }

  private populatePiSignatureFormsFromCheckedFolders(): void {
    if (!this.template || !this.template.folders) {
      this.piSignatureAvailableForms = [];
      return;
    }

    const allForms: any[] = [];
    const formIds = new Set();

    for (const folder of this.template.folders) {
      if (this.piSignatureFolderCheckboxes[folder.id] && folder.forms) {
        folder.forms.forEach((form: any) => {
          if (!formIds.has(form.id)) {
            formIds.add(form.id);
            allForms.push({
              id: form.id,
              name: form.name,
              folderId: folder.id
            });
          }
        });
      }
    }

    if (this.piSignatureFolderId && !this.piSignatureFolderCheckboxes[this.piSignatureFolderId]) {
      const selectedFolder = this.template.folders.find((f: any) => f.id === this.piSignatureFolderId);
      if (selectedFolder && selectedFolder.forms) {
        selectedFolder.forms.forEach((form: any) => {
          if (!formIds.has(form.id)) {
            formIds.add(form.id);
            allForms.push({
              id: form.id,
              name: form.name,
              folderId: selectedFolder.id
            });
          }
        });
      }
    }

    this.piSignatureAvailableForms = allForms;
  }

  togglePiSignatureFolderDropdown(): void {
    this.showPiSignatureFolderDropdown = !this.showPiSignatureFolderDropdown;
    this.showPiSignatureFormDropdown = false;
  }

  togglePiSignatureFormDropdown(): void {
    this.showPiSignatureFormDropdown = !this.showPiSignatureFormDropdown;
  }

  selectPiSignatureFolder(folderId: any): void {
    this.piSignatureFolderId = folderId;
    this.showPiSignatureFolderDropdown = false;
    this.onPiSignatureFolderChange();
  }

  selectPiSignatureForm(formId: any): void {
    this.piSignatureFormId = formId;
    this.showPiSignatureFormDropdown = false;
    this.onPiSignatureFormChange();
  }

  togglePiSignatureFolderCheckbox(folderId: any): void {
    this.piSignatureFolderCheckboxes[folderId] = !this.piSignatureFolderCheckboxes[folderId];

    if (this.piSignatureFolderCheckboxes[folderId] && !this.piSignatureFolderId) {
      this.piSignatureFolderId = folderId;
    }

    this.populatePiSignatureFormsFromCheckedFolders();

    if (this.piSignatureFolderCheckboxes[folderId]) {
      this.piSignatureFormId = '';
      this.piSignatureFormCheckboxes = {};
    }
  }

  togglePiSignatureFormCheckbox(formId: any): void {
    this.piSignatureFormCheckboxes[formId] = !this.piSignatureFormCheckboxes[formId];

    if (this.piSignatureFormCheckboxes[formId] && this.template && this.template.folders) {
      for (const folder of this.template.folders) {
        if (folder.forms?.some((frm: any) => frm.id === formId)) {
          if (!this.piSignatureFolderId) {
            this.piSignatureFolderId = folder.id;
          }
          break;
        }
      }
    }
  }

  hasAnyPiSignatureFolderCheckboxChecked(): boolean {
    return Object.values(this.piSignatureFolderCheckboxes).some(checked => checked === true);
  }

  hasAnyPiSignatureFormCheckboxChecked(): boolean {
    return Object.values(this.piSignatureFormCheckboxes).some(checked => checked === true);
  }

  getPiSignatureFolderLabel(): string {
    const checkedIds = Object.keys(this.piSignatureFolderCheckboxes || {}).filter(id => this.piSignatureFolderCheckboxes[id]);
    if (checkedIds.length > 1) {
      return `${checkedIds.length} folders selected`;
    }
    if (checkedIds.length === 1) {
      const foundChecked = this.piSignatureAvailableFolders?.find((x: any) => x.id === checkedIds[0]);
      return foundChecked?.name || 'Select folder';
    }
    if (this.piSignatureFolderId) {
      const found = this.piSignatureAvailableFolders?.find((x: any) => x.id === this.piSignatureFolderId);
      return found?.name || 'Select folder';
    }
    return 'Select folder';
  }

  getPiSignatureFormLabel(): string {
    const checkedIds = Object.keys(this.piSignatureFormCheckboxes || {}).filter(id => this.piSignatureFormCheckboxes[id]);
    if (checkedIds.length > 1) {
      return `${checkedIds.length} forms selected`;
    }
    if (checkedIds.length === 1) {
      const foundChecked = this.piSignatureAvailableForms?.find((x: any) => x.id === checkedIds[0]);
      return foundChecked?.name || 'Select form';
    }
    if (this.piSignatureFormId) {
      const found = this.piSignatureAvailableForms?.find((x: any) => x.id === this.piSignatureFormId);
      return found?.name || 'Select form';
    }
    return 'Select form';
  }

  closePiSignatureDropdowns(): void {
    this.showPiSignatureFolderDropdown = false;
    this.showPiSignatureFormDropdown = false;
  }

  selectLockFolder(folderId: any): void {
    this.lockFolderId = folderId;
    this.showLockFolderDropdown = false;
    this.onLockFolderChange();
  }

  selectLockForm(formId: any): void {
    this.lockFormId = formId;
    this.showLockFormDropdown = false;
    this.onLockFormChange();
  }

  selectLockField(fieldId: any): void {
    this.lockFieldId = fieldId;
    this.showLockFieldDropdown = false;
  }

  hasAnyLockFolderCheckboxChecked(): boolean {
    return Object.values(this.lockFolderCheckboxes).some(checked => checked === true);
  }

  hasAnyLockFormCheckboxChecked(): boolean {
    return Object.values(this.lockFormCheckboxes).some(checked => checked === true);
  }

  getActiveLockFolderId(): any {
    if (this.lockFolderId) {
      return this.lockFolderId;
    }
    for (const folderId in this.lockFolderCheckboxes) {
      if (this.lockFolderCheckboxes[folderId]) {
        return folderId;
      }
    }
    return null;
  }

  getActiveLockFormId(): any {
    if (this.lockFormId) {
      return this.lockFormId;
    }
    for (const formId in this.lockFormCheckboxes) {
      if (this.lockFormCheckboxes[formId]) {
        return formId;
      }
    }
    return null;
  }

  getFreezeFolderLabel(): string {
    const checkedIds = Object.keys(this.freezeFolderCheckboxes || {}).filter(id => this.freezeFolderCheckboxes[id]);
    if (checkedIds.length > 1) {
      return `${checkedIds.length} folders selected`;
    }
    if (checkedIds.length === 1) {
      const foundChecked = this.freezeAvailableFolders?.find((x: any) => x.id === checkedIds[0]);
      return foundChecked?.name || 'Select Folder';
    }
    if (this.freezeFolderId) {
      const found = this.freezeAvailableFolders?.find((x: any) => x.id === this.freezeFolderId);
      return found?.name || 'Select Folder';
    }
    return 'Select Folder';
  }

  getFreezeFormLabel(): string {
    if (!this.freezeFormId) return 'All Forms in Folder';
    const found = this.freezeAvailableForms?.find((x: any) => x.id === this.freezeFormId);
    return found?.name || 'All Forms in Folder';
  }

  getFreezeFieldLabel(): string {
    if (!this.freezeFieldId) return 'All Fields in Form';
    const found = this.freezeAvailableFields?.find((x: any) => x.id === this.freezeFieldId);
    return found?.title || 'All Fields in Form';
  }

  getLockFolderLabel(): string {
    const checkedIds = Object.keys(this.lockFolderCheckboxes || {}).filter(id => this.lockFolderCheckboxes[id]);
    if (checkedIds.length > 1) {
      return `${checkedIds.length} folders selected`;
    }
    if (checkedIds.length === 1) {
      const foundChecked = this.lockAvailableFolders?.find((x: any) => x.id === checkedIds[0]);
      return foundChecked?.name || 'Select Folder';
    }
    if (this.lockFolderId) {
      const found = this.lockAvailableFolders?.find((x: any) => x.id === this.lockFolderId);
      return found?.name || 'Select Folder';
    }
    return 'Select Folder';
  }

  getLockFormLabel(): string {
    const checkedIds = Object.keys(this.lockFormCheckboxes || {}).filter(id => this.lockFormCheckboxes[id]);
    if (checkedIds.length > 1) {
      return `${checkedIds.length} forms selected`;
    }
    if (checkedIds.length === 1) {
      const foundChecked = this.lockAvailableForms?.find((x: any) => x.id === checkedIds[0]);
      return foundChecked?.name || 'All Forms in Folder';
    }
    if (this.lockFormId) {
      const found = this.lockAvailableForms?.find((x: any) => x.id === this.lockFormId);
      return found?.name || 'All Forms in Folder';
    }
    return 'All Forms in Folder';
  }

  getLockFieldLabel(): string {
    const checkedIds = Object.keys(this.lockFieldCheckboxes || {}).filter(id => this.lockFieldCheckboxes[id]);
    if (checkedIds.length > 1) {
      return `${checkedIds.length} fields selected`;
    }
    if (checkedIds.length === 1) {
      const foundChecked = this.lockAvailableFields?.find((x: any) => x.id === checkedIds[0]);
      return foundChecked?.title || 'All Fields in Form';
    }
    if (this.lockFieldId) {
      const found = this.lockAvailableFields?.find((x: any) => x.id === this.lockFieldId);
      return found?.title || 'All Fields in Form';
    }
    return 'All Fields in Form';
  }

  private applyFreezeToTarget(): void {
    if (!this.template || !this.template.folders) {
      this.freezeError = 'Template data not available.';
      return;
    }

    const hasCheckedFolders = this.hasAnyFreezeFolderCheckboxChecked();
    const hasCheckedForms = this.hasAnyFreezeFormCheckboxChecked();
    const hasCheckedFields = this.hasAnyFreezeFieldCheckboxChecked();

    if (!hasCheckedFolders && !hasCheckedForms && !hasCheckedFields && !this.freezeFolderId) {
      this.freezeError = 'Please select at least a folder to freeze/unfreeze.';
      return;
    }

    if (hasCheckedFolders) {
      for (const folder of this.template.folders) {
        if (this.freezeFolderCheckboxes[folder.id]) {
          folder.is_frozen = this.isFreezing;
          if (folder.forms) {
            folder.forms.forEach((form: any) => {
              form.is_frozen = this.isFreezing;
              if (form.fields) {
                form.fields.forEach((field: any) => {
                  field.is_frozen = this.isFreezing;
                });
              }
            });
          }
        }
      }
    }

    if (hasCheckedForms) {
      for (const folder of this.template.folders) {
        if (folder.forms) {
          for (const form of folder.forms) {
            if (this.freezeFormCheckboxes[form.id]) {
              form.is_frozen = this.isFreezing;
              if (form.fields) {
                form.fields.forEach((field: any) => {
                  field.is_frozen = this.isFreezing;
                });
              }
            }
          }
        }
      }
    }

    if (hasCheckedFields) {
      for (const folder of this.template.folders) {
        if (folder.forms) {
          for (const form of folder.forms) {
            if (form.fields) {
              for (const field of form.fields) {
                if (this.freezeFieldCheckboxes[field.id]) {
                  field.is_frozen = this.isFreezing;
                }
              }
            }
          }
        }
      }
    }

    if (!hasCheckedFolders && !hasCheckedForms && !hasCheckedFields) {
      const target = this.getFreezeTarget();
      if (target) {
        if (target.type === 'folder' && target.folder) {
          target.folder.is_frozen = this.isFreezing;
        } else if (target.type === 'form' && target.form) {
          target.form.is_frozen = this.isFreezing;
        } else if (target.type === 'field' && target.field) {
          target.field.is_frozen = this.isFreezing;
        }
      }
    }
  }

  private getFreezeSuccessMessage(): string {
    const action = this.isFreezing ? 'freezed' : 'unfreezed';
    const hasCheckedFolders = this.hasAnyFreezeFolderCheckboxChecked();
    const hasCheckedForms = this.hasAnyFreezeFormCheckboxChecked();
    const hasCheckedFields = this.hasAnyFreezeFieldCheckboxChecked();

    // Multi-select cases
    if (hasCheckedFolders || hasCheckedForms || hasCheckedFields) {
      if (hasCheckedFolders && !hasCheckedForms && !hasCheckedFields) {
        return `Folders ${action} successfully.`;
      }
      if (!hasCheckedFolders && hasCheckedForms && !hasCheckedFields) {
        return `Forms ${action} successfully.`;
      }
      if (!hasCheckedFolders && !hasCheckedForms && hasCheckedFields) {
        return `Fields ${action} successfully.`;
      }
      return `Selected items ${action} successfully.`;
    }

    // Single-target (dropdown-based) cases
    const target = this.getFreezeTarget();
    if (!target) {
      return `${action.charAt(0).toUpperCase() + action.slice(1)} successfully.`;
    }

    if (target.type === 'folder') {
      return `Folder ${action} successfully.`;
    }
    if (target.type === 'form') {
      return `Form ${action} successfully.`;
    }
    return `Field ${action} successfully.`;
  }

  private applyLockToTarget(): void {
    if (!this.template || !this.template.folders) {
      this.lockError = 'Template data not available.';
      return;
    }

    const hasCheckedFolders = this.hasAnyLockFolderCheckboxChecked();
    const hasCheckedForms = this.hasAnyLockFormCheckboxChecked();
    const hasCheckedFields = Object.values(this.lockFieldCheckboxes).some(checked => checked === true);

    if (!hasCheckedFolders && !hasCheckedForms && !hasCheckedFields && !this.lockFolderId) {
      this.lockError = 'Please select at least a folder to lock.';
      return;
    }

    if (hasCheckedFolders) {
      for (const folder of this.template.folders) {
        if (this.lockFolderCheckboxes[folder.id]) {
          if (folder.is_locked) {
            this.lockError = `Folder "${folder.name}" is already locked.`;
            return;
          }
          folder.is_locked = true;
          if (folder.forms) {
            folder.forms.forEach((form: any) => {
              if (form.is_locked) {
                this.lockError = `Form "${form.name}" in folder "${folder.name}" is already locked.`;
                return;
              }
              form.is_locked = true;
              if (form.fields) {
                form.fields.forEach((field: any) => {
                  if (field.is_locked) {
                    this.lockError = `Field "${field.title}" in form "${form.name}" is already locked.`;
                    return;
                  }
                  field.is_locked = true;
                });
              }
            });
          }
        }
      }
    }

    if (hasCheckedForms) {
      for (const folder of this.template.folders) {
        if (folder.forms) {
          for (const form of folder.forms) {
            if (this.lockFormCheckboxes[form.id]) {
              if (form.is_locked) {
                this.lockError = `Form "${form.name}" is already locked.`;
                return;
              }
              form.is_locked = true;
              if (form.fields) {
                form.fields.forEach((field: any) => {
                  if (field.is_locked) {
                    this.lockError = `Field "${field.title}" in form "${form.name}" is already locked.`;
                    return;
                  }
                  field.is_locked = true;
                });
              }
            }
          }
        }
      }
    }

    if (hasCheckedFields) {
      for (const folder of this.template.folders) {
        if (folder.forms) {
          for (const form of folder.forms) {
            if (form.fields) {
              for (const field of form.fields) {
                if (this.lockFieldCheckboxes[field.id]) {
                  if (field.is_locked) {
                    this.lockError = `Field "${field.title}" is already locked.`;
                    return;
                  }
                  field.is_locked = true;
                }
              }
            }
          }
        }
      }
    }

    if (!hasCheckedFolders && !hasCheckedForms && !hasCheckedFields) {
      const target = this.getLockTarget();
      if (target) {
        if (target.type === 'folder' && target.folder) {
          if (target.folder.is_locked) {
            this.lockError = 'This folder is already locked.';
            return;
          }
          target.folder.is_locked = true;
        } else if (target.type === 'form' && target.form) {
          if (target.form.is_locked) {
            this.lockError = 'This form is already locked.';
            return;
          }
          target.form.is_locked = true;
        } else if (target.type === 'field' && target.field) {
          if (target.field.is_locked) {
            this.lockError = 'This field is already locked.';
            return;
          }
          target.field.is_locked = true;
        }
      }
    }
  }

  private getLockSuccessMessage(): string {
    const hasCheckedFolders = this.hasAnyLockFolderCheckboxChecked();
    const hasCheckedForms = this.hasAnyLockFormCheckboxChecked();

    // For locking, we don't currently support field-level checkboxes, so just folders/forms.
    if (hasCheckedFolders || hasCheckedForms) {
      if (hasCheckedFolders && !hasCheckedForms) {
        return 'Folders locked successfully.';
      }
      if (!hasCheckedFolders && hasCheckedForms) {
        return 'Forms locked successfully.';
      }
      return 'Selected items locked successfully.';
    }

    const target = this.getLockTarget();
    if (!target) {
      return 'Locked successfully.';
    }

    if (target.type === 'folder') {
      return 'Folder locked successfully.';
    }
    if (target.type === 'form') {
      return 'Form locked successfully.';
    }
    return 'Field locked successfully.';
  }

  private buildTemplateItemFreezePayload(): any {
    const folderIds = Object.keys(this.freezeFolderCheckboxes || {}).filter((id) => this.freezeFolderCheckboxes[id]);
    const formIds = Object.keys(this.freezeFormCheckboxes || {}).filter((id) => this.freezeFormCheckboxes[id]);
    const fieldIds = Object.keys(this.freezeFieldCheckboxes || {}).filter((id) => this.freezeFieldCheckboxes[id]);
    const study_id = this.study_id;
    const subject_id = this.subject_id;

    // If nothing checked, fall back to dropdown selection (single target path)
    if (!folderIds.length && !formIds.length && !fieldIds.length) {
      if (this.freezeFolderId) folderIds.push(this.freezeFolderId);
      if (this.freezeFormId) formIds.push(this.freezeFormId);
      if (this.freezeFieldId) fieldIds.push(this.freezeFieldId);
    }

    return {
      template_id: this.template_id,
      is_frozen: this.isFreezing,
      reason: this.freezeReason,
      folder_ids: folderIds,
      form_ids: formIds,
      field_ids: fieldIds,
      study_id: study_id,
      subject_id: subject_id
    };
  }

  private buildTemplateItemLockPayload(): any {
    const folderIds = Object.keys(this.lockFolderCheckboxes || {}).filter((id) => this.lockFolderCheckboxes[id]);
    const formIds = Object.keys(this.lockFormCheckboxes || {}).filter((id) => this.lockFormCheckboxes[id]);
    const fieldIds = Object.keys(this.lockFieldCheckboxes || {}).filter((id) => this.lockFieldCheckboxes[id]);

    const study_id = this.study_id;
    const subject_id = this.subject_id;
    
    if (!folderIds.length && !formIds.length && !fieldIds.length) {
      if (this.lockFolderId) folderIds.push(this.lockFolderId);
      if (this.lockFormId) formIds.push(this.lockFormId);
      if (this.lockFieldId) fieldIds.push(this.lockFieldId);
    }

    return {
      template_id: this.template_id,
      is_locked: true,
      reason: this.lockReason,
      folder_ids: folderIds,
      form_ids: formIds,
      field_ids: fieldIds,
    };
  }

  authenticateAndApplyFreeze(): void {
    if (!this.freezeFolderId && !this.hasAnyFreezeFolderCheckboxChecked()) {
      this.freezeError = 'Please select at least a folder to freeze/unfreeze.';
      return;
    }
    if (!this.freezeEmail || !this.freezePassword || !this.freezeReason) {
      this.freezeError = 'Please enter email, password, and reason.';
      return;
    }
    this.freezeError = '';

    const purpose = this.isFreezing ? 'freeze_template_item' : 'unfreeze_template_item';
    this.apiService.login(this.freezeEmail, this.freezePassword, purpose).subscribe({
      next: () => {
        const payload = this.buildTemplateItemFreezePayload();
        this.apiService.updateTemplateItemFreezeStatus(payload).subscribe({
          next: () => {
            this.applyFreezeToTarget(); // keep UI in sync immediately
            this.closeFreezeModal();
            alert(this.getFreezeSuccessMessage());
          },
          error: (error) => {
            let errorMessage = 'Failed to update freeze status. Please try again.';
            if (error?.error) {
              if (error.error.message) errorMessage = error.error.message;
              else if (error.error.error) errorMessage = error.error.error;
              else if (typeof error.error === 'string') errorMessage = error.error;
            }
            this.freezeError = errorMessage;
          },
        });
      },
      error: (error) => {
        this.freezeError = 'Invalid email or password. Please try again.';
      },
    });
  }

  authenticateAndApplyLock(): void {
    if (!this.lockFolderId && !this.hasAnyLockFolderCheckboxChecked()) {
      this.lockError = 'Please select at least a folder to lock.';
      return;
    }
    if (!this.lockEmail || !this.lockPassword || !this.lockReason) {
      this.lockError = 'Please enter email, password, and reason.';
      return;
    }
    this.lockError = '';

    const purpose = 'lock_template_item';
    this.apiService.login(this.lockEmail, this.lockPassword, purpose).subscribe({
      next: () => {
        const payload = this.buildTemplateItemLockPayload();
        this.apiService.updateTemplateItemLockStatus(payload).subscribe({
          next: () => {
            this.applyLockToTarget();
            this.closeLockModal();
            alert(this.getLockSuccessMessage());
          },
          error: (error) => {
            let errorMessage = 'Failed to lock item. Please try again.';
            if (error?.error) {
              if (error.error.message) errorMessage = error.error.message;
              else if (error.error.error) errorMessage = error.error.error;
              else if (typeof error.error === 'string') errorMessage = error.error;
            }
            this.lockError = errorMessage;
          },
        });
      },
      error: (error) => {
        this.lockError = 'Invalid email or password. Please try again.';
      },
    });
  }
}
